import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { css, useTheme, jsx } from '@emotion/react';
import { svgBasePath, getColor, getColorValue, ColorContext } from '@paypalcorp/pp-react-utils';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useMemo } from 'react';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
/* Icon base class */


function styles(tokens, colorTokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    console.warn('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysSizeIconXs = tokens.sysSizeIconXs,
      sysSizeIconSm = tokens.sysSizeIconSm,
      sysSizeIconMd = tokens.sysSizeIconMd,
      sysSizeIconLg = tokens.sysSizeIconLg,
      sysSizeIconXl = tokens.sysSizeIconXl,
      sysColorBackgroundMain = tokens.sysColorBackgroundMain,
      sysColorBackgroundAlt = tokens.sysColorBackgroundAlt,
      sysColorBackgroundSurface = tokens.sysColorBackgroundSurface,
      sysColorBackgroundSurfaceHover = tokens.sysColorBackgroundSurfaceHover,
      sysColorBackgroundSurfaceActive = tokens.sysColorBackgroundSurfaceActive,
      sysColorBackgroundHighContrast = tokens.sysColorBackgroundHighContrast,
      sysColorBackgroundMediumContrast = tokens.sysColorBackgroundMediumContrast,
      sysColorPrimaryMain = tokens.sysColorPrimaryMain,
      sysColorPrimaryMainHover = tokens.sysColorPrimaryMainHover,
      sysColorPrimaryMainActive = tokens.sysColorPrimaryMainActive,
      sysColorPrimaryContrast = tokens.sysColorPrimaryContrast,
      sysColorPrimaryContrastHover = tokens.sysColorPrimaryContrastHover,
      sysColorPrimaryContrastActive = tokens.sysColorPrimaryContrastActive,
      sysColorSecondaryMain = tokens.sysColorSecondaryMain,
      sysColorSecondaryMainHover = tokens.sysColorSecondaryMainHover,
      sysColorSecondaryMainActive = tokens.sysColorSecondaryMainActive,
      sysColorSecondaryContrast = tokens.sysColorSecondaryContrast,
      sysColorTertiaryMain = tokens.sysColorTertiaryMain,
      sysColorTertiaryMainHover = tokens.sysColorTertiaryMainHover,
      sysColorTertiaryMainActive = tokens.sysColorTertiaryMainActive,
      sysColorTertiaryContrast = tokens.sysColorTertiaryContrast,
      sysColorFeaturedMain = tokens.sysColorFeaturedMain,
      sysColorFeaturedMainHover = tokens.sysColorFeaturedMainHover,
      sysColorFeaturedMainActive = tokens.sysColorFeaturedMainActive,
      sysColorFeaturedContrast = tokens.sysColorFeaturedContrast,
      sysColorUnselectedMain = tokens.sysColorUnselectedMain,
      sysColorUnselectedMainHover = tokens.sysColorUnselectedMainHover,
      sysColorUnselectedMainActive = tokens.sysColorUnselectedMainActive,
      sysColorUnselectedContrast = tokens.sysColorUnselectedContrast,
      sysColorSelectedMain = tokens.sysColorSelectedMain,
      sysColorSelectedMainHover = tokens.sysColorSelectedMainHover,
      sysColorSelectedMainActive = tokens.sysColorSelectedMainActive,
      sysColorSelectedContrast = tokens.sysColorSelectedContrast,
      sysColorSelectedRangeMain = tokens.sysColorSelectedRangeMain,
      sysColorSelectedRangeMainHover = tokens.sysColorSelectedRangeMainHover,
      sysColorSelectedRangeMainActive = tokens.sysColorSelectedRangeMainActive,
      sysColorSelectedRangeContrast = tokens.sysColorSelectedRangeContrast,
      sysColorLinkMain = tokens.sysColorLinkMain,
      sysColorLinkMainHover = tokens.sysColorLinkMainHover,
      sysColorLinkMainActive = tokens.sysColorLinkMainActive,
      sysColorLinkAlt = tokens.sysColorLinkAlt,
      sysColorLinkAltHover = tokens.sysColorLinkAltHover,
      sysColorLinkAltActive = tokens.sysColorLinkAltActive,
      sysColorLinkContrast = tokens.sysColorLinkContrast,
      sysColorLinkContrastHover = tokens.sysColorLinkContrastHover,
      sysColorLinkContrastActive = tokens.sysColorLinkContrastActive,
      sysColorAccent1Main = tokens.sysColorAccent1Main,
      sysColorAccent1Contrast = tokens.sysColorAccent1Contrast,
      sysColorAccent2Main = tokens.sysColorAccent2Main,
      sysColorAccent2Contrast = tokens.sysColorAccent2Contrast,
      sysColorAccent3Main = tokens.sysColorAccent3Main,
      sysColorAccent3Contrast = tokens.sysColorAccent3Contrast,
      sysColorAccent4Main = tokens.sysColorAccent4Main,
      sysColorAccent4Contrast = tokens.sysColorAccent4Contrast,
      sysColorErrorMain = tokens.sysColorErrorMain,
      sysColorErrorMainHover = tokens.sysColorErrorMainHover,
      sysColorErrorMainActive = tokens.sysColorErrorMainActive,
      sysColorErrorContrast = tokens.sysColorErrorContrast,
      sysColorWarningMain = tokens.sysColorWarningMain,
      sysColorWarningMainHover = tokens.sysColorWarningMainHover,
      sysColorWarningMainActive = tokens.sysColorWarningMainActive,
      sysColorWarningAlt = tokens.sysColorWarningAlt,
      sysColorWarningContrast = tokens.sysColorWarningContrast,
      sysColorSuccessMain = tokens.sysColorSuccessMain,
      sysColorSuccessMainHover = tokens.sysColorSuccessMainHover,
      sysColorSuccessMainActive = tokens.sysColorSuccessMainActive,
      sysColorSuccessContrast = tokens.sysColorSuccessContrast,
      sysColorSystemMain = tokens.sysColorSystemMain,
      sysColorSystemMainHover = tokens.sysColorSystemMainHover,
      sysColorSystemMainActive = tokens.sysColorSystemMainActive,
      sysColorSystemContrast = tokens.sysColorSystemContrast,
      sysColorInfoMain = tokens.sysColorInfoMain,
      sysColorInfoMainHover = tokens.sysColorInfoMainHover,
      sysColorInfoMainActive = tokens.sysColorInfoMainActive,
      sysColorInfoContrast = tokens.sysColorInfoContrast,
      sysColorSpecialtyMain = tokens.sysColorSpecialtyMain,
      sysColorSpecialtyMainHover = tokens.sysColorSpecialtyMainHover,
      sysColorSpecialtyMainActive = tokens.sysColorSpecialtyMainActive,
      sysColorSpecialtyContrast = tokens.sysColorSpecialtyContrast;
  var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: icon_base;\n    speak: none;\n    aspect-ratio: 1;\n  "])));
  var backgroundBase = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    label: icon_background_base;\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeIconLg, sysSizeIconLg);
  var sizeXs = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    label: size_xs;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeIconXs, sysSizeIconXs);
  var sizeSm = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    label: size_sm;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeIconSm, sysSizeIconSm);
  var sizeMd = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    label: size_md;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeIconMd, sysSizeIconMd);
  var sizeLg = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    label: size_lg;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeIconLg, sysSizeIconLg);
  var sizeXl = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    label: size_xl;\n    width: ", ";\n    height: ", ";\n  "])), sysSizeIconXl, sysSizeIconXl);
  var sizes = {
    xs: sysSizeIconXs,
    sm: sysSizeIconSm,
    md: sysSizeIconMd,
    lg: sysSizeIconLg,
    xl: sysSizeIconXl
  };

  var getIconSizeCss = function getIconSizeCss(sizeName) {
    var _sizes$sizeName;

    var size = (_sizes$sizeName = sizes[sizeName]) !== null && _sizes$sizeName !== void 0 ? _sizes$sizeName : sizes.xl;
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      label: size_ ", ";\n      width: ", ";\n      height: ", ";\n    "])), sizeName, size, size);
  };

  var legalColors = {
    sysColorBackgroundMain: sysColorBackgroundMain,
    sysColorBackgroundAlt: sysColorBackgroundAlt,
    sysColorBackgroundSurface: sysColorBackgroundSurface,
    sysColorBackgroundSurfaceHover: sysColorBackgroundSurfaceHover,
    sysColorBackgroundSurfaceActive: sysColorBackgroundSurfaceActive,
    sysColorBackgroundHighContrast: sysColorBackgroundHighContrast,
    sysColorBackgroundMediumContrast: sysColorBackgroundMediumContrast,
    sysColorPrimaryMain: sysColorPrimaryMain,
    sysColorPrimaryMainHover: sysColorPrimaryMainHover,
    sysColorPrimaryMainActive: sysColorPrimaryMainActive,
    sysColorPrimaryContrast: sysColorPrimaryContrast,
    sysColorPrimaryContrastHover: sysColorPrimaryContrastHover,
    sysColorPrimaryContrastActive: sysColorPrimaryContrastActive,
    sysColorSecondaryMain: sysColorSecondaryMain,
    sysColorSecondaryMainHover: sysColorSecondaryMainHover,
    sysColorSecondaryMainActive: sysColorSecondaryMainActive,
    sysColorSecondaryContrast: sysColorSecondaryContrast,
    sysColorTertiaryMain: sysColorTertiaryMain,
    sysColorTertiaryMainHover: sysColorTertiaryMainHover,
    sysColorTertiaryMainActive: sysColorTertiaryMainActive,
    sysColorTertiaryContrast: sysColorTertiaryContrast,
    sysColorFeaturedMain: sysColorFeaturedMain,
    sysColorFeaturedMainHover: sysColorFeaturedMainHover,
    sysColorFeaturedMainActive: sysColorFeaturedMainActive,
    sysColorFeaturedContrast: sysColorFeaturedContrast,
    sysColorUnselectedMain: sysColorUnselectedMain,
    sysColorUnselectedMainHover: sysColorUnselectedMainHover,
    sysColorUnselectedMainActive: sysColorUnselectedMainActive,
    sysColorUnselectedContrast: sysColorUnselectedContrast,
    sysColorSelectedMain: sysColorSelectedMain,
    sysColorSelectedMainHover: sysColorSelectedMainHover,
    sysColorSelectedMainActive: sysColorSelectedMainActive,
    sysColorSelectedContrast: sysColorSelectedContrast,
    sysColorSelectedRangeMain: sysColorSelectedRangeMain,
    sysColorSelectedRangeMainHover: sysColorSelectedRangeMainHover,
    sysColorSelectedRangeMainActive: sysColorSelectedRangeMainActive,
    sysColorSelectedRangeContrast: sysColorSelectedRangeContrast,
    sysColorLinkMain: sysColorLinkMain,
    sysColorLinkMainHover: sysColorLinkMainHover,
    sysColorLinkMainActive: sysColorLinkMainActive,
    sysColorLinkAlt: sysColorLinkAlt,
    sysColorLinkAltHover: sysColorLinkAltHover,
    sysColorLinkAltActive: sysColorLinkAltActive,
    sysColorLinkContrast: sysColorLinkContrast,
    sysColorLinkContrastHover: sysColorLinkContrastHover,
    sysColorLinkContrastActive: sysColorLinkContrastActive,
    sysColorAccent1Main: sysColorAccent1Main,
    sysColorAccent1Contrast: sysColorAccent1Contrast,
    sysColorAccent2Main: sysColorAccent2Main,
    sysColorAccent2Contrast: sysColorAccent2Contrast,
    sysColorAccent3Main: sysColorAccent3Main,
    sysColorAccent3Contrast: sysColorAccent3Contrast,
    sysColorAccent4Main: sysColorAccent4Main,
    sysColorAccent4Contrast: sysColorAccent4Contrast,
    sysColorErrorMain: sysColorErrorMain,
    sysColorErrorMainHover: sysColorErrorMainHover,
    sysColorErrorMainActive: sysColorErrorMainActive,
    sysColorErrorContrast: sysColorErrorContrast,
    sysColorWarningMain: sysColorWarningMain,
    sysColorWarningMainHover: sysColorWarningMainHover,
    sysColorWarningMainActive: sysColorWarningMainActive,
    sysColorWarningAlt: sysColorWarningAlt,
    sysColorWarningContrast: sysColorWarningContrast,
    sysColorSuccessMain: sysColorSuccessMain,
    sysColorSuccessMainHover: sysColorSuccessMainHover,
    sysColorSuccessMainActive: sysColorSuccessMainActive,
    sysColorSuccessContrast: sysColorSuccessContrast,
    sysColorSystemMain: sysColorSystemMain,
    sysColorSystemMainHover: sysColorSystemMainHover,
    sysColorSystemMainActive: sysColorSystemMainActive,
    sysColorSystemContrast: sysColorSystemContrast,
    sysColorInfoMain: sysColorInfoMain,
    sysColorInfoMainHover: sysColorInfoMainHover,
    sysColorInfoMainActive: sysColorInfoMainActive,
    sysColorInfoContrast: sysColorInfoContrast,
    sysColorSpecialtyMain: sysColorSpecialtyMain,
    sysColorSpecialtyMainHover: sysColorSpecialtyMainHover,
    sysColorSpecialtyMainActive: sysColorSpecialtyMainActive,
    sysColorSpecialtyContrast: sysColorSpecialtyContrast
  };
  var ICON_FALLBACK_COLOR = legalColors.sysColorBackgroundHighContrast;

  var getMaskImageCss = function getMaskImageCss(colorName, iconName, cdnHost) {
    var iconURL = "".concat(svgBasePath(cdnHost), "/").concat(iconName, ".svg");
    var iconColor = getColor(colorName, legalColors, ICON_FALLBACK_COLOR);
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      label: ", ";\n      mask: url(", ") center no-repeat;\n      background-color: ", "; // Note: we set the BACKGROUND color here...\n    "])), "mask-".concat(colorName), iconURL, getColorValue(colorTokens, iconColor, 'contrast'));
  };

  var getColorCss = function getColorCss(colorName) {
    return colorName ? css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n          label: ", ";\n          color: ", ";\n        "])), "".concat(colorName), getColorValue(colorTokens, getColor(colorName, legalColors, ICON_FALLBACK_COLOR), 'contrast')) : null;
  };

  var svg = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    label: svg;\n    speak: none;\n    display: inline-block;\n    aspect-ratio: 1;\n    img,\n    svg {\n      width: 100%;\n      height: 100%;\n      display: block;\n    }\n  "])));
  return {
    base: base,
    backgroundBase: backgroundBase,
    sizeXs: sizeXs,
    sizeSm: sizeSm,
    sizeMd: sizeMd,
    sizeLg: sizeLg,
    sizeXl: sizeXl,
    svg: svg,
    legalColors: legalColors,
    getIconSizeCss: getIconSizeCss,
    getMaskImageCss: getMaskImageCss,
    getColorCss: getColorCss
  };
}

var _excluded = ["as", "size", "color", "className", "children"];

var IconContainer = function IconContainer(_ref) {
  var _iconStyles$getColorC;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      color = _ref.color,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();
  var colorTokens = React.useContext(ColorContext);
  var iconStyles = useMemo(function () {
    return styles(tokens, colorTokens);
  }, [tokens, colorTokens]);
  var cssVal = [iconStyles.svg, size === 'xs' && iconStyles.sizeXs, size === 'sm' && iconStyles.sizeSm, size === 'md' && iconStyles.sizeMd, size === 'lg' && iconStyles.sizeLg, size === 'xl' && iconStyles.sizeXl, (_iconStyles$getColorC = iconStyles.getColorCss) === null || _iconStyles$getColorC === void 0 ? void 0 : _iconStyles$getColorC.call(iconStyles, color)];
  return jsx(as, _extends({
    css: cssVal,
    className: className,
    "data-ppui-info": "icons_8.18.0"
  }, rest), children);
};

var _excluded$1 = ["svgElementRef"],
    _excluded2 = ["svgElementRef"],
    _excluded3 = ["svgElementRef"],
    _excluded4 = ["svgElementRef"],
    _excluded5 = ["svgElementRef"],
    _excluded6 = ["svgElementRef"],
    _excluded7 = ["svgElementRef"],
    _excluded8 = ["svgElementRef"],
    _excluded9 = ["svgElementRef"],
    _excluded10 = ["svgElementRef"],
    _excluded11 = ["svgElementRef"],
    _excluded12 = ["svgElementRef"],
    _excluded13 = ["svgElementRef"],
    _excluded14 = ["svgElementRef"],
    _excluded15 = ["svgElementRef"],
    _excluded16 = ["svgElementRef"],
    _excluded17 = ["svgElementRef"],
    _excluded18 = ["svgElementRef"],
    _excluded19 = ["svgElementRef"],
    _excluded20 = ["svgElementRef"],
    _excluded21 = ["svgElementRef"],
    _excluded22 = ["svgElementRef"],
    _excluded23 = ["svgElementRef"],
    _excluded24 = ["svgElementRef"],
    _excluded25 = ["svgElementRef"],
    _excluded26 = ["svgElementRef"],
    _excluded27 = ["svgElementRef"],
    _excluded28 = ["svgElementRef"],
    _excluded29 = ["svgElementRef"],
    _excluded30 = ["svgElementRef"],
    _excluded31 = ["svgElementRef"],
    _excluded32 = ["svgElementRef"],
    _excluded33 = ["svgElementRef"],
    _excluded34 = ["svgElementRef"],
    _excluded35 = ["svgElementRef"],
    _excluded36 = ["svgElementRef"],
    _excluded37 = ["svgElementRef"],
    _excluded38 = ["svgElementRef"],
    _excluded39 = ["svgElementRef"],
    _excluded40 = ["svgElementRef"],
    _excluded41 = ["svgElementRef"],
    _excluded42 = ["svgElementRef"],
    _excluded43 = ["svgElementRef"],
    _excluded44 = ["svgElementRef"],
    _excluded45 = ["svgElementRef"],
    _excluded46 = ["svgElementRef"],
    _excluded47 = ["svgElementRef"],
    _excluded48 = ["svgElementRef"],
    _excluded49 = ["svgElementRef"],
    _excluded50 = ["svgElementRef"],
    _excluded51 = ["svgElementRef"],
    _excluded52 = ["svgElementRef"],
    _excluded53 = ["svgElementRef"],
    _excluded54 = ["svgElementRef"],
    _excluded55 = ["svgElementRef"],
    _excluded56 = ["svgElementRef"],
    _excluded57 = ["svgElementRef"],
    _excluded58 = ["svgElementRef"],
    _excluded59 = ["svgElementRef"],
    _excluded60 = ["svgElementRef"],
    _excluded61 = ["svgElementRef"],
    _excluded62 = ["svgElementRef"],
    _excluded63 = ["svgElementRef"],
    _excluded64 = ["svgElementRef"],
    _excluded65 = ["svgElementRef"],
    _excluded66 = ["svgElementRef"],
    _excluded67 = ["svgElementRef"],
    _excluded68 = ["svgElementRef"],
    _excluded69 = ["svgElementRef"],
    _excluded70 = ["svgElementRef"],
    _excluded71 = ["svgElementRef"],
    _excluded72 = ["svgElementRef"],
    _excluded73 = ["svgElementRef"],
    _excluded74 = ["svgElementRef"],
    _excluded75 = ["svgElementRef"],
    _excluded76 = ["svgElementRef"],
    _excluded77 = ["svgElementRef"],
    _excluded78 = ["svgElementRef"],
    _excluded79 = ["svgElementRef"],
    _excluded80 = ["svgElementRef"],
    _excluded81 = ["svgElementRef"],
    _excluded82 = ["svgElementRef"],
    _excluded83 = ["svgElementRef"],
    _excluded84 = ["svgElementRef"],
    _excluded85 = ["svgElementRef"],
    _excluded86 = ["svgElementRef"],
    _excluded87 = ["svgElementRef"],
    _excluded88 = ["svgElementRef"],
    _excluded89 = ["svgElementRef"],
    _excluded90 = ["svgElementRef"],
    _excluded91 = ["svgElementRef"],
    _excluded92 = ["svgElementRef"],
    _excluded93 = ["svgElementRef"],
    _excluded94 = ["svgElementRef"],
    _excluded95 = ["svgElementRef"],
    _excluded96 = ["svgElementRef"],
    _excluded97 = ["svgElementRef"],
    _excluded98 = ["svgElementRef"],
    _excluded99 = ["svgElementRef"],
    _excluded100 = ["svgElementRef"],
    _excluded101 = ["svgElementRef"],
    _excluded102 = ["svgElementRef"],
    _excluded103 = ["svgElementRef"],
    _excluded104 = ["svgElementRef"],
    _excluded105 = ["svgElementRef"],
    _excluded106 = ["svgElementRef"],
    _excluded107 = ["svgElementRef"],
    _excluded108 = ["svgElementRef"],
    _excluded109 = ["svgElementRef"],
    _excluded110 = ["svgElementRef"],
    _excluded111 = ["svgElementRef"],
    _excluded112 = ["svgElementRef"],
    _excluded113 = ["svgElementRef"],
    _excluded114 = ["svgElementRef"],
    _excluded115 = ["svgElementRef"],
    _excluded116 = ["svgElementRef"],
    _excluded117 = ["svgElementRef"],
    _excluded118 = ["svgElementRef"],
    _excluded119 = ["svgElementRef"],
    _excluded120 = ["svgElementRef"],
    _excluded121 = ["svgElementRef"],
    _excluded122 = ["svgElementRef"],
    _excluded123 = ["svgElementRef"],
    _excluded124 = ["svgElementRef"],
    _excluded125 = ["svgElementRef"],
    _excluded126 = ["svgElementRef"],
    _excluded127 = ["svgElementRef"],
    _excluded128 = ["svgElementRef"],
    _excluded129 = ["svgElementRef"],
    _excluded130 = ["svgElementRef"],
    _excluded131 = ["svgElementRef"],
    _excluded132 = ["svgElementRef"],
    _excluded133 = ["svgElementRef"],
    _excluded134 = ["svgElementRef"],
    _excluded135 = ["svgElementRef"],
    _excluded136 = ["svgElementRef"],
    _excluded137 = ["svgElementRef"],
    _excluded138 = ["svgElementRef"],
    _excluded139 = ["svgElementRef"],
    _excluded140 = ["svgElementRef"],
    _excluded141 = ["svgElementRef"],
    _excluded142 = ["svgElementRef"],
    _excluded143 = ["svgElementRef"],
    _excluded144 = ["svgElementRef"],
    _excluded145 = ["svgElementRef"],
    _excluded146 = ["svgElementRef"],
    _excluded147 = ["svgElementRef"],
    _excluded148 = ["svgElementRef"],
    _excluded149 = ["svgElementRef"],
    _excluded150 = ["svgElementRef"],
    _excluded151 = ["svgElementRef"],
    _excluded152 = ["svgElementRef"],
    _excluded153 = ["svgElementRef"],
    _excluded154 = ["svgElementRef"],
    _excluded155 = ["svgElementRef"],
    _excluded156 = ["svgElementRef"],
    _excluded157 = ["svgElementRef"],
    _excluded158 = ["svgElementRef"],
    _excluded159 = ["svgElementRef"],
    _excluded160 = ["svgElementRef"],
    _excluded161 = ["svgElementRef"],
    _excluded162 = ["svgElementRef"],
    _excluded163 = ["svgElementRef"],
    _excluded164 = ["svgElementRef"],
    _excluded165 = ["svgElementRef"],
    _excluded166 = ["svgElementRef"],
    _excluded167 = ["svgElementRef"],
    _excluded168 = ["svgElementRef"],
    _excluded169 = ["svgElementRef"],
    _excluded170 = ["svgElementRef"],
    _excluded171 = ["svgElementRef"],
    _excluded172 = ["svgElementRef"],
    _excluded173 = ["svgElementRef"],
    _excluded174 = ["svgElementRef"],
    _excluded175 = ["svgElementRef"],
    _excluded176 = ["svgElementRef"],
    _excluded177 = ["svgElementRef"],
    _excluded178 = ["svgElementRef"],
    _excluded179 = ["svgElementRef"],
    _excluded180 = ["svgElementRef"],
    _excluded181 = ["svgElementRef"],
    _excluded182 = ["svgElementRef"],
    _excluded183 = ["svgElementRef"],
    _excluded184 = ["svgElementRef"],
    _excluded185 = ["svgElementRef"],
    _excluded186 = ["svgElementRef"],
    _excluded187 = ["svgElementRef"],
    _excluded188 = ["svgElementRef"],
    _excluded189 = ["svgElementRef"],
    _excluded190 = ["svgElementRef"],
    _excluded191 = ["svgElementRef"],
    _excluded192 = ["svgElementRef"],
    _excluded193 = ["svgElementRef"],
    _excluded194 = ["svgElementRef"],
    _excluded195 = ["svgElementRef"],
    _excluded196 = ["svgElementRef"],
    _excluded197 = ["svgElementRef"],
    _excluded198 = ["svgElementRef"],
    _excluded199 = ["svgElementRef"],
    _excluded200 = ["svgElementRef"],
    _excluded201 = ["svgElementRef"],
    _excluded202 = ["svgElementRef"],
    _excluded203 = ["svgElementRef"],
    _excluded204 = ["svgElementRef"],
    _excluded205 = ["svgElementRef"],
    _excluded206 = ["svgElementRef"],
    _excluded207 = ["svgElementRef"],
    _excluded208 = ["svgElementRef"],
    _excluded209 = ["svgElementRef"],
    _excluded210 = ["svgElementRef"],
    _excluded211 = ["svgElementRef"],
    _excluded212 = ["svgElementRef"],
    _excluded213 = ["svgElementRef"],
    _excluded214 = ["svgElementRef"],
    _excluded215 = ["svgElementRef"],
    _excluded216 = ["svgElementRef"],
    _excluded217 = ["svgElementRef"],
    _excluded218 = ["svgElementRef"],
    _excluded219 = ["svgElementRef"],
    _excluded220 = ["svgElementRef"],
    _excluded221 = ["svgElementRef"],
    _excluded222 = ["svgElementRef"],
    _excluded223 = ["svgElementRef"],
    _excluded224 = ["svgElementRef"],
    _excluded225 = ["svgElementRef"],
    _excluded226 = ["svgElementRef"],
    _excluded227 = ["svgElementRef"],
    _excluded228 = ["svgElementRef"],
    _excluded229 = ["svgElementRef"],
    _excluded230 = ["svgElementRef"],
    _excluded231 = ["svgElementRef"],
    _excluded232 = ["svgElementRef"],
    _excluded233 = ["svgElementRef"],
    _excluded234 = ["svgElementRef"],
    _excluded235 = ["svgElementRef"],
    _excluded236 = ["svgElementRef"],
    _excluded237 = ["svgElementRef"],
    _excluded238 = ["svgElementRef"],
    _excluded239 = ["svgElementRef"],
    _excluded240 = ["svgElementRef"],
    _excluded241 = ["svgElementRef"],
    _excluded242 = ["svgElementRef"],
    _excluded243 = ["svgElementRef"],
    _excluded244 = ["svgElementRef"],
    _excluded245 = ["svgElementRef"],
    _excluded246 = ["svgElementRef"],
    _excluded247 = ["svgElementRef"],
    _excluded248 = ["svgElementRef"],
    _excluded249 = ["svgElementRef"],
    _excluded250 = ["svgElementRef"],
    _excluded251 = ["svgElementRef"],
    _excluded252 = ["svgElementRef"],
    _excluded253 = ["svgElementRef"],
    _excluded254 = ["svgElementRef"],
    _excluded255 = ["svgElementRef"],
    _excluded256 = ["svgElementRef"],
    _excluded257 = ["svgElementRef"],
    _excluded258 = ["svgElementRef"],
    _excluded259 = ["svgElementRef"],
    _excluded260 = ["svgElementRef"],
    _excluded261 = ["svgElementRef"],
    _excluded262 = ["svgElementRef"],
    _excluded263 = ["svgElementRef"],
    _excluded264 = ["svgElementRef"],
    _excluded265 = ["svgElementRef"],
    _excluded266 = ["svgElementRef"],
    _excluded267 = ["svgElementRef"],
    _excluded268 = ["svgElementRef"],
    _excluded269 = ["svgElementRef"],
    _excluded270 = ["svgElementRef"],
    _excluded271 = ["svgElementRef"],
    _excluded272 = ["svgElementRef"],
    _excluded273 = ["svgElementRef"],
    _excluded274 = ["svgElementRef"],
    _excluded275 = ["svgElementRef"],
    _excluded276 = ["svgElementRef"],
    _excluded277 = ["svgElementRef"],
    _excluded278 = ["svgElementRef"],
    _excluded279 = ["svgElementRef"],
    _excluded280 = ["svgElementRef"],
    _excluded281 = ["svgElementRef"],
    _excluded282 = ["svgElementRef"],
    _excluded283 = ["svgElementRef"],
    _excluded284 = ["svgElementRef"],
    _excluded285 = ["svgElementRef"],
    _excluded286 = ["svgElementRef"],
    _excluded287 = ["svgElementRef"],
    _excluded288 = ["svgElementRef"],
    _excluded289 = ["svgElementRef"],
    _excluded290 = ["svgElementRef"],
    _excluded291 = ["svgElementRef"],
    _excluded292 = ["svgElementRef"],
    _excluded293 = ["svgElementRef"],
    _excluded294 = ["svgElementRef"],
    _excluded295 = ["svgElementRef"],
    _excluded296 = ["svgElementRef"],
    _excluded297 = ["svgElementRef"],
    _excluded298 = ["svgElementRef"],
    _excluded299 = ["svgElementRef"],
    _excluded300 = ["svgElementRef"],
    _excluded301 = ["svgElementRef"],
    _excluded302 = ["svgElementRef"],
    _excluded303 = ["svgElementRef"],
    _excluded304 = ["svgElementRef"],
    _excluded305 = ["svgElementRef"],
    _excluded306 = ["svgElementRef"],
    _excluded307 = ["svgElementRef"],
    _excluded308 = ["svgElementRef"],
    _excluded309 = ["svgElementRef"],
    _excluded310 = ["svgElementRef"],
    _excluded311 = ["svgElementRef"],
    _excluded312 = ["svgElementRef"],
    _excluded313 = ["svgElementRef"],
    _excluded314 = ["svgElementRef"],
    _excluded315 = ["svgElementRef"],
    _excluded316 = ["svgElementRef"],
    _excluded317 = ["svgElementRef"],
    _excluded318 = ["svgElementRef"],
    _excluded319 = ["svgElementRef"],
    _excluded320 = ["svgElementRef"],
    _excluded321 = ["svgElementRef"],
    _excluded322 = ["svgElementRef"],
    _excluded323 = ["svgElementRef"],
    _excluded324 = ["svgElementRef"],
    _excluded325 = ["svgElementRef"],
    _excluded326 = ["svgElementRef"],
    _excluded327 = ["svgElementRef"],
    _excluded328 = ["svgElementRef"],
    _excluded329 = ["svgElementRef"],
    _excluded330 = ["svgElementRef"],
    _excluded331 = ["svgElementRef"],
    _excluded332 = ["svgElementRef"],
    _excluded333 = ["svgElementRef"],
    _excluded334 = ["svgElementRef"];

var AcornsIcon = function AcornsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded$1);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.575 11.024H4.426c-1.335-.104-1.291-6.117 6.459-6.676.072-.032.088-.04.132-.184a3.26 3.26 0 0 0 .12-.756 2.094 2.094 0 0 0-.12-.8A1.977 1.977 0 0 0 10.661 2c.24 0 .48.048.704.14.292.116.592.32.86.588.264.268.496.568.684.892a5.492 5.492 0 0 1 .388.792c7.566.655 7.602 6.508 6.278 6.612zm-.36 1.003s1.2 7.633-6.139 9.041c-.331.284-.883.936-1.087.932-.2.004-.756-.648-1.088-.932-7.375-1.264-6.135-9.04-6.135-9.04h14.45z",
    "data-ppui": "true"
  })), props.children);
};

var ActivityIcon = function ActivityIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5zm6.002 3a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75zM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3.002 3a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75zM7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3.002 3a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75zM7 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AddCameraIcon = function AddCameraIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded3);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.748 18.867a.75.75 0 0 1-.75-.75v-1.625h-1.625a.75.75 0 1 1 0-1.5h1.625v-1.625a.75.75 0 1 1 1.5 0v1.625h1.625a.75.75 0 1 1 0 1.5h-1.625v1.625a.75.75 0 0 1-.75.75zM9.5 11.996a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6.996v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h9a1 1 0 0 1 1 1v7.75a6.25 6.25 0 0 1-12.084 2.25H3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h1zm1.5 0v-1.5h5v1.5h-5zm15 8.75a4.75 4.75 0 0 1-4.734 4.75h-.017a4.75 4.75 0 1 1 0-9.5 4.75 4.75 0 0 1 4.75 4.75zm-1.25-5.25h-.107a6.213 6.213 0 0 0-2.133-.874.75.75 0 0 1 .74-.626h1.5a.75.75 0 0 1 0 1.5zM8 8.996a3 3 0 0 1 2.985 2.703 6.228 6.228 0 0 0-1.366 2.823A3 3 0 1 1 8 8.996z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AddCashIcon = function AddCashIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded4);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.623 15.746a.75.75 0 0 1 .75-.75h1.625v-1.625a.75.75 0 0 1 1.5 0v1.625h1.625a.75.75 0 0 1 0 1.5h-1.625v1.625a.75.75 0 0 1-1.5 0v-1.625h-1.625a.75.75 0 0 1-.75-.75z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.998 14a1 1 0 0 0 1 1h6.545a6.25 6.25 0 1 0 12.455.87H22v-2.25h-.002V6a1 1 0 0 0-1-1h-18a1 1 0 0 0-1 1v8zm9 1.75a4.724 4.724 0 0 1 .879-2.752A4.75 4.75 0 1 1 15.75 20.5 4.75 4.75 0 0 1 11 15.75zm-.609-3.217a6.252 6.252 0 0 1 4.575-2.985 3 3 0 1 0-4.575 2.985z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AddUserIcon = function AddUserIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded5);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.749 18.87a.75.75 0 0 1-.75-.75v-1.625h-1.625a.75.75 0 0 1 0-1.5h1.625V13.37a.75.75 0 0 1 1.5 0v1.625h1.625a.75.75 0 0 1 0 1.5h-1.625v1.625a.75.75 0 0 1-.75.75z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.344 9.51a4.5 4.5 0 1 0-5.68.834A8.004 8.004 0 0 0 4.002 18v3a1 1 0 0 0 1 1h10.749a6.25 6.25 0 1 0-.407-12.488zm5.157 6.239a4.794 4.794 0 0 0-.087-.912 4.753 4.753 0 0 0-4.274-3.823 4.75 4.75 0 1 0 4.36 4.734z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AddVideoIcon = function AddVideoIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded6);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.623 15.742a.75.75 0 0 1 .75-.75h1.625v-1.625a.75.75 0 0 1 1.5 0v1.625h1.625a.75.75 0 0 1 0 1.5h-1.625v1.625a.75.75 0 0 1-1.5 0v-1.625h-1.625a.75.75 0 0 1-.75-.75z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3.996a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6.504A6.25 6.25 0 1 0 20 11.162V4.996a1 1 0 0 0-1-1H3zM14.182 20.23a4.753 4.753 0 0 1-1.165-8.37l-.011.006c.15-.106.306-.204.468-.292l-.012.007a4.75 4.75 0 1 1 1.248 8.8l-.528-.151zm-4.4-6.349a6.257 6.257 0 0 1 5.222-4.343.99.99 0 0 0-.36-.391L9.53 5.952A1 1 0 0 0 8 6.8v6.391a1 1 0 0 0 1.53.848l.252-.157z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AddIcon = function AddIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded7);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V5z",
    "data-ppui": "true"
  })), props.children);
};

var AlarmClockIcon = function AlarmClockIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded8);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.487 2.784c-.446.325-.386.969.037 1.324l1.03.863-.907.907A7.966 7.966 0 0 0 12 5a7.966 7.966 0 0 0-3.647.878l-.907-.907 1.03-.863c.423-.355.483-1 .037-1.324A4.102 4.102 0 0 0 2.415 7.9c.243.496.887.549 1.31.194l1.03-.864.899.899a8 8 0 1 0 12.693 0l.898-.9 1.03.865c.423.355 1.067.302 1.31-.194a4.102 4.102 0 0 0-6.098-5.116zM12 7.01a.75.75 0 0 0-.75.75v4.688l-3.352 1.916a.75.75 0 0 0 .745 1.302l3.73-2.132a.75.75 0 0 0 .377-.651V7.76a.75.75 0 0 0-.75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AnimalsIcon = function AnimalsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded9);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 3a4 4 0 0 0-4 4v4H5c-.552 0-1.007.45-.939.998a8.009 8.009 0 0 0 5.189 6.517V20.5h-1.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-1.5v-1.985A8.003 8.003 0 0 0 20 11V9h1a1 1 0 1 0 0-2h-1a4 4 0 0 0-4-4zm-2.75 17.5v-1.597a8.06 8.06 0 0 1-2.5 0V20.5h2.5zM17.5 7A1.25 1.25 0 1 1 15 7a1.25 1.25 0 0 1 2.5 0zm-7.75 6.5a.75.75 0 0 0-1.5 0 3.75 3.75 0 1 0 7.5 0 .75.75 0 0 0-1.5 0 2.25 2.25 0 1 1-4.5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AppMenuIcon = function AppMenuIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded10);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm7-14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm5-12a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    "data-ppui": "true"
  })), props.children);
};

var AppliancesIcon = function AppliancesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded11);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 18h8v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1zM3.5 5.5v11h11v-11h-11zM18.248 16a1.751 1.751 0 1 0 0-3.502 1.751 1.751 0 0 0 0 3.502zm-2.25-8.75a.75.75 0 0 1 .75-.75h3.002a.75.75 0 0 1 0 1.5h-3.003a.75.75 0 0 1-.75-.75zm.75 2.25a.75.75 0 0 0 0 1.5h3.002a.75.75 0 0 0 0-1.5h-3.003z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ArrowDownSmIcon = function ArrowDownSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded12);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5a1 1 0 0 0-2 0v6.755L4.669 8.257a1 1 0 0 0-1.338 1.486l5 4.5a1 1 0 0 0 1.338 0l5-4.5a1 1 0 0 0-1.338-1.486L10 11.255V4.5z",
    "data-ppui": "true"
  })), props.children);
};

var ArrowDownIcon = function ArrowDownIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded13);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.707 14.29a1 1 0 0 0-1.414 0L13 18.583V2.997a1 1 0 1 0-2 0v15.586L6.707 14.29a1 1 0 0 0-1.414 1.414l5.993 5.993a1.03 1.03 0 0 0 .714.3.997.997 0 0 0 .714-.3l5.993-5.993a1 1 0 0 0 0-1.414z",
    "data-ppui": "true"
  })), props.children);
};

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded14);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.707 17.29a1 1 0 1 1-1.414 1.414L2.3 12.711a.997.997 0 0 1 0-1.428L8.293 5.29a1 1 0 0 1 1.414 1.414l-4.293 4.293H21a1 1 0 1 1 0 2H5.414l4.293 4.293z",
    "data-ppui": "true"
  })), props.children);
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded15);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.293 18.704a1 1 0 0 1 0-1.414l4.293-4.293H3a1 1 0 1 1 0-2h15.586l-4.293-4.293a1 1 0 0 1 1.414-1.414l5.993 5.993a1.03 1.03 0 0 1 .3.714.997.997 0 0 1-.295.71l-.002.002-.003.002-5.993 5.993a1 1 0 0 1-1.414 0z",
    "data-ppui": "true"
  })), props.children);
};

var ArrowUpSmIcon = function ArrowUpSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded16);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 14.5a1 1 0 0 1-1-1V6.745L4.669 9.743A1 1 0 1 1 3.33 8.257l5-4.5a1 1 0 0 1 1.338 0l5 4.5a1 1 0 1 1-1.338 1.486L10 6.745V13.5a1 1 0 0 1-1 1z",
    "data-ppui": "true"
  })), props.children);
};

var ArrowUpIcon = function ArrowUpIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded17);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.707 9.71a1 1 0 0 1-1.414-1.414l5.993-5.993.02-.02a.997.997 0 0 1 1.408.02l5.993 5.993a1 1 0 0 1-1.414 1.414L13 5.417v15.586a1 1 0 1 1-2 0V5.417L6.707 9.71z",
    "data-ppui": "true"
  })), props.children);
};

var ArtIcon = function ArtIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded18);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 0-9-9 8.98 8.98 0 0 0 .525 3.036c.266.742 1.329.724 2.018.34a3 3 0 0 1 4.3 3.583c-.252.748-.079 1.797.7 1.924.474.077.961.117 1.457.117zm2-14a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm3 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM7 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AttachIcon = function AttachIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded19);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 7a5 5 0 0 1 10 0v8a7 7 0 1 1-14 0V7a1 1 0 0 1 2 0v8a5 5 0 0 0 10 0V7a3 3 0 1 0-6 0v8a1 1 0 1 0 2 0V7a1 1 0 1 1 2 0v8a3 3 0 1 1-6 0V7z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AutoIcon = function AutoIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded20);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13.102v2.373a.474.474 0 0 1-.474.475H19.6a2.85 2.85 0 0 1-5.7 0h-3.8a2.85 2.85 0 0 1-5.7 0H2.973a.474.474 0 0 1-.474-.474V12.15a1.896 1.896 0 0 1 1.425-1.832L5.35 6.697A1.9 1.9 0 0 1 7.113 5.5h6.352a2.15 2.15 0 0 1 1.484.713l3.225 4.039h.474a2.85 2.85 0 0 1 2.852 2.85zm-12.825 2.85a1.425 1.425 0 1 0-2.85 0 1.425 1.425 0 0 0 2.85 0zm.712-8.55H7.113l-1.14 2.85h3.414v-2.85zm6.354 2.85l-2.28-2.85h-2.647v2.85h4.927zm2.443 5.7a1.425 1.425 0 1 0-1.425 1.425 1.425 1.425 0 0 0 1.415-1.425h.01z",
    "data-ppui": "true"
  })), props.children);
};

var AutopayNoIcon = function AutopayNoIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded21);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.521 16.94c-.321.49-1.005.515-1.419.102l-.017-.017c-.36-.361-.384-.933-.117-1.369a6.96 6.96 0 0 0 .837-2.02c.12-.498.54-.886 1.052-.886h.024c.584 0 1.05.501.931 1.074a8.95 8.95 0 0 1-1.29 3.116zm-3.865 1.029c.436-.268 1.008-.244 1.37.117l.016.017c.414.413.388 1.097-.1 1.419a8.948 8.948 0 0 1-3.118 1.292c-.573.118-1.074-.347-1.074-.931v-.024c0-.512.388-.933.885-1.052a6.96 6.96 0 0 0 2.021-.838zM8.341 6.03c-.435.267-1.007.243-1.369-.118l-.016-.017c-.414-.414-.388-1.097.1-1.42a8.949 8.949 0 0 1 3.12-1.29c.572-.118 1.074.346 1.074.931v.024c0 .511-.389.933-.886 1.051a6.958 6.958 0 0 0-2.023.838zm-2.447.925c-.413-.413-1.097-.387-1.418.101a8.95 8.95 0 0 0-1.294 3.12c-.117.572.347 1.074.932 1.074h.024c.511 0 .933-.389 1.052-.886a6.96 6.96 0 0 1 .839-2.023c.267-.435.244-1.008-.118-1.37l-.017-.016zm7.93-3.77c-.573-.118-1.074.347-1.074.932v.024c0 .511.388.932.885 1.051.724.174 1.404.46 2.021.839.436.267 1.008.244 1.37-.118l.016-.016c.414-.414.388-1.097-.1-1.42a8.95 8.95 0 0 0-3.118-1.292zM5.19 13.635c-.12-.497-.54-.885-1.052-.885h-.024c-.585 0-1.05.501-.932 1.074a8.95 8.95 0 0 0 1.294 3.12c.321.488 1.005.514 1.418.1l.017-.016c.362-.362.385-.934.118-1.37a6.958 6.958 0 0 1-.84-2.023zm1.782 4.453c.362-.361.934-.385 1.37-.118a6.957 6.957 0 0 0 2.022.838c.497.119.886.54.886 1.052v.024c0 .584-.502 1.049-1.074.931a8.95 8.95 0 0 1-3.12-1.291c-.488-.322-.514-1.006-.1-1.42l.016-.016zm11.13-11.13c.414-.414 1.098-.388 1.42.101a8.95 8.95 0 0 1 1.29 3.116c.118.573-.347 1.075-.931 1.075h-.024c-.511 0-.933-.389-1.052-.886a6.961 6.961 0 0 0-.837-2.02c-.267-.436-.244-1.008.117-1.37l.017-.016z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.997 12a5 5 0 1 0 10 0 5 5 0 0 0-10 0zm5.75.167V9.75a.75.75 0 0 0-1.5 0v1.981l-1.28.731a.75.75 0 0 0 .743 1.303l1.66-.947a.75.75 0 0 0 .378-.651z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var AutopayIcon = function AutopayIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded22);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12c-.552 0-.992.45-1.07.997A7.001 7.001 0 0 1 5 12a7 7 0 0 1 13.448-2.729c.199.47.702.759 1.17.729H20a1 1 0 0 0 1-1V4a1 1 0 1 0-2 0v2.343a9 9 0 1 0 1.945 6.656c.06-.55-.393-.999-.945-.999z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm.75-7.25v2.417a.75.75 0 0 1-.378.652l-1.659.946a.75.75 0 0 1-.743-1.303l1.28-.73V9.75a.75.75 0 0 1 1.5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BabyProductsIcon = function BabyProductsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded23);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 4a1 1 0 0 0-1 1v5H5.498V7.5a1 1 0 0 0-1-1H2.75a.75.75 0 0 0 0 1.5h1.248v4H4v3a1 1 0 0 0 1 1h3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5h9.027a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5H21a1 1 0 0 0 1-1v-5a6 6 0 0 0-6-6h-3zm4.527 15.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-8.027-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BankDepositIcon = function BankDepositIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded24);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.748 18.875a.75.75 0 0 1-.75-.75V16.5h-1.625a.75.75 0 1 1 0-1.5h1.625v-1.625a.75.75 0 1 1 1.5 0V15h1.625a.75.75 0 0 1 0 1.5h-1.625v1.625a.75.75 0 0 1-.75.75z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6.903a1.5 1.5 0 0 1 .793-1.324l6.265-3.343a2 2 0 0 1 1.883 0l6.265 3.343c.488.261.794.77.794 1.324v2.1a1 1 0 0 1-1 1h-.796a6.252 6.252 0 1 1-7.038 10H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-7H5a1 1 0 0 1-1-1v-2.1zm5.5 8.753a6.352 6.352 0 0 0 0 .193v1.154h-2v-7h2v5.653zm1.5.181v-.169a4.744 4.744 0 0 1 4.672-4.665h.154a4.717 4.717 0 0 1 2.174.566 4.757 4.757 0 0 1 2.5 4.184 4.75 4.75 0 0 1-9.5.084zm2-5.699a6.274 6.274 0 0 0-2 1.552v-1.687h2v.135zm.75-3.635a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BankInfoIcon = function BankInfoIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded25);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15.25a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25V15.5a.25.25 0 0 1 .25-.25h1zm-.5-1.005a.998.998 0 1 0 0-1.995.998.998 0 0 0 0 1.995z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6.9a1.5 1.5 0 0 1 .794-1.324l6.264-3.343a2 2 0 0 1 1.884 0l6.264 3.343A1.5 1.5 0 0 1 20 6.9V9a1 1 0 0 1-1 1h-.795a6.252 6.252 0 1 1-7.038 10H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-7H5a1 1 0 0 1-1-1V6.9zM15.75 11a4.73 4.73 0 0 0-2.75.877 4.742 4.742 0 0 0-2 3.788v.169c.007.403.064.794.165 1.166a4.763 4.763 0 0 0 2.461 3 4.728 4.728 0 0 0 2.688.467 4.75 4.75 0 0 0-.564-9.468zM13 10v.135a6.273 6.273 0 0 0-2 1.552V10h2zm-3.5 0v5.653a6.352 6.352 0 0 0 0 .193V17h-2v-7h2zm4.25-3.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BankIcon = function BankIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded26);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6.9a1.5 1.5 0 0 1 .794-1.324l6.264-3.343a2 2 0 0 1 1.884 0l6.264 3.343A1.5 1.5 0 0 1 20 6.9V9a1 1 0 0 1-1 1h-1v7h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-7H5a1 1 0 0 1-1-1V6.9zM7.5 10v7h2v-7h-2zm3.5 0v7h2v-7h-2zm3.5 0v7h2v-7h-2zm-.75-3.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BeautyIcon = function BeautyIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded27);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.966 16a6.5 6.5 0 1 0-6.931 0H5a1 1 0 0 0-1 1H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1-1h-.034zm1.534-5.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1v-2a1 1 0 0 0-1-1V4.604a.25.25 0 0 0-.427-.177l-1.28 1.28a1 1 0 0 0-.293.707V10a1 1 0 0 0-1 1v2z",
    "data-ppui": "true"
  })), props.children);
};

var BigPurchaseIcon = function BigPurchaseIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded28);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 2a.75.75 0 0 1 .75.75V3h4.224a1 1 0 0 1 .917 1.399L17.912 5.5l.48 1.101A1 1 0 0 1 17.473 8H13.25v1.15c.016.017.03.036.046.055l6.995 9.19A1 1 0 0 1 19.496 20H5.504a1 1 0 0 1-.795-1.606l6.995-9.189.046-.055v-6.4A.75.75 0 0 1 12.5 2zm3.776 3.5l.436 1H13.25v-2h3.462l-.436 1z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BillPaymentIcon = function BillPaymentIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded29);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.002 1.997a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1H18a1 1 0 0 0 1-1v-18a1 1 0 0 0-1-1H6.002zm1.75 13.5a.75.75 0 0 0 0 1.5h5.498a.75.75 0 0 0 0-1.5H7.752zm-.75 3.75a.75.75 0 0 1 .75-.75h5.498a.75.75 0 0 1 0 1.5H7.752a.75.75 0 0 1-.75-.75zm9.249-3.75a.75.75 0 0 1 0 1.5h-.502a.75.75 0 0 1 0-1.5h.502zm.75 3.75a.75.75 0 0 0-.75-.75h-.502a.75.75 0 0 0 0 1.5h.502a.75.75 0 0 0 .75-.75zm-9-15.25a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BirthdayIcon = function BirthdayIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded30);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5a1 1 0 0 0 1-1c0-.552-.448-2-1-2s-1 1.448-1 2a1 1 0 0 0 1 1zm-1 3.5V6h2v2.5h5.99c.834 0 1.51.676 1.51 1.51v2.172c0 .65-.189 1.208-.5 1.672V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5.146a2.952 2.952 0 0 1-.5-1.672V10.01c0-.834.676-1.51 1.51-1.51H11zm3.333 3.682c0 .647-.433 1.214-1.085 1.537-.361.178-.79.281-1.248.281-.459 0-.887-.103-1.248-.281-.652-.323-1.085-.89-1.085-1.537 0 .647-.434 1.214-1.086 1.537A2.828 2.828 0 0 1 7.333 14C6.045 14 5 13.186 5 12.182V10.01a.01.01 0 0 1 .01-.01h13.98a.01.01 0 0 1 .01.01v2.172C19 13.186 17.955 14 16.667 14c-.46 0-.887-.103-1.248-.281-.652-.323-1.086-.89-1.086-1.537z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BitcoinCashIcon = function BitcoinCashIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded31);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.376 4.859c2.292-.322 4.23-.042 4.905 1.973l-.001.002c.496 1.474.074 2.524-.816 3.272 1.753.016 3.02.763 3.326 3.022.38 2.804-1.497 4.014-4.384 4.857l.666 2.887-1.74.401-.657-2.847c-.45.104-.913.207-1.393.307l.66 2.861-1.738.401-.668-2.891-3.51.8-.135-2.161s1.293-.276 1.266-.29c.492-.114.54-.498.52-.727L6.87 8.895c-.148-.338-.472-.694-1.177-.531.016-.029-1.264.292-1.264.292L4 6.798l3.507-.816-.66-2.857 1.739-.401.647 2.801a71.37 71.37 0 0 1 1.385-.339l-.642-2.784L11.716 2l.66 2.859zm-.2 11.686c1.429-.31 4.554-.985 4.096-2.968-.469-2.026-3.444-1.265-4.896-.894a15.35 15.35 0 0 1-.424.106l.884 3.83c.097-.022.211-.047.34-.074zm-1.34-5.573c1.193-.254 3.797-.81 3.38-2.613-.425-1.842-2.902-1.202-4.114-.888-.136.035-.257.066-.357.09l.804 3.474.287-.063z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BitcoinIcon = function BitcoinIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded32);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.07 10.04c.315-2.102-1.285-3.232-3.473-3.985l.71-2.847-1.733-.431-.692 2.771a68.358 68.358 0 0 0-1.388-.326l.695-2.79L11.457 2l-.709 2.845-3.495-.865-.46 1.85s1.285.295 1.258.314c.702.175.829.64.808 1.007L6.914 14.95c-.086.213-.304.532-.794.41.017.025-1.26-.316-1.26-.316L4 17.031l3.49.88-.717 2.88 1.73.432.711-2.848c.474.128.932.246 1.38.358l-.707 2.835L11.62 22l.717-2.874c2.955.559 5.178.333 6.112-2.337.753-2.152-.037-3.393-1.592-4.203 1.132-.262 1.985-1.007 2.213-2.545v-.001zm-3.96 5.552c-.537 2.152-4.159.989-5.334.697l.952-3.815c1.175.293 4.941.874 4.383 3.118zm.538-5.583c-.489 1.958-3.505.963-4.483.72l.861-3.461c.98.244 4.13.7 3.62 2.741",
    "data-ppui": "true"
  })), props.children);
};

var BlockIcon = function BlockIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded33);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 0 1-12.906 6.32L18.32 7.094A7.965 7.965 0 0 1 20 12zM5.68 16.906L16.906 5.68A8 8 0 0 0 5.68 16.906z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BooksIcon = function BooksIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded34);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 6.226a8.758 8.758 0 0 1 9.328.244l.46.307a.476.476 0 0 1 .212.396V18.56c0 .35-.39.559-.682.364l-.664-.443a7.676 7.676 0 0 0-.594-.358l-.031-.017-.03-.016a7.675 7.675 0 0 0-7.411.115 1.186 1.186 0 0 1-1.177 0 7.538 7.538 0 0 0-.412-.219 7.678 7.678 0 0 0-7.654.495l-.664.443A.437.437 0 0 1 2 18.56V7.173c0-.159.079-.307.211-.396l.46-.307A8.756 8.756 0 0 1 12 6.226zm1 1.733a6.758 6.758 0 0 1 7 .036v7.893a9.681 9.681 0 0 0-7-.08v-7.85zm-9 7.929a9.687 9.687 0 0 1 7-.079v-7.85a6.758 6.758 0 0 0-7 .036v7.893z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BoxIcon = function BoxIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded35);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7zm2.247 11.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5h-1.5zm-.75-3.25c0 .414.336.75.75.75h3.5a.75.75 0 1 0 0-1.5h-3.5a.75.75 0 0 0-.75.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var BusinessIcon = function BusinessIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded36);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 3v2H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1zm1.5.5V5h7V3.5h-7zm-5 9.25h5v-1.5h-5v1.5zm12 0h5v-1.5h-5v1.5zM14 11a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ButtonIcon = function ButtonIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded37);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 5a7 7 0 0 0 0 14h6a7 7 0 1 0 0-14H9zm4.461 2.043a.75.75 0 0 1 .508.931l-2.492 8.475a.75.75 0 0 1-1.44-.424l2.493-8.474a.75.75 0 0 1 .931-.508zm-4.94 7.176a.75.75 0 1 1-1.061 1.06l-2.743-2.742a.76.76 0 0 1 0-1.074L7.46 8.72a.75.75 0 1 1 1.06 1.06L6.301 12l2.22 2.22zm6.948 0a.75.75 0 1 0 1.061 1.06l2.743-2.742a.76.76 0 0 0 0-1.074L16.53 8.72a.75.75 0 0 0-1.06 1.06L17.689 12l-2.22 2.22z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CalculatorIcon = function CalculatorIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded38);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 2a1 1 0 0 0-1 1v7.25a1 1 0 0 0 1 1h7.25a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm3.625 1.625a.75.75 0 0 0-.75.75v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5a.75.75 0 0 0-.75-.75zM3 12.75a1 1 0 0 0-1 1V21a1 1 0 0 0 1 1h7.25a1 1 0 0 0 1-1v-7.25a1 1 0 0 0-1-1H3zm5.747 2.503a.75.75 0 0 0-1.061 0l-1.061 1.061-1.061-1.06a.75.75 0 0 0-1.06 1.06l1.06 1.06-1.06 1.062a.75.75 0 0 0 1.06 1.06l1.06-1.06 1.062 1.06a.75.75 0 1 0 1.06-1.06l-1.06-1.061 1.06-1.061a.75.75 0 0 0 0-1.06zM13.75 2a1 1 0 0 0-1 1v7.25a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-7.25zm6.625 4.625a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 0 0 .75-.75zM13.75 12.75a1 1 0 0 0-1 1V21a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1v-7.25a1 1 0 0 0-1-1h-7.25zm6.625 6.127a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 0 0 .75-.75zm-.75-3.755a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 1 1 0-1.5h4.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CalendarPausedIcon = function CalendarPausedIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded39);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.254 18a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75zm-3.75-.75a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-1.5 0v3z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 2.75a.75.75 0 0 1 1.5 0V4h3V2.75a.75.75 0 0 1 1.5 0V4h4a1 1 0 0 1 1 1v6.167A6.25 6.25 0 1 1 11.167 20H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4V2.75zm6.75 17.75A4.75 4.75 0 0 1 11 15.75a4.75 4.75 0 1 1 4.75 4.75zM18.5 10h-.295a6.23 6.23 0 0 0-2.455-.5 6.23 6.23 0 0 0-2.456.5H5.5V5.5H9v.75a.75.75 0 0 0 1.5 0V5.5h3v.75a.75.75 0 0 0 1.5 0V5.5h3.5V10z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CalendarSmIcon = function CalendarSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded40);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.75 1.999a.75.75 0 0 1 .75.75V3H14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.5v-.251a.75.75 0 1 1 1.5 0V3h2v-.251a.75.75 0 0 1 .75-.75zM6.5 4.5v.751a.75.75 0 1 0 1.5 0V4.5h2v.751a.75.75 0 0 0 1.5 0V4.5h2V8h-9V4.5h2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CalendarIcon = function CalendarIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded41);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 2.75a.75.75 0 0 1 1.5 0V4h3V2.75a.75.75 0 0 1 1.5 0V4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4V2.75zM9 5.5H5.5V10h13V5.5H15v.75a.75.75 0 0 1-1.5 0V5.5h-3v.75a.75.75 0 0 1-1.5 0V5.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CameraIcon = function CameraIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded42);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 7V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1zm1.5 0V5.5h5V7h-5zM8 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm11.25 0a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5h1.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CardStackIcon = function CardStackIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded43);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 8V4.8a.8.8 0 0 1 .8-.8h14.4a.8.8 0 0 1 .8.8v9.6a.8.8 0 0 1-.8.8H18v3.2a.8.8 0 0 1-.8.8H2.8a.8.8 0 0 1-.8-.8V8.8a.8.8 0 0 1 .8-.8H6zm1.5 0V5.5h13v8.2H18V8.8a.8.8 0 0 0-.8-.8H7.5zm4.75 9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CashBackIcon = function CashBackIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded44);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.855 7h1.142V6a4 4 0 1 1 8 0v1h1.142a1 1 0 0 1 .989.848L18.92 13h2.075a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5.163a1 1 0 0 1-.989-1.152l1.693-11A1 1 0 0 1 6.855 7zm7.642-1v1h-5V6a2.5 2.5 0 0 1 5 0zM20.5 18.5v-4H11v4h9.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CashPickupIcon = function CashPickupIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded45);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 6v4H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4h3a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm1.5.5V10H17a1 1 0 0 1 1 1v1.5h2.5v-6h-13zM10 17a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CashIcon = function CashIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded46);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.242 18c.42 0 .76-.34.76-.76v-2.242h1a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-15a1 1 0 0 0-1 1v1H2.76a.76.76 0 0 0-.76.76v8.482c0 .42.34.76.76.76h16.482zM5.002 9.498H3.5V16.5h15.002v-1.502h-12.5a1 1 0 0 1-1-1v-4.5zm6 1a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CausesIcon = function CausesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded47);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.05 5.437C12.29 4.87 13.287 3 16.35 3c3.76 0 5.79 3.94 3.98 8a8.755 8.755 0 0 1-.236.492 2.99 2.99 0 0 1 1.027.691l.587.605a1 1 0 0 1-.015 1.409l-4.725 4.653A4 4 0 0 1 14.16 20H9.5l-1.544 1.543a1 1 0 0 1-1.414 0l-3.836-3.836a1 1 0 0 1 0-1.414L5.37 13.63c-.697-.824-1.292-1.716-1.7-2.63-1.81-4.06.22-8 3.98-8 3.06 0 4.06 1.87 4.301 2.437.018.043.08.043.098 0zM7.25 20.13l1.63-1.63h5.282a2.49 2.49 0 0 0 1.754-.719l4.371-4.304-.241-.249a1.493 1.493 0 0 0-.764-.422 1.5 1.5 0 0 0-1.373.407l-2.847 2.848a1.5 1.5 0 0 1-1.073.439H9.75a.75.75 0 0 1 0-1.5h2.75v-1.5H8.657a2.5 2.5 0 0 0-1.768.732L4.121 17l3.13 3.129z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CenterAlignIcon = function CenterAlignIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded48);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5zm0 8a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5zm1.5 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1zm1-9a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2h-9z",
    "data-ppui": "true"
  })), props.children);
};

var ChangePlanIcon = function ChangePlanIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded49);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.296 8.295a1 1 0 0 0 1.414 1.414l2.993-2.995a1.01 1.01 0 0 0 0-1.428L18.71 2.29a1 1 0 1 0-1.414 1.414L18.59 5h-1.598c-1.127 0-2.083.212-2.896.623-.815.411-1.433.995-1.922 1.66-.552.749-.962 1.646-1.313 2.544-.483-.95-1.078-1.883-1.886-2.669C7.61 5.83 5.725 5 3 5a1 1 0 0 0 0 2c2.272 0 3.636.67 4.582 1.592.993.966 1.616 2.287 2.242 3.792l.038.091c-.474 1.145-1.018 2.147-1.844 2.92C7.037 16.31 5.55 17 3 17a1 1 0 0 0 0 2c2.946 0 4.959-.812 6.384-2.145a8.386 8.386 0 0 0 1.527-1.962c.327.662.7 1.3 1.15 1.86C13.15 18.105 14.683 19 16.992 19h1.598l-1.294 1.295a1 1 0 0 0 1.414 1.414l2.993-2.995a1.01 1.01 0 0 0 0-1.428L18.71 14.29a1 1 0 1 0-1.414 1.414L18.59 17h-1.598c-1.688 0-2.654-.606-3.375-1.502-.647-.804-1.1-1.835-1.6-3.041l.04-.106.28-.757c.459-1.255.843-2.306 1.447-3.126.339-.46.727-.815 1.213-1.06C15.483 7.163 16.12 7 16.992 7h1.598l-1.294 1.295z",
    "data-ppui": "true"
  })), props.children);
};

var CharitiesIcon = function CharitiesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded50);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.997 6.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.751 2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h10.496a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.751zm.5 1.5v4h9.496v-4H7.251zM4.003 11a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1a1 1 0 0 1-.997 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8a1 1 0 0 1-.997-1v-1zm9.413 2.21c-.53 1.246-2.296 1.246-2.826.001a1.028 1.028 0 0 0-.294-.377c-.166-.135-.506-.335-1.193-.335-.67 0-1.126.321-1.38.826-.27.537-.352 1.394.095 2.398.416.933 1.28 1.92 2.25 2.69.474.375.936.668 1.323.86.38.187.578.222.609.228h.007c.03-.005.229-.04.611-.228a7.68 7.68 0 0 0 1.325-.859c.97-.768 1.831-1.754 2.243-2.687l.002-.004c.448-1.004.367-1.86.097-2.398-.255-.505-.711-.826-1.38-.826-.689 0-1.029.2-1.194.335-.19.154-.272.324-.295.377z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ChatIcon = function ChatIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded51);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1.651.76l4.38-3.76H21a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3z",
    "data-ppui": "true"
  })), props.children);
};

var CheckCaptureIcon = function CheckCaptureIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded52);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.997 5.746a.75.75 0 0 1 .75-.75h2.504a.75.75 0 1 1 0 1.5H3.497v1.752a.75.75 0 1 1-1.5 0V5.746zm19.251-.75a.75.75 0 0 1 .75.75v2.497a.75.75 0 0 1-1.5 0V6.496h-1.749a.75.75 0 0 1 0-1.5h2.499zM2.747 18.997a.75.75 0 0 1-.75-.75v-2.502a.75.75 0 0 1 1.5 0v1.752h1.754a.75.75 0 0 1 0 1.5H2.747zm18.501 0a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-1.5 0v1.75h-1.75a.75.75 0 0 0 0 1.5h2.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.001 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-12zm5.75 4.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5zm-5.25.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CheckIcon = function CheckIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded53);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 8a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8zm2 6.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75zm6.75-.75a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CheckmarkBackgroundSmIcon = function CheckmarkBackgroundSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded54);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm3.854-9.183a.75.75 0 1 0-1.189-.914L7.95 10.738l-1.652-1.7a.75.75 0 1 0-1.076 1.045l2.248 2.314a.76.76 0 0 0 1.148-.066l4.236-5.514z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CheckmarkBackgroundIcon = function CheckmarkBackgroundIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded55);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm5.135-11.954a.75.75 0 0 0-1.19-.912l-5.292 6.904-2.59-2.661a.75.75 0 0 0-1.075 1.046l3.188 3.275a.76.76 0 0 0 1.147-.068l5.812-7.584z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CheckmarkSmIcon = function CheckmarkSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded56);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.69 11.474l5.517-7.19a1 1 0 0 1 1.586 1.218l-6.22 8.107a1 1 0 0 1-1.51.089l-3.35-3.44a1 1 0 1 1 1.433-1.396l2.544 2.612z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CheckmarkIcon = function CheckmarkIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded57);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.62 6.207a1 1 0 0 1 .185 1.402L11.37 18.603a1.01 1.01 0 0 1-1.525.09l-4.996-5.13a1 1 0 1 1 1.433-1.396l4.198 4.311 7.74-10.086a1 1 0 0 1 1.402-.185z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ChevronDownSmIcon = function ChevronDownSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded58);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.291 6.293a1 1 0 0 1 1.415 0l3.293 3.293 3.293-3.293a1 1 0 1 1 1.414 1.414L9.713 11.7a1.01 1.01 0 0 1-1.428 0L4.29 7.707a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ChevronDownIcon = function ChevronDownIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded59);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.292 8.293a1 1 0 0 1 1.414 0L12 14.586l6.293-6.293a1 1 0 0 1 1.414 1.414L12.713 16.7a1.01 1.01 0 0 1-1.428 0L4.292 9.707a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ChevronLeftIcon = function ChevronLeftIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded60);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.703 4.293a1 1 0 0 1 0 1.414L9.41 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-6.993-6.993a1.01 1.01 0 0 1 0-1.428l6.993-6.993a1 1 0 0 1 1.414 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ChevronRightIcon = function ChevronRightIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded61);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.797 4.389a.979.979 0 0 0 0 1.396L15.09 12l-6.293 6.215a.979.979 0 0 0 0 1.396c.39.386 1.024.386 1.414 0l6.993-6.906a.989.989 0 0 0 0-1.41l-6.993-6.906a1.009 1.009 0 0 0-1.414 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ChevronUpSmIcon = function ChevronUpSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded62);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.707 11.703a1 1 0 0 1-1.414 0L8.999 8.41l-3.293 3.293a1 1 0 0 1-1.414-1.414l3.993-3.993a1.01 1.01 0 0 1 1.429 0l3.993 3.993a1 1 0 0 1 0 1.414z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ChevronUpIcon = function ChevronUpIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded63);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 15.703a1 1 0 0 0 1.414 0L12 9.41l6.293 6.293a1 1 0 0 0 1.414-1.414l-6.993-6.993a1.01 1.01 0 0 0-1.428 0l-6.993 6.993a1 1 0 0 0 0 1.414z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ChildrenIcon = function ChildrenIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded64);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.336 10.347a4.5 4.5 0 1 0-4.673 0A8.003 8.003 0 0 0 3.999 18v3a1 1 0 0 0 1 1h14.962a2.038 2.038 0 0 0 2.038-2.038v-.431c0-1.68-.77-3.178-1.975-4.163a3.68 3.68 0 0 0-4.942-4.752 7.93 7.93 0 0 0-.746-.27zm6.163 9.615a.538.538 0 0 1-.538.538h-6.676a.538.538 0 0 1-.538-.538v-.431a3.878 3.878 0 0 1 2.744-3.708 2.18 2.18 0 0 1 1.132-4.044 2.182 2.182 0 0 1 1.132 4.044 3.882 3.882 0 0 1 2.745 3.708v.43z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ClockSmIcon = function ClockSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded65);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 16A7 7 0 1 1 9 2a7 7 0 0 1 0 14zm.75-11.25v4.996a.75.75 0 0 1-.379.651L6.577 11.99a.75.75 0 1 1-.743-1.303L8.25 9.31V4.75a.75.75 0 0 1 1.5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ClockIcon = function ClockIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded66);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm.75-15.235v6.25a.75.75 0 0 1-.378.652l-4.349 2.481a.75.75 0 1 1-.743-1.302l3.97-2.266V5.765a.75.75 0 0 1 1.5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CloseSmIcon = function CloseSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded67);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 7.598L5.443 4.04a.992.992 0 1 0-1.402 1.403L7.597 9l-3.556 3.557a.992.992 0 1 0 1.402 1.402L9 10.403l3.556 3.556a.992.992 0 0 0 1.403-1.402L10.403 9l3.556-3.556a.992.992 0 1 0-1.402-1.403L9 7.598z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CloseIcon = function CloseIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded68);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.293 5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 1.414-1.414L12 10.586l5.293-5.293z",
    "data-ppui": "true"
  })), props.children);
};

var ClothingIcon = function ClothingIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded69);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7a3 3 0 0 0 3-3V3l6.275 1.793a1 1 0 0 1 .726.961V10a1 1 0 0 1-1 1h-2.004v10a1 1 0 0 1-1 1H6.004a1 1 0 0 1-1-1V11H3a1 1 0 0 1-1-1V5.754a1 1 0 0 1 .726-.961L9 3v3-2a3 3 0 0 0 3 3z",
    "data-ppui": "true"
  })), props.children);
};

var CloudStorageIcon = function CloudStorageIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded70);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 9.5c0 .401-.053.79-.151 1.16a4.5 4.5 0 0 1-1.732 8.297H5.883A4.5 4.5 0 0 1 6 10.028a4 4 0 0 1 6.051-3.418A4.5 4.5 0 0 1 20 9.5zm-8.49-.44a.732.732 0 0 1 .98 0l2.662 2.396a.732.732 0 1 1-.98 1.088l-1.44-1.295v5.147a.732.732 0 0 1-1.464 0v-5.147l-1.44 1.295a.732.732 0 0 1-.98-1.088L11.51 9.06z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CodeIcon = function CodeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded71);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.341 4.04a1 1 0 0 1 .677 1.242l-4.118 14a1 1 0 0 1-1.918-.564l4.118-14a1 1 0 0 1 1.241-.677zM18.586 12l-2.473 2.473a1 1 0 0 0 1.414 1.415l3.18-3.18a1 1 0 0 0 0-1.415l-3.18-3.18a1 1 0 1 0-1.415 1.414L18.587 12zM7.888 14.473L5.414 12l2.474-2.473a1 1 0 0 0-1.415-1.414l-3.18 3.18a1 1 0 0 0 0 1.414l3.18 3.18a1 1 0 0 0 1.415-1.414z",
    "data-ppui": "true"
  })), props.children);
};

var CommunityIcon = function CommunityIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded72);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.413 3.712c-.53 1.246-2.297 1.246-2.827 0a1.028 1.028 0 0 0-.294-.377C10.126 3.2 9.786 3 9.099 3c-.67 0-1.126.322-1.38.827-.27.537-.352 1.394.096 2.397.415.933 1.278 1.92 2.249 2.69.474.376.936.669 1.323.86.38.188.578.223.609.228h.007c.03-.005.229-.04.611-.228a7.68 7.68 0 0 0 1.325-.859c.97-.768 1.831-1.753 2.243-2.686l.003-.005c.447-1.003.366-1.86.096-2.397C16.026 3.322 15.57 3 14.9 3c-.689 0-1.029.2-1.194.335-.19.154-.272.325-.294.377zM7.47 9.969a1.97 1.97 0 0 1-.946 1.683A3.502 3.502 0 0 1 9.001 15v.357A.643.643 0 0 1 8.36 16H2.644a.643.643 0 0 1-.643-.643V15a3.502 3.502 0 0 1 2.478-3.348A1.968 1.968 0 0 1 5.502 8c1.087 0 1.968.881 1.968 1.969zm13 0c0 .713-.378 1.337-.946 1.683A3.502 3.502 0 0 1 22.001 15v.357a.643.643 0 0 1-.642.643h-5.715a.643.643 0 0 1-.643-.643V15a3.501 3.501 0 0 1 2.478-3.348A1.968 1.968 0 0 1 18.502 8c1.087 0 1.968.881 1.968 1.969zm-7.446 5.683A1.968 1.968 0 0 0 12.002 12a1.969 1.969 0 0 0-1.023 3.652A3.502 3.502 0 0 0 8.501 19v.357c0 .355.288.643.643.643h5.715a.643.643 0 0 0 .643-.643V19a3.502 3.502 0 0 0-2.478-3.348z",
    "data-ppui": "true"
  })), props.children);
};

var ConnectionIcon = function ConnectionIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded73);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.834 17.834c.293.292.77.294 1.038-.022A8.964 8.964 0 0 0 21 12a8.96 8.96 0 0 0-2.128-5.812c-.268-.317-.745-.315-1.038-.022-.293.293-.29.766-.027 1.086A7.47 7.47 0 0 1 19.5 12a7.47 7.47 0 0 1-1.694 4.747c-.262.32-.265.794.028 1.087z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.712 15.712c.293.293.772.296 1.027-.031A5.974 5.974 0 0 0 18 12c0-1.387-.47-2.665-1.261-3.68-.255-.328-.734-.325-1.027-.032-.293.292-.287.764-.046 1.102A4.48 4.48 0 0 1 16.5 12a4.48 4.48 0 0 1-.834 2.61c-.24.337-.247.81.046 1.102zm-6.667-3.081l2.234-4.205c.187-.352.721-.22.721.18v2.291h2.617c.288 0 .473.307.338.562l-2.234 4.205c-.187.353-.721.22-.721-.18v-2.29H9.383a.383.383 0 0 1-.338-.563zM5.128 6.188c.268-.317.745-.315 1.038-.022.293.293.29.766.028 1.086A7.47 7.47 0 0 0 4.5 12a7.47 7.47 0 0 0 1.694 4.747c.262.32.265.794-.028 1.087-.293.292-.77.294-1.038-.022A8.964 8.964 0 0 1 3 12c0-2.216.8-4.244 2.128-5.812z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.261 8.32c.255-.328.734-.325 1.027-.032.293.292.286.764.046 1.102A4.48 4.48 0 0 0 7.5 12c0 .973.309 1.874.834 2.61.24.337.247.81-.046 1.102-.293.293-.772.296-1.027-.031A5.974 5.974 0 0 1 6 12c0-1.387.47-2.665 1.261-3.68z",
    "data-ppui": "true"
  })), props.children);
};

var ContactUsIcon = function ContactUsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded74);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4.997a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1.651.76l4.38-3.76H21a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1H3zm8.422 7.54h1.164c.168 0 .264-.097.276-.277.06-.564.324-.84.912-1.296l.108-.084c.756-.588 1.164-1.296 1.164-2.172 0-1.344-1.032-2.412-2.916-2.412-1.788 0-2.868.96-3.012 2.52-.012.192.096.288.276.288h1.32c.168 0 .264-.096.288-.276.06-.648.42-1.02 1.08-1.02.636 0 1.02.408 1.02.936 0 .516-.276.876-.552 1.128l-.456.42c-.672.612-.912 1.032-.948 1.956 0 .192.096.288.276.288zm.578 3.46a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ContactsIcon = function ContactsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded75);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1H5a1 1 0 1 1 0-2h1v-3H5a1 1 0 1 1 0-2h1V8H5a1 1 0 0 1 0-2h1V5zm9.25 4.25c0 .815-.433 1.528-1.081 1.923A4.002 4.002 0 0 1 17 15v.444a.556.556 0 0 1-.556.556H9.556A.556.556 0 0 1 9 15.444V15a4.002 4.002 0 0 1 2.831-3.827A2.249 2.249 0 0 1 13 7a2.25 2.25 0 0 1 2.25 2.25z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CopyToClipboardIcon = function CopyToClipboardIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded76);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 16v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3zm2.5-10.5v9H16V9a1 1 0 0 0-1-1H9.5V5.5h9z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CreditCardIcon = function CreditCardIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded77);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5.997a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-12zm3 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2zm11.05 5.021c-.203.432-.767.475-1.105.138-.256-.257-.291-.653-.161-.99A3.24 3.24 0 0 0 15 11.997c0-.412-.076-.805-.216-1.168-.13-.338-.095-.734.161-.99.338-.337.902-.294 1.105.138.289.613.45 1.298.45 2.02a4.73 4.73 0 0 1-.45 2.021zm.997 1.299c-.205.326-.184.756.088 1.028.316.316.839.293 1.085-.08a7.714 7.714 0 0 0 1.28-4.268c0-1.577-.47-3.043-1.28-4.267-.246-.373-.769-.397-1.085-.08-.272.272-.293.702-.088 1.028.604.961.953 2.1.953 3.32a6.22 6.22 0 0 1-.953 3.319z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CreditMastercardIcon = function CreditMastercardIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded78);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5.997a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-12zm3 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2zm11.59 7.982a2.546 2.546 0 1 0 0-4.528c.602.566.977 1.371.977 2.263a3.1 3.1 0 0 1-.977 2.264zm-.967-4.529a3.102 3.102 0 0 0-.977 2.264 3.1 3.1 0 0 0 .977 2.264 2.546 2.546 0 1 1 0-4.528zm.484 4.204a2.54 2.54 0 0 1-.897-1.94c0-.777.348-1.473.896-1.94a2.54 2.54 0 0 1 .897 1.94 2.54 2.54 0 0 1-.896 1.94z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CriticalSmIcon = function CriticalSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded79);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.105 2.55a1 1 0 0 1 1.79 0l5.996 11.998a1 1 0 0 1-.895 1.447H3.004a1 1 0 0 1-.895-1.447L8.105 2.55zm.481 8.428h.827c.136 0 .224-.08.234-.218.015-.355.034-.704.054-1.06.045-.811.092-1.658.092-2.686v-.785c0-.15-.078-.229-.224-.229H8.431c-.146 0-.224.08-.224.229v.785c0 1.028.047 1.875.092 2.685.02.357.04.706.054 1.06.01.14.097.22.233.22zM9 14.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CriticalIcon = function CriticalIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded80);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.105 3.554a1 1 0 0 1 1.79 0l7.498 14.998a1 1 0 0 1-.895 1.447H4.502a1 1 0 0 1-.895-1.447l7.498-14.998zm.384 10.96h1.02c.168 0 .276-.096.288-.264.018-.428.042-.85.067-1.28.055-.98.113-2.002.113-3.244v-.948c0-.18-.096-.276-.276-.276h-1.404c-.18 0-.277.096-.277.276v.948c0 1.242.058 2.264.114 3.243.024.43.048.853.066 1.281.013.168.12.264.289.264zm.51 3.486A1 1 0 1 0 12 16a1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CrowdfundIcon = function CrowdfundIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded81);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.023 5.652A1.968 1.968 0 0 0 12 2a1.969 1.969 0 0 0-1.022 3.652A3.502 3.502 0 0 0 8.5 9v.357c0 .355.288.643.643.643h5.714a.643.643 0 0 0 .643-.643V9a3.502 3.502 0 0 0-2.477-3.348zM7.469 9.969a1.97 1.97 0 0 1-.946 1.683A3.502 3.502 0 0 1 9 15v.357a.643.643 0 0 1-.643.643H2.643A.643.643 0 0 1 2 15.357V15a3.502 3.502 0 0 1 2.478-3.348A1.968 1.968 0 0 1 5.5 8c1.087 0 1.969.881 1.969 1.969zm13 0a1.97 1.97 0 0 1-.946 1.683A3.502 3.502 0 0 1 22 15v.357a.643.643 0 0 1-.643.643h-5.714a.643.643 0 0 1-.643-.643V15a3.502 3.502 0 0 1 2.478-3.348A1.968 1.968 0 0 1 18.5 8c1.087 0 1.969.881 1.969 1.969zm-6.5 6a1.97 1.97 0 0 1-.946 1.683A3.502 3.502 0 0 1 15.5 21v.357a.643.643 0 0 1-.643.643H9.143a.643.643 0 0 1-.643-.643V21a3.502 3.502 0 0 1 2.478-3.348A1.968 1.968 0 0 1 12 14c1.088 0 1.969.882 1.969 1.969z",
    "data-ppui": "true"
  })), props.children);
};

var CryptoIcon = function CryptoIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded82);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V8H6v7.998h12V14a1 1 0 1 1 2 0v2.998a1 1 0 0 1-1 1h-3v3.005a1 1 0 1 1-2 0v-3.005h-4v3.005a1 1 0 1 1-2 0v-3.005H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3V3a1 1 0 0 1 2 0v3h4V3a1 1 0 0 1 1-1z",
    "data-ppui": "true"
  })), props.children);
};

var CultureIcon = function CultureIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded83);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.933 9.206a.75.75 0 0 0 0-1.06l-.355-.355a.75.75 0 1 0-1.06 1.06l.354.355a.75.75 0 0 0 1.06 0zm-3.228-1.414a.75.75 0 0 1 0 1.06l-.352.353a.75.75 0 0 1-1.06-1.06l.352-.353a.75.75 0 0 1 1.06 0zm-.652 5.238a.706.706 0 0 1-.998 0l-.062-.063a.706.706 0 0 1 0-.998 3.723 3.723 0 0 1 5.264 0 .706.706 0 0 1 0 .998l-.062.063a.706.706 0 0 1-.998 0 2.223 2.223 0 0 0-3.144 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 15.57a4.984 4.984 0 0 0 3.5 1.428H17a5 5 0 0 0 5-5V3.566a1 1 0 0 0-1.447-.894l-.35.175a8 8 0 0 1-7.156 0l-.35-.175a1 1 0 0 0-1.447.894v3.132l-.297.149a8 8 0 0 1-7.156 0l-.35-.175A1 1 0 0 0 2 7.566V16a5 5 0 0 0 5 5h.75a5 5 0 0 0 5-5v-.43zM20.5 4.365a9.5 9.5 0 0 1-7.75 0v7.703a3.5 3.5 0 0 0 3.5 3.43H17a3.5 3.5 0 0 0 3.5-3.5V4.365zM8.947 15.967a.706.706 0 0 1 .998 0l.063.063a.706.706 0 0 1 0 .998 3.723 3.723 0 0 1-5.265 0 .706.706 0 0 1 0-.998l.062-.063a.706.706 0 0 1 .999 0 2.223 2.223 0 0 0 3.143 0zm-3.21-2.719a.75.75 0 0 0 0-1.5h-.498a.75.75 0 0 0 0 1.5h.498zm3.999-1.5a.75.75 0 0 1 0 1.5h-.502a.75.75 0 0 1 0-1.5h.502z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var CurrencyChfIcon = function CurrencyChfIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded84);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62 15.705c1.64 0 2.83-.78 3.35-2.13.01-.03.02-.06.02-.1 0-.1-.09-.14-.22-.14H7.4c-.12 0-.2.05-.27.16-.33.5-.82.8-1.5.8-1.2 0-1.92-.9-1.92-2.28 0-1.44.72-2.35 1.92-2.35.72 0 1.25.33 1.57.92.06.12.14.17.27.17l1.32-.01c.13 0 .21-.06.21-.16 0-.03-.01-.07-.02-.1-.51-1.37-1.71-2.19-3.34-2.19-2.17 0-3.64 1.45-3.64 3.71 0 2.31 1.45 3.7 3.62 3.7zm4.627-.13h1.18c.15 0 .23-.08.23-.23v-2.75h2.6v2.75c0 .15.08.23.23.23h1.18c.15 0 .23-.08.23-.23v-6.69c0-.15-.08-.23-.23-.23h-1.18c-.15 0-.23.08-.23.23v2.53h-2.6v-2.53c0-.15-.08-.23-.23-.23h-1.18c-.15 0-.23.08-.23.23v6.69c0 .15.08.23.23.23zm7.363 0h1.18c.15 0 .23-.08.23-.23v-2.69h2.54c.15 0 .23-.08.23-.23v-.92c0-.15-.08-.23-.23-.23h-2.54v-1.45h2.75c.15 0 .23-.08.23-.23v-.94c0-.15-.08-.23-.23-.23h-4.16c-.15 0-.23.08-.23.23v6.69c0 .15.08.23.23.23z",
    "data-ppui": "true"
  })), props.children);
};

var CurrencyDollarIcon = function CurrencyDollarIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded85);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.665 21h1.69c.317 0 .486-.169.486-.486V19.1c2.366-.38 3.908-1.902 3.908-4.184 0-2.387-1.479-3.21-4.183-4.14l-1.225-.423c-1.31-.444-1.902-.718-1.902-1.775 0-.908.74-1.5 1.944-1.5 1.183 0 1.901.529 2.176 1.458.084.275.275.423.55.423h1.837c.275 0 .465-.148.465-.38 0-.127-.063-.444-.127-.655-.464-1.627-1.669-2.662-3.443-2.98V3.487c0-.317-.17-.486-.486-.486h-1.69c-.317 0-.486.169-.486.486v1.458c-2.26.422-3.655 1.901-3.655 3.887 0 2.176 1.373 3.211 4.077 4.12l1.078.359c1.288.422 2.197.697 2.197 1.817 0 1.056-.887 1.774-2.303 1.774-1.394 0-2.197-.676-2.514-1.774-.063-.275-.232-.423-.528-.423H7.629c-.295 0-.464.148-.464.423 0 .274.21 1.077.359 1.394.612 1.395 1.88 2.303 3.655 2.578v1.415c0 .317.169.486.486.486z",
    "data-ppui": "true"
  })), props.children);
};

var CurrencyEuroIcon = function CurrencyEuroIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded86);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.284 11.384h.942v1.619h-.942c-.362 0-.555.193-.555.555v1.28c0 .363.193.557.555.557H7.42C8.048 18.898 9.69 21 13.34 21c3.02 0 4.638-1.401 5.339-3.89.097-.338.242-.87.242-1.184 0-.314-.145-.507-.508-.507h-1.909c-.338 0-.531.169-.604.531-.29 1.57-1.208 2.489-2.633 2.489-1.691 0-2.465-1.136-2.73-3.044h3.841c.363 0 .556-.194.556-.556v-1.28c0-.363-.193-.556-.556-.556h-3.986v-1.62h4.397c.362 0 .556-.192.556-.555v-1.28c0-.363-.194-.556-.556-.556h-4.277c.17-1.981 1.063-3.43 2.803-3.43 1.498 0 2.223.99 2.561 2.56.073.338.266.508.604.508h1.957c.363 0 .532-.194.532-.58 0-.194-.049-.363-.097-.58C18.244 4.619 16.552 3 13.34 3 9.933 3 8 5.126 7.492 8.364l-.096.628H6.284c-.362 0-.555.193-.555.556v1.28c0 .363.193.556.555.556z",
    "data-ppui": "true"
  })), props.children);
};

var CurrencyPoundIcon = function CurrencyPoundIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded87);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.946 13.349h2.587c.359.87.487 1.69.487 2.459 0 1.434-.718 2.715-2.792 3.048-.359.076-.564.281-.564.64v1.255c0 .384.205.59.59.59h11.218c.384 0 .59-.206.59-.59v-1.434c0-.384-.206-.59-.59-.59h-3.535l-2.766.026c.717-.87 1.025-1.818 1.025-2.894 0-.794-.154-1.716-.436-2.51h3.817c.384 0 .589-.205.589-.59v-1.383c0-.384-.205-.589-.59-.589h-4.712c-.256-.845-.59-1.69-.59-2.663 0-1.41.667-2.741 2.485-2.741 1.486 0 2.203.845 2.434 2.075.076.358.281.538.64.538h1.998c.384 0 .589-.205.563-.615-.23-2.946-2.28-4.713-5.584-4.713-3.918 0-5.84 2.459-5.84 5.353 0 1.102.231 1.998.513 2.766H5.946c-.384 0-.59.205-.59.59v1.383c0 .384.206.589.59.589z",
    "data-ppui": "true"
  })), props.children);
};

var CurrencyRupeeIcon = function CurrencyRupeeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded88);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53 7.441v1.284c0 .378.201.58.579.58h5.463c-.403 1.132-1.36 1.66-3.071 1.66H6.134c-.377 0-.579.202-.579.58v1.334c0 .277.076.478.252.705l5.564 6.772c.176.226.402.327.704.327h2.971c.302 0 .504-.126.504-.327 0-.151-.05-.252-.303-.529L9.76 13.382c2.77-.201 4.708-1.636 5.237-4.078h2.895c.378 0 .579-.201.579-.579V7.441c0-.377-.201-.579-.58-.579h-2.87a4.66 4.66 0 0 0-.805-1.712h3.676c.378 0 .579-.201.579-.579V3.262c0-.377-.201-.579-.58-.579H6.11c-.378 0-.579.202-.579.58v1.384c0 .377.201.579.579.579h2.366c1.687 0 2.694.478 3.072 1.636H6.109c-.378 0-.579.202-.579.58z",
    "data-ppui": "true"
  })), props.children);
};

var CurrencyYenIcon = function CurrencyYenIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded89);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48 3.68l2.443 5.186H6.21c-.378 0-.58.201-.58.579v1.334c0 .378.202.579.58.579h2.895l.806 1.687H6.21c-.378 0-.58.201-.58.579v1.334c0 .378.202.58.58.58h4.254v4.883c0 .378.202.579.58.579h2.19c.377 0 .579-.201.579-.579v-4.884h4.405c.378 0 .58-.201.58-.579v-1.334c0-.378-.202-.58-.58-.58h-3.852l.831-1.686h3.021c.378 0 .58-.201.58-.579V9.445c0-.378-.202-.58-.58-.58H16.38l2.442-5.034c.126-.252.151-.353.151-.453 0-.227-.2-.378-.503-.378h-2.266c-.327 0-.554.151-.68.453l-3.197 7.452h-.075L9.005 3.453C8.88 3.151 8.653 3 8.325 3H5.91c-.327 0-.504.151-.504.403 0 .075.025.176.076.277z",
    "data-ppui": "true"
  })), props.children);
};

var CustomersIcon = function CustomersIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded90);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 18h-2v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1.5a6.003 6.003 0 0 1 4.469-5.803 3.657 3.657 0 0 1 1.766-6.688 3.656 3.656 0 1 1 5.296 4.688A6.003 6.003 0 0 1 20 15.5V17a1 1 0 0 1-1 1zm-4.844-9.289v-.055c0-1.54-.952-2.857-2.3-3.396a2.156 2.156 0 1 1 2.3 3.451zM13.306 11a3.677 3.677 0 0 1-.775.697 6.007 6.007 0 0 1 4.386 4.803H18.5v-1A4.5 4.5 0 0 0 14 11h-.693z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DailyDealIcon = function DailyDealIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded91);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75 2a.75.75 0 0 0-.75.75V4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h9.46l1.81 1.809a.653.653 0 0 0 .922 0l4.617-4.617a.653.653 0 0 0 0-.923L20 14.46V5a1 1 0 0 0-1-1h-4V2.75a.75.75 0 0 0-1.5 0V4h-3V2.75A.75.75 0 0 0 9.75 2zm6.98 18.15l3.42-3.42-4.232-4.23H12.5v3.418l4.23 4.231zM5.5 5.5H9v.75a.75.75 0 0 0 1.5 0V5.5h3v.75a.75.75 0 0 0 1.5 0V5.5h3.5V10h-13V5.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DashboardIcon = function DashboardIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded92);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 0 0-1 1v2.75a1 1 0 0 0 1 1h5.75a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5zm0 6.25a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1h5.75a1 1 0 0 0 1-1v-7.75a1 1 0 0 0-1-1H5zM13.25 5a1 1 0 0 1 1-1H19a1 1 0 0 1 1 1v8.75a1 1 0 0 1-1 1h-4.75a1 1 0 0 1-1-1V5zm1 11.25a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1H19a1 1 0 0 0 1-1v-1.75a1 1 0 0 0-1-1h-4.75z",
    "data-ppui": "true"
  })), props.children);
};

var DayIcon = function DayIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded93);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a.77.77 0 0 1 .77.77v2.05a.77.77 0 1 1-1.54 0V2.77A.77.77 0 0 1 12 2zM4.79 4.79a.767.767 0 0 1 1.087 0l1.45 1.45A.77.77 0 1 1 6.24 7.328l-1.45-1.45a.77.77 0 0 1 0-1.089zm2.626 12.882a.77.77 0 1 0-1.088-1.088l-1.45 1.45a.77.77 0 1 0 1.087 1.089l1.45-1.45zM2 12a.77.77 0 0 1 .77-.77h2.05a.77.77 0 1 1 0 1.54H2.77A.77.77 0 0 1 2 12zm9.23 9.23a.77.77 0 0 0 1.54 0v-2.05a.77.77 0 0 0-1.54 0v2.05zm7.98-2.02a.767.767 0 0 1-1.087 0l-1.45-1.45a.77.77 0 1 1 1.087-1.088l1.45 1.45c.3.301.3.788 0 1.089zM16.584 6.328a.77.77 0 0 0 1.088 1.088l1.45-1.45a.77.77 0 0 0-1.087-1.089l-1.45 1.45zM22 12a.77.77 0 0 1-.77.77h-2.05a.77.77 0 0 1 0-1.54h2.05A.77.77 0 0 1 22 12zm-10 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10z",
    "data-ppui": "true"
  })), props.children);
};

var DealsIcon = function DealsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded94);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.788 4.287a.998.998 0 0 1 .808-.282 1 1 0 0 1 .29.034l5.961 1.597a2 2 0 0 1 1.215.932l4.742 8.215a1 1 0 0 1-.366 1.365l-8.066 4.657a1 1 0 0 1-1.366-.366L11.753 20H5a1 1 0 0 1-1-1V9.838a2 2 0 0 1 .597-1.426l4.191-4.125zm-1.524 7.938a2 2 0 0 1-.2-1.518l.953-3.556-2.368 2.33a.5.5 0 0 0-.149.357V18.5h5.387l-3.623-6.275zm4.45-1.485a1.5 1.5 0 1 0 .776-2.898 1.5 1.5 0 0 0-.776 2.898z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DeclineIcon = function DeclineIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded95);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8.111 9.171L10.94 12l-2.83 2.829a.75.75 0 0 0 1.06 1.06L12 13.061l2.828 2.828a.75.75 0 0 0 1.06-1.06L13.061 12l2.828-2.828a.75.75 0 1 0-1.06-1.061L12 10.939 9.172 8.111a.75.75 0 0 0-1.06 1.06z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DeleteIcon = function DeleteIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded96);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 3v3H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1zm1.5.5V6h7V3.5h-7zm1 7.25a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-1.5 0v-8.5zm3.5 0a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-1.5 0v-8.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DesktopIcon = function DesktopIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded97);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-6v2h2.25a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5H11v-2H5a1 1 0 0 1-1-1V5zm2 9.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DetailedListIcon = function DetailedListIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded98);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.002a2 2 0 0 1 3.732-1H19a1 1 0 1 1 0 2H7.732a2 2 0 0 1-3.732-1zM6 8a2 2 0 1 0 1.732 3H19a1 1 0 1 0 0-2H7.732A2 2 0 0 0 6 8zM4 20a2 2 0 0 1 3.732-1H19a1 1 0 1 1 0 2H7.732A2 2 0 0 1 4 20zm0-5a2 2 0 0 1 3.732-1H19a1 1 0 1 1 0 2H7.732A2 2 0 0 1 4 15z",
    "data-ppui": "true"
  })), props.children);
};

var DirectDepositIcon = function DirectDepositIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded99);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1l-.001 9.477a1 1 0 0 1-.298.712l-4.733 4.661A4 4 0 0 1 14.16 20H9.5l-1.543 1.543a1 1 0 0 1-1.414 0l-3.836-3.836a1 1 0 0 1 0-1.414l3.121-3.121c.06-.06.12-.117.183-.172H3a1 1 0 0 1-1-1V4zm13.915 13.781a2.5 2.5 0 0 1-1.754.719H8.879L7.25 20.129 4.121 17l2.768-2.768a2.5 2.5 0 0 1 1.768-.732H12.5V15H9.75a.75.75 0 0 0 0 1.5h4.236a1.508 1.508 0 0 0 1.075-.44l2.847-2.847a1.5 1.5 0 0 1 2.137.015l.241.249-4.37 4.304zM4 10.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75zm6.75-.75a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DisasterReliefIcon = function DisasterReliefIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded100);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.996 2a6 6 0 0 1 6 6v.334a.808.808 0 0 1-.025.21.748.748 0 0 1-.387.476l-1.942.98H18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h2.35l-1.942-.98a.748.748 0 0 1-.412-.686V8a6 6 0 0 1 6-6zm4.501 5.888l-3.75 1.893V8.007a1.877 1.877 0 0 1 3.75-.119zm-5.255.121c0 .033.002.066.004.099v1.673L7.5 7.89a1.873 1.873 0 0 1 3.744.103v.016zm2.174 5.202c-.53 1.245-2.297 1.245-2.827 0a1.028 1.028 0 0 0-.294-.377c-.166-.135-.506-.335-1.193-.335-.67 0-1.126.321-1.38.826-.27.537-.352 1.394.095 2.398.416.933 1.28 1.92 2.25 2.69.474.375.936.668 1.323.86.38.187.578.222.609.228h.007c.03-.005.229-.04.611-.228a7.68 7.68 0 0 0 1.325-.859c.97-.768 1.831-1.754 2.243-2.687l.003-.004c.447-1.004.366-1.86.096-2.398-.255-.505-.711-.826-1.38-.826-.689 0-1.029.2-1.194.335-.19.154-.272.324-.294.377z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DisasterIcon = function DisasterIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded101);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22a7 7 0 0 0 7-7c0-2.884-1.155-4.714-2.355-6.615-.982-1.556-1.994-3.158-2.427-5.424-.167-.875-1.287-1.305-1.864-.626-4.571 5.369-2.89 7.99-2.207 9.056.278.434.391.61-.147.61-1.329 0-1.885-1.545-2.109-2.582-.11-.513-.587-.91-.976-.558C5.614 10.041 5 13.775 5 15a7 7 0 0 0 7 7zm2-3.5a2 2 0 1 1-4 0c0-1.105.895-5 2-5s2 3.895 2 5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DislikeSelectedIcon = function DislikeSelectedIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded102);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.113 22.568a.753.753 0 0 1-.661.392 3.23 3.23 0 0 1-2.37-1.053 3.505 3.505 0 0 1-.456-.617c-.37-.635-.405-1.314-.3-1.924.103-.6.348-1.172.596-1.652a.84.84 0 0 0-.747-1.226H5.04a2.358 2.358 0 0 1-1.053-.238 2.481 2.481 0 0 1-.85-.679 2.65 2.65 0 0 1-.493-.974 2.745 2.745 0 0 1-.067-1.094L3.76 5.181c.085-.606.372-1.17.82-1.582a2.391 2.391 0 0 1 1.643-.638h10.174a.74.74 0 0 1 .21.03h3.062c1.052 0 1.707.958 1.707 1.874v8.976c0 .916-.655 1.874-1.707 1.874h-2.815l-3.74 6.853zm6.756-8.728a.474.474 0 0 1-.1.306c-.05.06-.09.063-.101.063H17.16V4.496h2.507c.012 0 .05.004.1.064.053.06.1.167.1.305v8.976z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DislikeIcon = function DislikeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded103);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.452 22.96a.75.75 0 0 0 .66-.392l3.74-6.853h2.816c1.052 0 1.707-.958 1.707-1.874V4.864c0-.916-.655-1.875-1.707-1.875h-3.062a.752.752 0 0 0-.21-.03H6.222A2.391 2.391 0 0 0 4.58 3.6a2.646 2.646 0 0 0-.82 1.582l-1.182 8.322a2.71 2.71 0 0 0 .56 2.068c.23.286.519.52.849.68.328.158.688.24 1.053.237h4.135a.84.84 0 0 1 .747 1.226c-.248.48-.493 1.053-.596 1.652-.105.61-.07 1.289.3 1.924.129.22.282.427.457.617a3.23 3.23 0 0 0 2.369 1.053zm3.191-8.172L12.034 21.4a1.772 1.772 0 0 1-.846-.517 1.997 1.997 0 0 1-.26-.352c-.142-.243-.182-.538-.118-.91.065-.38.233-.795.45-1.217.806-1.562-.328-3.422-2.085-3.422H5.027a.853.853 0 0 1-.383-.087.976.976 0 0 1-.333-.268 1.146 1.146 0 0 1-.212-.422 1.24 1.24 0 0 1-.03-.492L5.25 5.39a1.14 1.14 0 0 1 .347-.682.885.885 0 0 1 .61-.241h9.435v10.321z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DisputesIcon = function DisputesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded104);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a1 1 0 0 0-1 1v11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1V3a1 1 0 0 0-1-1H6zm10.25 12h-8.5a.75.75 0 0 1 0-1.5h8.5a.75.75 0 0 1 0 1.5zm0-7.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h8.5zm-8.5 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5zm7.715 6a3.501 3.501 0 0 1-6.93 0H5.5v5h13v-5h-3.035z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DocumentIcon = function DocumentIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded105);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.414 2.586A2 2 0 0 1 11.828 2H18a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8.828a2 2 0 0 1 .586-1.414l4.828-4.828zM11 4.125V8H7.125L11 4.125zm5.25 8.375a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h8.5zm-8.5 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5zm0 3a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DonateIcon = function DonateIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded106);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.35 5c-3.062 0-4.06 1.87-4.3 2.437a.054.054 0 0 1-.099 0C11.71 6.87 10.711 5 7.651 5c-3.76 0-5.79 3.94-3.98 8C5.31 16.68 10 20 12 20c.124 0 .26-.013.404-.038 1.285 1.21 2.776 2.041 3.594 2.041 1.333 0 4.468-2.207 5.555-4.668.903-2.027.372-4.009-1.004-4.877C21.956 8.596 19.942 5 16.35 5zm1.062 9.212c-.53 1.246-2.297 1.246-2.826 0a1.027 1.027 0 0 0-.295-.377c-.166-.135-.506-.335-1.193-.335-.67 0-1.126.322-1.38.827-.27.537-.352 1.394.095 2.397.416.933 1.28 1.92 2.25 2.69.474.376.936.668 1.323.86.38.188.578.223.609.228h.007c.03-.005.229-.04.611-.228a7.68 7.68 0 0 0 1.325-.858c.97-.769 1.831-1.754 2.244-2.687l.002-.005c.447-1.003.366-1.86.096-2.397-.255-.505-.711-.827-1.38-.827-.689 0-1.029.2-1.194.335-.19.154-.272.325-.294.377z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var DownloadIcon = function DownloadIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded107);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.998 2a1 1 0 0 1 1 1v10.59l2.295-2.295a1 1 0 0 1 1.414 1.414l-3.995 3.995a1.01 1.01 0 0 1-1.428 0L7.288 12.71a1 1 0 0 1 1.415-1.414l2.295 2.295V3a1 1 0 0 1 1-1z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13a1 1 0 1 1 2 0v6h14v-6a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7z",
    "data-ppui": "true"
  })), props.children);
};

var EditIcon = function EditIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded108);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.278 8.77l.026-.026 5.45-5.451a1 1 0 0 1 1.415 0l2.54 2.54a1 1 0 0 1 0 1.414l-3.93 3.928a.937.937 0 0 1-.025.027l-7.375 7.375a2 2 0 0 1-.965.535l-3.801.877a.5.5 0 0 1-.6-.6l.877-3.8a2 2 0 0 1 .535-.965l5.853-5.854zm3.29-1.169l2.894-2.894 1.832 1.832L16.4 9.434 14.568 7.6z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var EducationIcon = function EducationIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded109);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h.25v9.002l-.815 1.96A.75.75 0 0 0 3.127 20h1.746a.75.75 0 0 0 .693-1.038L4.75 17V8H6v7.266a.68.68 0 0 0 .065.31C6.339 16.122 7.605 18 12 18c4.396 0 5.66-1.878 5.935-2.424a.68.68 0 0 0 .065-.31V8h3a1 1 0 0 0 1-1V6z",
    "data-ppui": "true"
  })), props.children);
};

var ElectricityIcon = function ElectricityIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded110);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 3v5H4a1 1 0 0 0-1 1v3a9 9 0 1 0 18 0V9a1 1 0 0 0-1-1h-3V3a1 1 0 1 0-2 0v5H9V3a1 1 0 0 0-2 0zm1.393 11.53l2.194-4.13c.367-.69 1.413-.429 1.413.352V13h2.726a1 1 0 0 1 .883 1.47l-2.197 4.134c-.366.69-1.412.43-1.412-.352V16H9.277a1 1 0 0 1-.884-1.47z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var EmailIcon = function EmailIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded111);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a.995.995 0 0 0 .44.83c.16.107.353.17.56.17h18a1 1 0 0 0 1-1V6zm-18.5.504v1.75l7.986 4.79a1 1 0 0 0 1.028 0l7.986-4.79v-1.75l-8.5 5.1-8.5-5.1z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var EmojiIcon = function EmojiIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded112);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm4.5-6.87a.75.75 0 0 0-1.06 0l-.334.333a4.393 4.393 0 0 1-6.212 0l-.333-.333A.75.75 0 0 0 7.5 15.19l.333.333a5.893 5.893 0 0 0 8.334 0l.333-.333a.75.75 0 0 0 0-1.06zM17 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var EnvironmentIcon = function EnvironmentIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded113);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.246 4a8.753 8.753 0 0 1 8.001 5.2 8.761 8.761 0 0 1 8-5.2v3.251A8.75 8.75 0 0 1 13 15.871v5.378a.75.75 0 0 1-1.5 0V16h-.002v-.128a8.754 8.754 0 0 1-7.252-8.623V4zM13 14.344v-.095h-.002v-1.5a7.251 7.251 0 0 1 5.748-7.094v1.596A7.251 7.251 0 0 1 13 14.344z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var EthereumIcon = function EthereumIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded114);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.905 12.188l-5.45 3.624L7 12.188 12.454 2l5.451 10.188zm-5.45 4.789L7 13.352 12.454 22l5.455-8.648-5.454 3.625z",
    "data-ppui": "true"
  })), props.children);
};

var FaceIdIcon = function FaceIdIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded115);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H6v1a1 1 0 0 1-2 0V5zm16 0a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0V5zm-3 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM11 11V9a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2zm-1-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM19 20a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h2zM4 19a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H6v-1a1 1 0 1 0-2 0v2zm11.086-5.37l-.156.157a4.143 4.143 0 0 1-5.86 0l-.156-.157A1 1 0 1 0 7.5 15.044l.156.157a6.143 6.143 0 0 0 8.688 0l.156-.157a1 1 0 0 0-1.414-1.414z",
    "data-ppui": "true"
  })), props.children);
};

var FamilySupportIcon = function FamilySupportIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded116);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.547 12.383a1 1 0 0 1-1.414 0L20 12.25v8.586a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V12.25l-.133.133a1 1 0 0 1-1.414-1.414l8.84-8.84a1 1 0 0 1 1.414 0l8.84 8.84a1 1 0 0 1 0 1.414zm-8.132-.336c-.53 1.245-2.296 1.245-2.826 0a1.027 1.027 0 0 0-.295-.378c-.165-.134-.505-.335-1.193-.335-.67 0-1.126.322-1.38.827-.27.537-.351 1.394.096 2.398.416.933 1.279 1.92 2.25 2.69.474.375.935.668 1.323.86.38.187.577.222.608.227l.004.001h.004c.03-.006.228-.04.611-.229a7.68 7.68 0 0 0 1.324-.858c.971-.768 1.832-1.754 2.244-2.687l.002-.004c.448-1.004.367-1.861.096-2.398-.254-.505-.71-.827-1.38-.827-.688 0-1.028.2-1.193.335-.19.154-.272.325-.295.378z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var FaqIcon = function FaqIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded117);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4.003a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1v2.996a1 1 0 0 1-1.651.758l-4.374-3.754H6.53l-.879.754A1 1 0 0 1 4 18v-2.996H3a1 1 0 0 1-1-1v-10zm6.278 12.5h6.252l3.97 3.407v-3.407h2v-9H18v6.5a1 1 0 0 1-1 1h-6.975l-1.747 1.5zM11 12.253a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-.525-2.25h-.97c-.15 0-.23-.08-.23-.24.03-.77.23-1.12.79-1.63l.38-.35c.23-.21.46-.51.46-.94 0-.44-.32-.78-.85-.78-.55 0-.85.31-.9.85-.02.15-.1.23-.24.23h-1.1c-.15 0-.24-.08-.23-.24.12-1.3 1.02-2.1 2.51-2.1 1.57 0 2.43.89 2.43 2.01 0 .73-.34 1.32-.97 1.81l-.09.07c-.49.38-.71.61-.76 1.08-.01.15-.09.23-.23.23z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var FavoriteSelectedIcon = function FavoriteSelectedIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded118);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.05 7.437C12.29 6.87 13.289 5 16.35 5c3.76 0 5.79 3.94 3.98 8C18.7 16.69 14 20 12 20c-1.999 0-6.69-3.32-8.33-7-1.81-4.06.22-8 3.98-8 3.061 0 4.06 1.87 4.301 2.437.019.043.08.043.099 0z",
    "data-ppui": "true"
  })), props.children);
};

var FavoriteIcon = function FavoriteIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded119);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.89 8.22c-.708 1.665-3.07 1.665-3.779 0l1.765-.75-1.764.75-.008-.018a1.815 1.815 0 0 0-.615-.726C9.183 7.261 8.632 7 7.651 7c-1.102 0-1.87.538-2.293 1.377-.443.881-.558 2.245.14 3.809.645 1.448 1.97 2.958 3.445 4.127.723.573 1.43 1.022 2.029 1.318.299.147.55.246.745.305.181.055.271.063.283.064.001 0 .002 0 0 0h.001c.012-.001.102-.008.286-.064.196-.06.447-.158.746-.305.6-.296 1.307-.744 2.03-1.316 1.475-1.167 2.798-2.675 3.438-4.123l.003-.006c.697-1.563.583-2.928.14-3.81C18.22 7.539 17.451 7 16.35 7c-.982 0-1.533.26-1.839.476L13.36 5.841C14.02 5.375 14.979 5 16.35 5c3.76 0 5.79 3.94 3.98 8C18.7 16.69 14 20 12 20s-6.69-3.32-8.33-7c-1.81-4.06.22-8 3.98-8 1.371 0 2.329.376 2.99.841l.107.078a3.831 3.831 0 0 1 1.204 1.518c.018.043.08.043.098 0a3.581 3.581 0 0 1 .06-.132 3.827 3.827 0 0 1 1.25-1.464l1.152 1.635a1.813 1.813 0 0 0-.614.725l-.007.019z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var FilterIcon = function FilterIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded120);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12c1.953 0 3.579-1.4 3.93-3.25h2.32a.75.75 0 0 0 0-1.5h-2.32a4.001 4.001 0 0 0-7.86 0H2.75a.75.75 0 0 0 0 1.5h8.32A4.001 4.001 0 0 0 15 12zm-2.07 3.25h8.32a.75.75 0 0 1 0 1.5h-8.32a4.001 4.001 0 0 1-7.86 0H2.75a.75.75 0 0 1 0-1.5h2.32a4.001 4.001 0 0 1 7.86 0z",
    "data-ppui": "true"
  })), props.children);
};

var FingerprintIcon = function FingerprintIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded121);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.805 20.097c-.322-.322-.274-.855.05-1.174A5.483 5.483 0 0 0 17.502 15V9.75a.75.75 0 0 1 1.5 0V15a6.98 6.98 0 0 1-2.245 5.137c-.272.252-.69.221-.95-.04zm-1.126.288c-.231-.231-.58-.289-.89-.183A5.5 5.5 0 0 1 6.5 15v-.249a.75.75 0 0 0-1.499 0V15a7 7 0 0 0 9.473 6.55c.485-.182.572-.799.206-1.165zM5 12.25a.75.75 0 0 0 1.5 0V9c0-.977.255-1.895.702-2.69.184-.328.157-.745-.109-1.01-.323-.324-.86-.293-1.097.1A6.967 6.967 0 0 0 5 9v3.25z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14v-2.25a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0V14zm7.251-2a.75.75 0 0 0 .75-.75V8.722A3.75 3.75 0 0 0 12.251 5h-.5A3.75 3.75 0 0 0 8 8.75v.5a.75.75 0 0 0 1.5 0v-.5a2.25 2.25 0 0 1 2.25-2.25h.5a2.25 2.25 0 0 1 2.25 2.25v2.5c0 .414.336.75.75.75z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5a5.503 5.503 0 0 1 5.259 3.881c.108.353.42.619.789.619.465 0 .826-.415.702-.864A7.003 7.003 0 0 0 7.738 3.447c-.334.257-.337.746-.04 1.044.289.288.752.29 1.082.05A5.475 5.475 0 0 1 12 3.5zM11.001 14a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0v5zm0 4v-1a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm5-4.25a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5z",
    "data-ppui": "true"
  })), props.children);
};

var FlagIcon = function FlagIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded122);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-7h12.234a1 1 0 0 0 .857-1.514L18 9l2.091-3.486A1 1 0 0 0 19.234 4H7V3a1 1 0 0 0-1-1H5z",
    "data-ppui": "true"
  })), props.children);
};

var FlashOffIcon = function FlashOffIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded123);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.117 2.529L8.22 6.098 4.346 2.223a.75.75 0 0 0-1.068 1.054l.004.003 17.436 17.436.006.006a.75.75 0 0 0 1.055-1.066l-4.527-4.527 2.475-4.66A1 1 0 0 0 18.844 9H12V3c0-1.043-1.394-1.39-1.883-.47zM15.78 17.9L6.749 8.868 4.272 13.53A1 1 0 0 0 5.155 15H12v6c0 1.043 1.394 1.39 1.883.47l1.897-3.57z",
    "data-ppui": "true"
  })), props.children);
};

var FlashIcon = function FlashIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded124);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.117 2.529L4.272 13.531A1 1 0 0 0 5.155 15H12v6c0 1.043 1.394 1.39 1.883.47l5.844-11A1 1 0 0 0 18.844 9H12V2.998c0-1.042-1.394-1.39-1.883-.469z",
    "data-ppui": "true"
  })), props.children);
};

var FlowersIcon = function FlowersIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded125);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2c-.894 0-1.618.724-1.618 1.617v1.48L9.336 4.05A1.617 1.617 0 1 0 7.05 6.337l1.048 1.048H6.615a1.615 1.615 0 0 0 0 3.23H8.1l-1.05 1.052a1.614 1.614 0 0 0 2.283 2.283l1.05-1.05v1.483c0 .622.35 1.163.867 1.433v1.2A2.993 2.993 0 0 0 9 16H7a3 3 0 0 0 3 3h1.25v2.248a.75.75 0 0 0 1.5 0V19H14a3 3 0 0 0 3-3h-2c-.896 0-1.7.393-2.25 1.016v-1.2c.515-.27.867-.81.867-1.433v-1.48l1.046 1.047a1.617 1.617 0 0 0 2.286-2.287l-1.048-1.048h1.483a1.615 1.615 0 1 0 0-3.23h-1.486l1.051-1.052a1.614 1.614 0 1 0-2.283-2.283l-1.05 1.05V3.617A1.615 1.615 0 0 0 12 2zm2 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var FoodIcon = function FoodIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded126);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.954 6.97a.75.75 0 1 0 1.06 1.06l1.824-1.823 1.939 1.94-1.823 1.823a.75.75 0 0 0 1.06 1.06l1.824-1.823 1.939 1.94-1.823 1.823a.75.75 0 0 0 1.06 1.06l1.811-1.81a5 5 0 0 1-.287 6.758l-.437.436a2 2 0 0 1-2.828 0L4.586 8.727a2 2 0 0 1 0-2.829l.436-.436a5 5 0 0 1 6.741-.302l-1.81 1.81z",
    "data-ppui": "true"
  })), props.children);
};

var FundraiserIcon = function FundraiserIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded127);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.004v6.274a2.99 2.99 0 0 1 2.123.91l.587.604a1 1 0 0 1-.016 1.409l-4.724 4.653A4 4 0 0 1 14.159 20H9.498l-1.543 1.543a1 1 0 0 1-1.414 0l-3.836-3.836a1 1 0 0 1 0-1.414l2.299-2.299V5H5a1 1 0 0 1-1-1V3zm3.248 17.129L8.877 18.5h5.282a2.507 2.507 0 0 0 1.754-.719l4.37-4.304-.24-.249a1.495 1.495 0 0 0-1.047-.454 1.495 1.495 0 0 0-1.09.439l-2.847 2.848a1.498 1.498 0 0 1-1.073.439H9.748a.75.75 0 0 1 0-1.5h2.75v-1.5H8.655a2.5 2.5 0 0 0-1.768.732L4.119 17l3.129 3.129zM13.419 5.21c-.53 1.245-2.296 1.245-2.826 0a1.027 1.027 0 0 0-.295-.377c-.165-.135-.505-.335-1.193-.335-.67 0-1.126.321-1.38.826-.27.537-.351 1.394.096 2.398.416.933 1.279 1.92 2.25 2.69.474.376.935.668 1.323.86.38.187.577.222.608.228h.008c.03-.005.228-.04.611-.228a7.63 7.63 0 0 0 1.324-.859c.971-.768 1.832-1.754 2.244-2.687l.002-.004c.448-1.004.367-1.86.096-2.398-.254-.505-.71-.826-1.38-.826-.688 0-1.028.2-1.193.334-.19.154-.272.325-.295.378z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var FurnitureIcon = function FurnitureIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded128);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v6h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1V5zm14 7H6v1.5h12V12z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var GasPumpIcon = function GasPumpIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded129);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.501 12.498v-4h5v4h-5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4.999a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2h4.05c.11 0 .214.023.308.066a1 1 0 0 1 .642.934v3a1 1 0 0 1-.75.968v3.031a4.25 4.25 0 0 1-4.25 4.25v1.75a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-16zm14.001 6a1 1 0 0 0 .75.968v3.031a2.75 2.75 0 0 1-2.75 2.75v-9.25h2v2.5zm-12-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var GeneralSupportIcon = function GeneralSupportIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded130);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5.999a1 1 0 0 0 1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v1zm10.413 4.21c-.53 1.246-2.296 1.246-2.826 0a1.027 1.027 0 0 0-.295-.377c-.165-.134-.505-.335-1.193-.335-.67 0-1.126.322-1.38.827-.27.537-.351 1.394.096 2.397.416.933 1.279 1.92 2.25 2.69.474.376.935.669 1.323.86.38.188.577.223.608.228L12 16.5h.004c.03-.006.228-.04.611-.229a7.68 7.68 0 0 0 1.324-.858c.971-.768 1.832-1.754 2.244-2.687l.002-.005c.447-1.003.366-1.86.096-2.397-.254-.505-.71-.827-1.38-.827-.688 0-1.028.2-1.194.335a1.029 1.029 0 0 0-.294.377z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var GetDirectionsIcon = function GetDirectionsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded131);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.707 2.295a1 1 0 0 0-1.414 0l-8.999 8.998a1 1 0 0 0 0 1.414l8.999 8.998a1 1 0 0 0 1.414 0l8.998-8.998a1 1 0 0 0 0-1.414l-8.998-8.998zm1.998 13.414a.75.75 0 1 1-1.061-1.06l1.899-1.9H9.25v2.5a.75.75 0 1 1-1.5 0v-3a1 1 0 0 1 1-1h6.793l-1.899-1.898a.75.75 0 0 1 1.06-1.06l3.003 3.002a1 1 0 0 1 0 1.414l-3.002 3.002z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var GiftCardIcon = function GiftCardIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded132);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.55 5.997a2.75 2.75 0 0 1 4.452-3.136 2.75 2.75 0 0 1 4.452 3.136H21a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h7v-1a1 1 0 0 1 1-1h.55zm2.45-2.5c.69 0 1.25.56 1.25 1.25v1.25H14a1.25 1.25 0 1 1 0-2.5zm-2.5 4h9v6h-9v-6zm1.969 7.738c.027-.078.05-.157.07-.238h1.531a4.32 4.32 0 0 1-.328 1.09c-.197.437-.763.48-1.101.141-.256-.256-.291-.651-.172-.993zm4.323-.238h-1.51a5.515 5.515 0 0 1-.758 2.177c-.2.328-.18.758.093 1.03.316.317.84.294 1.083-.082a7.008 7.008 0 0 0 1.092-3.125zm.211-9a1.25 1.25 0 1 0-1.25-1.25v1.25h1.25zM4.5 11.497a1 1 0 0 1 1-1H7a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1v-1.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var GoalsIcon = function GoalsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded133);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.707 3.293a1 1 0 0 1 0 1.414l-6.775 6.775a2.006 2.006 0 0 1-1.169 2.367 2 2 0 1 1-.245-3.782l6.775-6.774a1 1 0 0 1 1.414 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.65 3.77c.606.27.695 1.057.226 1.526-.324.323-.82.388-1.243.216a7 7 0 1 0 3.855 3.855c-.172-.424-.107-.92.216-1.243.47-.469 1.256-.38 1.525.226A9 9 0 1 1 12 3c1.3 0 2.535.275 3.65.77z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.614 6.533c.793.088.987 1.037.423 1.602-.263.262-.637.367-1.008.364H12A3.501 3.501 0 1 0 15.502 12v-.03c-.003-.37.102-.745.364-1.007.565-.564 1.514-.37 1.602.424a5.501 5.501 0 1 1-4.854-4.854z",
    "data-ppui": "true"
  })), props.children);
};

var GoldIcon = function GoldIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded134);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.81 19.348c-1.908-.41-3.35-1.223-4.322-2.44-.961-1.23-1.454-2.817-1.48-4.764-.012-1.268.218-2.414.692-3.439A6.825 6.825 0 0 1 7.736 6.17c.884-.666 1.908-1.095 3.074-1.287V3h2.42v1.883c1.307.243 2.42.736 3.343 1.479.935.73 1.64 1.825 2.113 3.285h-2.344a4.097 4.097 0 0 0-1.71-1.921c-.755-.461-1.639-.692-2.65-.692-.73 0-1.39.135-1.979.404-.576.256-1.018.544-1.326.864a4.975 4.975 0 0 0-1.056 1.69c-.205.59-.307 1.288-.307 2.094 0 .577.09 1.191.268 1.845.193.64.455 1.159.788 1.556.525.602 1.076 1.03 1.652 1.287.576.256 1.23.384 1.96.384 1.357 0 2.395-.243 3.112-.73.448-.307.787-.66 1.018-1.057.23-.41.384-.89.46-1.44h-3.65v-2.056h6.071c0 1.358-.121 2.459-.365 3.304a5.077 5.077 0 0 1-1.19 2.152 6.21 6.21 0 0 1-1.902 1.383 6.888 6.888 0 0 1-2.325.634V21H10.81v-1.652z",
    "data-ppui": "true"
  })), props.children);
};

var GourmetFoodIcon = function GourmetFoodIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded135);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.896a4.002 4.002 0 0 1 3.01-3.877c.535-.136.99.325.99.877v6c0 .023 0 .046-.002.069v6.285a.75.75 0 0 1-1.5 0v-5.646A4.001 4.001 0 0 1 18 8.896zM2 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a2 2 0 0 1-1.25 1.855v6.395a.75.75 0 0 1-1.5 0v-6.395A2 2 0 0 1 2 10V6zm10 11a5 5 0 1 0 0-10 5 5 0 0 0 0 10z",
    "data-ppui": "true"
  })), props.children);
};

var GrantsIcon = function GrantsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded136);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.828 2a2 2 0 0 0-1.414.586L5.585 7.414A2 2 0 0 0 5 8.828V21a1 1 0 0 0 1 1h8.999v-.003a.988.988 0 0 0 .54-.218l1.917-1.533 1.917 1.533a1 1 0 0 0 1.624-.78V15.33A4.502 4.502 0 0 0 19 8.256V3a1 1 0 0 0-1-1h-6.171zM19 9.901a2.997 2.997 0 0 1 .498 4.837 2.99 2.99 0 0 1-1.998.762 2.99 2.99 0 0 1-2.086-.843A3 3 0 0 1 19 9.9zM17.5 17a4.48 4.48 0 0 1-2.086-.511v3.47l2.042-1.634 2.041 1.633v-3.425A4.482 4.482 0 0 1 17.5 17zm-9.75-4.5H13c0 .526.09 1.03.256 1.5H7.75a.75.75 0 0 1 0-1.5zm6.164 3H7.75a.75.75 0 0 0 0 1.5h6.164v-1.5zm0 3H7.75a.75.75 0 0 0 0 1.5h6.164v-1.5zM11 8V4.125L7.125 8h3.874z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HandbagsIcon = function HandbagsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded137);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.304 9h1.695V8a5 5 0 1 1 10 0v1h1.696a1 1 0 0 1 .701.288l2.307 2.272a1 1 0 0 1 .246 1.033l-2.615 7.727a1 1 0 0 1-.947.68H5.612a1 1 0 0 1-.948-.68L2.05 12.593a1 1 0 0 1 .245-1.033l2.307-2.272A1 1 0 0 1 5.304 9zm10.295-1v1H8.4V8a3.6 3.6 0 1 1 7.2 0zM7 11.75a.75.75 0 0 0-1.5 0 6.5 6.5 0 1 0 13 0 .75.75 0 0 0-1.5 0 5 5 0 0 1-10 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HealthIcon = function HealthIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded138);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.1 5a5.022 5.022 0 0 1-.099-.999V3a1 1 0 0 1 1-1h7.998a1 1 0 0 1 1 1v1.001c0 .342-.034.676-.1 1H18a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.1zm1.546 0a3.5 3.5 0 0 1-.145-.999V3.5h6.998v.501a3.509 3.509 0 0 1-.145 1 3.5 3.5 0 0 1-6.708 0zm4.85 5.747a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2.25h-2.25a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.25v2.249a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.25h2.25a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2.25v-2.25z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HelpIcon = function HelpIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded139);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zm-1.5 0a7.48 7.48 0 0 1-.532 2.78l-2.323-.926A4.986 4.986 0 0 0 17 12c0-.701-.144-1.369-.405-1.974l2.298-.987c.39.908.607 1.91.607 2.961zm-4.72-6.968A7.48 7.48 0 0 0 12 4.5a7.476 7.476 0 0 0-2.961.607l.987 2.298A4.984 4.984 0 0 1 12 7c.655 0 1.28.126 1.854.355l.927-2.323zm-.806 11.563l.987 2.298c-.908.39-1.91.607-2.961.607-.982 0-1.92-.189-2.78-.532l.926-2.323A4.986 4.986 0 0 0 12 17c.701 0 1.369-.144 1.974-.405zm-6.57-2.62A4.984 4.984 0 0 1 7 12c0-.655.126-1.28.355-1.854L5.032 9.22A7.48 7.48 0 0 0 4.5 12c0 1.052.216 2.053.607 2.961l2.298-.987zM15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HideIcon = function HideIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded140);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.718 2.222a.75.75 0 0 1 0 1.06L3.286 20.714a.75.75 0 0 1-1.062-1.06l2.723-2.722C3.075 15.134 2 13.02 2 12c0-1.969 4-8 10-8 1.724 0 3.283.495 4.63 1.25l3.027-3.028a.75.75 0 0 1 1.06 0zM12 7c.834 0 1.621.204 2.313.566l-1.137 1.137a3.5 3.5 0 0 0-4.474 4.474l-1.136 1.136A5 5 0 0 1 12 7z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.374 18.747C8.72 19.503 10.277 20 12 20c6 0 10-6 10-8 0-1.036-1.073-3.145-2.941-4.937l-2.625 2.624a5 5 0 0 1-6.747 6.747l-2.313 2.313z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.824 15.297a3.5 3.5 0 0 0 4.474-4.474l-4.474 4.474z",
    "data-ppui": "true"
  })), props.children);
};

var HomeIcon = function HomeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded141);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.133 12.547a1 1 0 0 0 1.414-1.414l-8.84-8.84a1 1 0 0 0-1.414 0l-8.84 8.84a1 1 0 1 0 1.414 1.414L4 12.414V21a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8.586l.133.133zM10 15a2 2 0 1 1 4 0v5.5h-4V15z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HomeownerIcon = function HomeownerIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded142);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.57 11.5a5.009 5.009 0 0 0 1.014-1.5h1.208a.5.5 0 0 0 .354-.146l.5-.5a.5.5 0 0 1 .707 0l.5.5a.5.5 0 0 0 .354.146h.585a.5.5 0 0 0 .354-.146l.5-.5a.5.5 0 0 1 .707 0l.5.5a.5.5 0 0 0 .354.146h.641a.5.5 0 0 0 .277-.084l2.25-1.5a.5.5 0 0 0 0-.832l-1.872-1.248A2 2 0 0 0 18.394 6h-6.81a5.001 5.001 0 1 0-5.91 6.823l-2.97 2.97a1 1 0 0 0 0 1.414l3.836 3.836a1 1 0 0 0 1.414 0L9.497 19.5h4.661a4 4 0 0 0 2.807-1.15l4.725-4.653a1 1 0 0 0 .015-1.41l-.587-.604a3 3 0 0 0-4.273-.03L13.997 14.5v-2a1 1 0 0 0-1-1H10.57zm1.927 3h-2.75a.75.75 0 0 0 0 1.5h4.239a1.5 1.5 0 0 0 1.072-.44l2.848-2.847a1.493 1.493 0 0 1 .926-.433c.434-.04.882.11 1.21.448l.241.249-4.37 4.304a2.5 2.5 0 0 1-1.755.719H8.876l-1.629 1.629L4.12 16.5l2.767-2.768A2.5 2.5 0 0 1 8.654 13h3.843v1.5zM7 8a1.499 1.499 0 1 1-2.998 0A1.499 1.499 0 0 1 7 8z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HoneyIcon = function HoneyIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded143);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.43 18.791c.713.03 1.454-.494 2.036-1.17.311-.353 1.213.132 1.002.606C19.787 19.709 18.423 21 16.87 21c-1.754-.01-2.716-1.16-2.716-2.874V14c0-.444-.221-.746-.682-.746-1.975 0-3.429 5.062-3.57 6.777-.04.575-.861.706-1.302.695-.391-.01-1.063-.14-1.113-.635 0-3.489 0-5.648.01-9.147-1.183-.06-2.526-.403-3.368-1.3-1.023-1.09-.803-2.693.711-3.087.13-.04.27.03.32.161.402.949 1.274 2.542 2.357 2.703 0-.464 0-1.35-.01-1.815-.03-6.04 8.04-5.87 7.89-1.069-.09 2.824-3.148 4.064-5.354 4.407v4.417c.742-2.016 1.745-4.467 4.27-4.367 1.455.102 2.226 1.16 2.357 2.482.05.443.05.897.04 1.35v2.37l-.001.144c-.006.575-.015 1.423.723 1.45zM10.745 4.874c-.491.585-.652 1.573-.682 2.32-.012.396-.013.869-.014 1.329-.001.31-.002.616-.006.889 1.153-.303 2.176-1.19 2.727-2.27.26-.493.41-1.2.3-1.774-.23-1.18-1.634-1.311-2.325-.494z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HourglassIcon = function HourglassIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded144);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1v.325C7 9.907 9.239 12 12 12c-2.761 0-5 2.093-5 4.675V17H6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-1v-.325C17 14.093 14.761 12 12 12c2.761 0 5-2.093 5-4.675V7h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6zm.5 1.5v2h11v-2h-11zm0 17v-2h11v2h-11z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HouseholdSuppliesIcon = function HouseholdSuppliesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded145);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.18a1 1 0 0 1-.803.98l-.944.19V6c0 .921.174 1.515.385 1.853.193.31.404.397.613.397a.75.75 0 0 1 0 1.5c-.791 0-1.455-.412-1.886-1.103-.413-.662-.612-1.568-.612-2.647V4.65l-1.655.33A1 1 0 0 1 13.9 5h.1v4l2.6 3.467a2 2 0 0 1 .4 1.2V21a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.333a2 2 0 0 1 .4-1.2L8 9V5H6a1 1 0 0 1-1-1V3z",
    "data-ppui": "true"
  })), props.children);
};

var HouseholdIcon = function HouseholdIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded146);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 4a1 1 0 0 1 1 1v1.846c0 1.37.57 2.65 1.135 3.916.139.312.277.622.407.933.042.1.08.202.117.305H21c.553 0 1.007.45.939.998A8.001 8.001 0 0 1 14 20H5.056A1.056 1.056 0 0 1 4 18.944c0-.3-.131-.583-.339-.8A5.98 5.98 0 0 1 2.001 14c0-.816.163-1.595.458-2.305.13-.31.268-.621.407-.933C3.43 9.495 4 8.215 4 6.846V5a1 1 0 0 1 1-1h6zm4.127 14.403A6.534 6.534 0 0 1 14 18.5m1.127-.097a6.508 6.508 0 0 0 5.2-4.903H7.674a6.512 6.512 0 0 0 4.567 4.76c.56.156 1.15.24 1.76.24",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HumanServicesIcon = function HumanServicesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded147);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.143 6.005c.663-.539 1.678-1.006 3.209-1.006 3.76 0 5.79 3.94 3.98 8-.737 1.668-2.102 3.258-3.56 4.5-1.768 1.506-3.675 2.5-4.77 2.5-1.097 0-3.003-.999-4.77-2.508-1.457-1.242-2.82-2.83-3.56-4.492-1.81-4.06.22-8 3.98-8 1.67 0 2.728.557 3.382 1.156a3.75 3.75 0 0 1 .896 1.23l.016.035.007.016c.018.042.08.042.098 0l.015-.037.007-.015.032-.07a3.783 3.783 0 0 1 1.038-1.31zm-5.22 10.099c.232.208.47.408.71.599.746.591 1.482 1.06 2.118 1.374.677.335 1.096.421 1.25.421.156 0 .576-.087 1.254-.42.637-.314 1.373-.782 2.12-1.372.24-.19.476-.389.707-.596a5.009 5.009 0 0 0-2.622-1.895 2.812 2.812 0 1 0-2.92 0 5.01 5.01 0 0 0-2.617 1.889z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var HumanIcon = function HumanIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded148);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.813 4.812a2.812 2.812 0 0 1-1.352 2.405A5.002 5.002 0 0 1 17 12v2.111a.89.89 0 0 1-.89.889H15v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-6H7.888A.889.889 0 0 1 7 14.111V12a5.002 5.002 0 0 1 3.54-4.783 2.812 2.812 0 1 1 4.273-2.404z",
    "data-ppui": "true"
  })), props.children);
};

var HungerIcon = function HungerIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded149);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.704 5.402a1.25 1.25 0 0 1 0-1.768l.353-.354a.75.75 0 0 0-1.06-1.06l-.354.353a2.75 2.75 0 0 0 0 3.89l.353.353a.75.75 0 1 0 1.061-1.06l-.354-.354zm-3.559 0a1.25 1.25 0 0 1 0-1.768l.354-.354a.75.75 0 0 0-1.061-1.06l-.354.353a2.75 2.75 0 0 0 0 3.89l.354.353a.75.75 0 1 0 1.06-1.06l-.353-.354zm7-1.768a1.25 1.25 0 0 0 0 1.768l.354.353a.75.75 0 1 1-1.061 1.06l-.354-.353a2.75 2.75 0 0 1 0-3.889l.354-.353a.75.75 0 0 1 1.06 1.06l-.353.354z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 8c.552 0 1.007.45.938.998a7.944 7.944 0 0 1-.644 2.293c.67.073 1.318.37 1.825.892l.587.605a1 1 0 0 1-.016 1.409l-4.724 4.653A4 4 0 0 1 14.159 20H9.498l-1.543 1.543a1 1 0 0 1-1.414 0l-3.836-3.836a1 1 0 0 1 0-1.414l3.121-3.121.038-.038a7.965 7.965 0 0 1-1.802-4.136C3.993 8.45 4.448 8 5 8h14zm-5.005 8.5a1.5 1.5 0 0 0 1.06-.44l2.847-2.847a1.501 1.501 0 0 1 2.141.015l.24.249-4.37 4.304a2.5 2.5 0 0 1-1.754.719H8.877l-1.63 1.629-.001-.002-.002.002L4.115 17l2.768-2.768a2.5 2.5 0 0 1 1.768-.732h3.843V15H9.748a.75.75 0 0 0 0 1.5h4.248z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var InFlightIcon = function InFlightIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded150);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-.675.946L10.482 13H16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-3.25v4.5h2.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.5V16H9c-.02 0-.039 0-.058-.002a1 1 0 0 1-.96-.741L5.043 4.294A.997.997 0 0 1 5 3.904V3z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5.5a3.5 3.5 0 1 1 7 0v2a3.5 3.5 0 1 1-7 0v-2zm5.5 0v2a2 2 0 1 1-4 0v-2a2 2 0 1 1 4 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var IndustrialIcon = function IndustrialIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded151);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.999 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4v.765l-4 2.667V5h-4a1 1 0 0 1-1-1V3zm5 7.235v2.197l4-2.667V7.568l-4 2.667zm0 4l4-2.667v2.197l-4 2.667v-2.197zm0 4V19l1.566 2.74a.5.5 0 0 0 .868 0L14 19v-3.432l-4 2.667z",
    "data-ppui": "true"
  })), props.children);
};

var InformationSmIcon = function InformationSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded152);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 9A7 7 0 1 1 2 9a7 7 0 0 1 14 0zm-7.537 3.969h1.072c.146 0 .224-.078.224-.224V8.193c0-.146-.078-.224-.224-.224H8.463c-.147 0-.225.078-.225.224v4.552c0 .146.078.224.225.224zM9 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var InformationIcon = function InformationIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded153);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zm-9.662 5h1.32c.18 0 .276-.096.276-.276v-5.925c0-.18-.096-.276-.276-.276h-1.32c-.18 0-.276.096-.276.276v5.925c0 .18.096.276.276.276zM12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var InsightsIcon = function InsightsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded154);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5zm1.5 8.44v2.12l3.5-3.5 1.47 1.47a.75.75 0 0 0 1.06 0l5.474-5.473v2.787a.75.75 0 0 0 1.496.078v-4.75a.75.75 0 0 0-.74-.672h-4.606A.75.75 0 0 0 13.16 7h2.78L11 11.94l-1.47-1.47a.75.75 0 0 0-1.06 0L5.5 13.44z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var InstallmentsIcon = function InstallmentsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded155);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 7H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3zm1.5 0h3v-.75a.75.75 0 0 1 1.5 0V7h3a1 1 0 0 1 1 1v7.5h2.5v-11h-11V7zm-4 1.5H7v.75a.75.75 0 1 0 1.5 0V8.5h3v.75a.75.75 0 0 0 1.5 0V8.5h2.5V12h-11V8.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var InsuranceIcon = function InsuranceIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded156);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.792 11.293l-2.623 3.418-1.01-1.037a.75.75 0 1 0-1.075 1.046l1.413 1.452a1 1 0 0 0 1.51-.089l2.975-3.877a.75.75 0 1 0-1.19-.913z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5zm12.629 7.992a1 1 0 0 0 1.193-1.581l-5.117-5.118a1 1 0 0 0-1.415 0L6.172 11.41a1 1 0 0 0 1.194 1.58V17a1 1 0 0 0 1 1h7.263a1 1 0 0 0 1-1v-4.008z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var InsuredIcon = function InsuredIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded157);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.501 10.503v-.5a1.5 1.5 0 0 0-3 0v.5h3zM11 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.001 22.004c.12 0 .24-.028.347-.081 1.536-.765 7.653-4.306 7.653-11.015V5.659c0-.383-.344-.699-.784-.725-4.106-.248-5.464-1.525-6.607-2.68-.337-.34-.947-.336-1.278.009-1.11 1.157-2.472 2.474-6.547 2.722-.441.027-.784.342-.784.725v5.247c0 6.665 6.116 10.202 7.653 10.966a.78.78 0 0 0 .347.081zm3-11.501a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4.5a1 1 0 0 1 1-1v-.5a3 3 0 1 1 6 0v.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var InternationalIcon = function InternationalIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded158);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.998 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zM5.036 9.21a.406.406 0 0 0 .16.088c.374.101.716.502 1.107.96.722.843 1.61 1.883 3.174 1.603 1.52-.278 1.648-1.43 1.766-2.482.1-.896.192-1.72 1.127-1.873 1.592-.26 2.473-1.7 2.784-2.312A7.503 7.503 0 0 0 5.034 9.21zM12.08 19.5a7.5 7.5 0 0 0 7.083-9.722c-1.182.311-1.77.838-2.914 1.866-.263.236-.555.498-.89.79-1.135.988-.873 2.005-.641 2.903.166.645.316 1.229-.077 1.697-.334.394-.861.804-1.351 1.186-.667.52-1.264.984-1.21 1.28z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var InternetIcon = function InternetIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded159);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.456 5.93c-.476.323-.536.991-.158 1.425.346.397.941.456 1.379.164A14.93 14.93 0 0 1 12 5c3.079 0 5.942.928 8.323 2.52.438.292 1.033.232 1.38-.165.377-.433.317-1.101-.159-1.425A16.92 16.92 0 0 0 12 3C8.462 3 5.177 4.08 2.456 5.93zm15.747 3.795c.5.303.567.989.182 1.43-.338.387-.916.456-1.36.197A9.954 9.954 0 0 0 12 10a9.954 9.954 0 0 0-5.024 1.352c-.444.259-1.023.19-1.36-.197-.385-.44-.319-1.127.182-1.43A11.944 11.944 0 0 1 12 8c2.27 0 4.393.63 6.203 1.725zm-3.165 5.263c.401-.458.302-1.172-.257-1.414a6.978 6.978 0 0 0-2.78-.574c-.989 0-1.93.205-2.782.574-.558.242-.657.956-.257 1.415l.039.044c.312.358.83.436 1.276.272A4.99 4.99 0 0 1 12.001 15a5 5 0 0 1 1.723.305c.445.163.963.085 1.276-.272l.038-.045zM12 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    "data-ppui": "true"
  })), props.children);
};

var InvestIcon = function InvestIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded160);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2.5a1 1 0 0 1-1-1V5zm-12 4a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2.5a1 1 0 0 1-1-1V9zm7 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.5a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-2.5z",
    "data-ppui": "true"
  })), props.children);
};

var InvoiceIcon = function InvoiceIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded161);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3zm2 9.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75zm.75 2.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5zM12 18.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75zM13 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var JewelryIcon = function JewelryIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded162);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.935 6.596l.742-1.113a1 1 0 0 0 .063-1.002l-.465-.928A1 1 0 0 0 14.381 3H9.617a1 1 0 0 0-.894.553l-.464.928a1 1 0 0 0 .062 1.002l.742 1.113A7.502 7.502 0 0 0 12 21a7.5 7.5 0 0 0 2.936-14.404zM9.914 7.872l1.253 1.88a1 1 0 0 0 1.664 0l1.253-1.88A6.002 6.002 0 0 1 12 19.5 6 6 0 0 1 9.914 7.872z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var JusticeIcon = function JusticeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded163);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 2.75a.75.75 0 0 0-1.5 0V4h-6.5a.75.75 0 0 0 0 1.5H6L2 15a4 4 0 0 0 8 0L6 5.5h5.25v15h-2.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-2.5v-15H18L14 15a4 4 0 0 0 8 0l-4-9.5h1.25a.75.75 0 0 0 0-1.5h-6.5V2.75zM8.371 15L6 9.365 3.627 15h4.745zm12 0L18 9.365 15.627 15h4.745z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LaptopIcon = function LaptopIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded164);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1V6zm13.25 1a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5h10.5zM10 16.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LawnIcon = function LawnIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded165);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.748 2A.748.748 0 0 0 3 2.748V10a1 1 0 0 0 1 1h4.748v10.25a.75.75 0 0 0 1.5 0V11h4.753a1 1 0 0 0 1-1V2.748a.748.748 0 0 0-1.497 0V8h-1.38V2.748a.748.748 0 0 0-1.496 0V8h-1.38V2.748a.748.748 0 1 0-1.496 0V8h-1.38V2.748a.748.748 0 1 0-1.495 0V8h-1.38V2.748A.748.748 0 0 0 3.747 2z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.748 2.75a.75.75 0 0 1 1.5 0V14H21a1 1 0 0 1 1 1v.498C22 17.432 20.433 22 18.498 22c-1.934 0-3.502-4.568-3.502-6.502V15c.003-.553.452-1 1.004-1h1.748V2.75z",
    "data-ppui": "true"
  })), props.children);
};

var LeftAlignIcon = function LeftAlignIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded166);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5zm0 8a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5zm-1 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm1-9a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2H5z",
    "data-ppui": "true"
  })), props.children);
};

var LetterCheckmarkIcon = function LetterCheckmarkIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded167);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.572 13.54l-2.624 3.419-1.01-1.038a.75.75 0 1 0-1.074 1.047l1.413 1.451a1 1 0 0 0 1.51-.089l2.975-3.877a.75.75 0 1 0-1.19-.913z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.827 2a2 2 0 0 0-1.414.586L5.584 7.414A2 2 0 0 0 5 8.828V21a1 1 0 0 0 1 1h9.999c.188 0 .373-.017.552-.05A6.25 6.25 0 0 0 19 10.412V3a1 1 0 0 0-1-1h-6.172zm-1.413 10.5H7.751a.75.75 0 0 0 0 1.5h2a6.25 6.25 0 0 1 .663-1.5zm.922 1.5c.223-.56.549-1.068.955-1.5a4.735 4.735 0 0 1 3.46-1.496c1.256 0 2.398.488 3.248 1.285a4.735 4.735 0 0 1 1.5 3.463c0 1.37-.58 2.604-1.509 3.471a4.732 4.732 0 0 1-3.24 1.277c-.763 0-1.484-.18-2.123-.5a4.77 4.77 0 0 1-2.459-3 4.753 4.753 0 0 1 .168-3zm-1.829 1.5H7.751a.75.75 0 0 0 0 1.5h1.876a6.277 6.277 0 0 1-.12-1.5zm.63 3H7.752a.75.75 0 0 0 0 1.5h3.418a6.261 6.261 0 0 1-1.031-1.5zM10.999 8V4.125L7.124 8h3.875z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LightBulbIcon = function LightBulbIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded168);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.886 15.19c-.52.448-.886 1.072-.886 1.758V18a4 4 0 0 1-8 0v-1.052c0-.686-.365-1.31-.886-1.757a7.5 7.5 0 1 1 9.771 0zM14.5 16.5v1.25h-5V16.5h5zm-4.666 2.75a2.499 2.499 0 0 0 4.332 0H9.834zm.223-10.169L12 11.348l1.942-2.267a.75.75 0 0 1 1.14.976l-2.332 2.72V15h-1.5v-2.222l-2.332-2.72a.75.75 0 1 1 1.14-.977z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LikeSelectedIcon = function LikeSelectedIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded169);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.887 2.432a.753.753 0 0 1 .661-.392c.9 0 1.752.386 2.37 1.053.175.19.327.397.456.618.37.634.405 1.314.3 1.923-.103.6-.348 1.172-.596 1.652a.84.84 0 0 0 .747 1.226h4.135c.365-.003.725.079 1.053.238.33.16.62.393.85.679.23.286.397.619.493.974.095.356.118.729.067 1.094l-1.182 8.322a2.646 2.646 0 0 1-.82 1.582 2.39 2.39 0 0 1-1.643.638H7.604a.755.755 0 0 1-.21-.03H4.332c-1.052 0-1.707-.958-1.707-1.874v-8.976c0-.916.655-1.874 1.707-1.874h2.815l3.74-6.853zm-6.756 8.727c0-.138.048-.244.1-.305.05-.06.09-.063.101-.063H6.84v9.713H4.332c-.012 0-.05-.004-.1-.064a.474.474 0 0 1-.1-.305v-8.976z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LikeIcon = function LikeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded170);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.511 2a.753.753 0 0 0-.661.392L7.11 9.245H4.295c-1.053 0-1.707.958-1.707 1.875v8.975c0 .917.654 1.875 1.707 1.875h3.062c.067.02.138.03.21.03H17.74a2.391 2.391 0 0 0 1.642-.639c.449-.412.735-.976.82-1.581l1.182-8.323a2.746 2.746 0 0 0-.067-1.093 2.65 2.65 0 0 0-.493-.975 2.483 2.483 0 0 0-.85-.679 2.358 2.358 0 0 0-1.052-.237h-4.135a.84.84 0 0 1-.747-1.226c.247-.48.493-1.053.596-1.653.105-.609.069-1.289-.3-1.923a3.5 3.5 0 0 0-.457-.617A3.23 3.23 0 0 0 11.511 2zm-3.192 8.172l3.61-6.612c.312.083.605.257.846.517.098.106.186.224.26.352.142.244.182.538.118.91-.066.38-.233.795-.451 1.218-.805 1.562.329 3.422 2.086 3.422h4.149a.837.837 0 0 1 .382.087c.123.06.238.15.333.268.096.119.17.262.212.421.043.16.053.328.03.493l-1.182 8.322a1.138 1.138 0 0 1-.348.682.885.885 0 0 1-.61.242H8.32V10.172z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LinkIcon = function LinkIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded171);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.063 11.599a4.006 4.006 0 0 1-4.868.617l-.98.98a4.005 4.005 0 0 1-.616 4.867l-1.764 1.764a4.004 4.004 0 0 1-5.662-5.663l1.763-1.763a4.006 4.006 0 0 1 4.865-.62l.98-.98a4.005 4.005 0 0 1 .62-4.865l1.764-1.764a4.004 4.004 0 1 1 5.662 5.663l-1.764 1.764zm.35-3.178l-1.764 1.764a2.003 2.003 0 0 1-1.94.517l1.29-1.29a1 1 0 0 0-1.415-1.414l-1.288 1.289a2.003 2.003 0 0 1 .519-1.936l1.764-1.764a2.004 2.004 0 0 1 2.834 2.834zM7.998 14.584l1.288-1.288a2.003 2.003 0 0 0-1.935.52l-1.764 1.763a2.004 2.004 0 0 0 2.834 2.834l1.764-1.764c.525-.525.698-1.27.517-1.94l-1.29 1.29a1 1 0 0 1-1.414-1.415z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ListSimpleIcon = function ListSimpleIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded172);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4.002a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5zM5 9a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5zm0 10a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5zm-1-4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1z",
    "data-ppui": "true"
  })), props.children);
};

var LitecoinIcon = function LitecoinIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded173);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.293 10.008L15.533 2H9.267L6.224 12.489l-2.296.805L3 16.118l2.412-.83L3.464 22h16.943l1.393-4.235H11.123l1.376-4.918 2.802-.965.697-2.823-2.705.949z",
    "data-ppui": "true"
  })), props.children);
};

var LoansIcon = function LoansIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded174);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.405 7a3 3 0 1 0-5.995.172 3 3 0 1 0-1.991 5.662.951.951 0 0 0-.014.166v2l-2.848-2.848a3 3 0 0 0-4.273.031l-.587.605a1 1 0 0 0 .016 1.409l4.724 4.653A4 4 0 0 0 10.244 20h4.66l1.544 1.543a1 1 0 0 0 1.414 0l3.836-3.836a1 1 0 0 0 0-1.414l-3.122-3.121A4 4 0 0 0 15.748 12h-2.107a2.989 2.989 0 0 0 .759-2.172A3 3 0 0 0 18.405 7zm-6.5 8v-1.5h3.847a2.5 2.5 0 0 1 1.768.732L20.288 17l-3.13 3.129-.001-.002-.002.002-1.629-1.629h-5.282a2.5 2.5 0 0 1-1.754-.719l-4.371-4.304.241-.249a1.496 1.496 0 0 1 1.078-.454c.384 0 .769.145 1.062.439l2.848 2.848a1.5 1.5 0 0 0 1.06.439h4.246a.75.75 0 0 0 0-1.5h-2.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LocationIcon = function LocationIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded175);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.531 21.802C14.318 20.521 20 16.056 20 11a8 8 0 1 0-16 0c0 5.057 5.682 9.522 7.469 10.802a.908.908 0 0 0 1.062 0zM12 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LockIcon = function LockIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded176);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 9h1V8a6 6 0 1 1 12 0v1h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1zm11.5-1v1h-9V8a4.5 4.5 0 0 1 9 0zM14 14a2 2 0 0 1-1 1.732V18a1 1 0 1 1-2 0v-2.268A2 2 0 0 1 12 12a2 2 0 0 1 2 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LogoutIcon = function LogoutIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded177);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.295 15.295a1 1 0 0 0 1.414 1.414l3.995-3.995a1.01 1.01 0 0 0 0-1.428L17.71 7.29a1 1 0 1 0-1.414 1.414L18.59 11H8a1 1 0 1 0 0 2h10.59l-2.295 2.295z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H5v14h6z",
    "data-ppui": "true"
  })), props.children);
};

var LoyaltyCardIcon = function LoyaltyCardIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded178);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.001 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h17.997a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3.001zm5.223 3.38a.5.5 0 0 0-.949 0l-.67 2.004-2.113.019a.5.5 0 0 0-.293.901l1.698 1.257-.635 2.015a.5.5 0 0 0 .768.557l1.72-1.226 1.72 1.226a.5.5 0 0 0 .767-.557l-.635-2.015 1.698-1.257a.5.5 0 0 0-.293-.901l-2.113-.02-.67-2.002zm4.775 1.868a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75zm.75 2.754a.75.75 0 0 0 0 1.5h5.5a.75.75 0 1 0 0-1.5h-5.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var LuggageIcon = function LuggageIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded179);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3.499v3.5H6.005a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h1.514a1.75 1.75 0 1 0 3.465 0h2.035a1.75 1.75 0 1 0 3.465 0h1.521a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-3.003v-3.5h1.25a.75.75 0 0 0 0-1.5h-8.5a.75.75 0 1 0 0 1.5H9zm1.5 0v3.5h3v-3.5h-3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MedicalIcon = function MedicalIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded180);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.003 3v2h-4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4V3a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1zm1.5.5V5h7V3.5h-7zm3.995 3.75a1 1 0 0 1 1 1v2.25h2.25a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2.25v2.25a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V13.5h-2.25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2.25V8.25a1 1 0 0 1 1-1h1z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MembershipsIcon = function MembershipsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded181);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3zm11.75 10.5a.75.75 0 0 0 0 1.5h4.498a.75.75 0 0 0 0-1.5H14.75zm1.826-7.74a.5.5 0 0 1 .948 0l.54 1.61 1.699.016a.5.5 0 0 1 .293.902l-1.366 1.011.51 1.62a.5.5 0 0 1-.766.558l-1.384-.986-1.384.986a.5.5 0 0 1-.767-.557l.51-1.621-1.365-1.011a.5.5 0 0 1 .293-.902l1.7-.015.539-1.612zm-6.325 2.49c0 .815-.433 1.528-1.082 1.923A4.002 4.002 0 0 1 12.001 16v.444a.556.556 0 0 1-.556.556H4.556A.556.556 0 0 1 4 16.444V16a4.002 4.002 0 0 1 2.832-3.827A2.249 2.249 0 0 1 8 8a2.25 2.25 0 0 1 2.25 2.25z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MemorialsIcon = function MemorialsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded182);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7a2 2 0 1 1-4 0c0-1.105.895-5 2-5s2 3.895 2 5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.938V10a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v4.938H5.938c-.553 0-1.008.45-.93.997A7.061 7.061 0 0 0 8 20.759V21a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-.241a7.061 7.061 0 0 0 2.992-4.824c.078-.547-.377-.997-.93-.997H16z",
    "data-ppui": "true"
  })), props.children);
};

var MenuIcon = function MenuIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded183);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5zm-1 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm0 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1z",
    "data-ppui": "true"
  })), props.children);
};

var MerchantIcon = function MerchantIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded184);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.345 4.835l1.286 2.572c.213.426.444 1.085.3 1.843a3.991 3.991 0 0 1-.93 1.896V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7.857a3.991 3.991 0 0 1-.928-1.894c-.143-.757.086-1.415.298-1.84l1.284-2.573A1.51 1.51 0 0 1 6.006 4h11.988a1.51 1.51 0 0 1 1.35.835zm-1.342.67l1.287 2.573c.139.278.225.587.167.892a2.5 2.5 0 0 1-4.955-.47 2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1-4.955.47c-.058-.305.028-.614.166-.891l1.284-2.573L6 5.5h12l.003.006zM7 15a2 2 0 1 1 4 0v3.5H7V15zm7-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MessageCenterIcon = function MessageCenterIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded185);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 10h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-5.445l-2.904 2.492A1 1 0 0 1 11 20.733V19h-1a1 1 0 0 1-1-1v-4H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6zM3.5 6.018V4.5h.386L11 8.769 18.114 4.5h.386v1.518l-6.986 4.191a1 1 0 0 1-1.028 0L3.5 6.018zm9 11.482h-2v-6h10v6H15l-2.5 2.145V17.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MessageIcon = function MessageIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded186);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.999 5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1.65.76L12.03 18H21a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3zM5 9.719a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75zm.75 2.75a.75.75 0 1 0 0 1.5h12.5a.75.75 0 0 0 0-1.5H5.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MgmIcon = function MgmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded187);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23 5.825a3.726 3.726 0 0 1-.323-.609C4.822 5 4.81 4.86 4.823 4.787v-.004c.005-.026.012-.065.125-.124.16-.082.505-.18 1.173-.18h7.302l2.856 5.867a.993.993 0 0 0 .897.544h2.795c.528 0 .95-.392.985-.874.183-2.57-.217-4.29-.892-5.399C19.384 3.501 18.409 3 17.563 3H6.121c-.788 0-1.432.108-1.919.36-.528.272-.831.695-.918 1.182-.078.44.034.866.16 1.189.126.32.295.613.432.83l2.067 3.92c.193.366.662.514 1.047.331a.722.722 0 0 0 .349-.992L5.245 5.85l-.015-.025z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.597 12.128H4.357c-1.165 0-1.477.408-1.319 1.502l.909 6.217.005.035c.126.874.161 1.118 1.109 1.118h10.536v-8.872zm-5.548 3.095c0 .595-.401 1.101-.96 1.289v1.179a.468.468 0 0 1-.48.455.468.468 0 0 1-.48-.455v-1.18c-.56-.187-.961-.693-.961-1.288 0-.755.645-1.367 1.44-1.367.796 0 1.44.612 1.44 1.367z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.854 12.128h-2.806V21h2.806c.95 0 .948-.118.937-.865a18.77 18.77 0 0 1-.002-.288v-6.654l.002-.287c.011-.731.012-.778-.938-.778z",
    "data-ppui": "true"
  })), props.children);
};

var MicrophoneIcon = function MicrophoneIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded188);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2a4 4 0 0 0-4 4v3H5.91a.91.91 0 0 0-.91.91V12a7.001 7.001 0 0 0 6.238 6.959V20.5H8.75a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-2.488v-1.541A7.001 7.001 0 0 0 19 12V9.91a.91.91 0 0 0-.91-.91H16V6a4 4 0 0 0-4-4zm-4 8.5V12a4 4 0 0 0 8 0v-1.5h1.5V12a5.5 5.5 0 1 1-11 0v-1.5H8z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MilitaryIcon = function MilitaryIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded189);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.163 8.598l-3.121 2.23a6 6 0 1 1-6.084 0l-3.12-2.23A2 2 0 0 1 5 6.971V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3.97a2 2 0 0 1-.837 1.628zm-5.689 3.818a.5.5 0 0 0-.948 0l-.67 2.003-2.113.019a.5.5 0 0 0-.293.901l1.698 1.257-.635 2.015a.5.5 0 0 0 .767.557L12 17.942l1.72 1.226a.5.5 0 0 0 .767-.557l-.635-2.015 1.698-1.257a.5.5 0 0 0-.293-.901l-2.112-.02-.67-2.002z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MoveIcon = function MoveIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded190);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.707 6.707a1 1 0 0 1-1.414 0L13 5.414V11h5.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l2.993 2.993a1.01 1.01 0 0 1 0 1.428l-2.993 2.993a1 1 0 0 1-1.414-1.414L18.586 13H13v5.586l1.293-1.293a1 1 0 1 1 1.414 1.414L12.714 21.7a1.01 1.01 0 0 1-1.428 0l-2.993-2.993a1 1 0 1 1 1.414-1.414L11 18.586V13H5.414l1.293 1.293a1 1 0 1 1-1.414 1.414L2.3 12.714a1.01 1.01 0 0 1 0-1.428l2.993-2.993a1 1 0 0 1 1.414 1.414L5.414 11H11V5.414L9.707 6.707a1 1 0 1 1-1.414-1.414L11.286 2.3a1.01 1.01 0 0 1 1.428 0l2.993 2.993a1 1 0 0 1 0 1.414z",
    "data-ppui": "true"
  })), props.children);
};

var MovieIcon = function MovieIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded191);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.483 7.068a1 1 0 0 1 .707-1.225l1.981-.53L4.24 8.659a1.003 1.003 0 0 0-.498-.625l-.258-.966zm2.616 1.37L8.22 4.763 11 4.018 8.88 7.693l-2.781.745zm4.829-1.294l2.122-3.675 2.78-.745L13.71 6.4l-2.782.745zm4.83-1.294l2.112-3.66a1 1 0 0 1 1.067.737l.26.966a1 1 0 0 1-.708 1.225l-2.73.732z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 10a1 1 0 0 1 .32-.732L7.051 12h2.12l-3-3H19a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9zm10.173 2h-2.121l-3-3h2.12l3 3zm4.987-.013A1.004 1.004 0 0 1 19 12h-1.948l-3-3h2.12l2.988 2.987z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MusicIcon = function MusicIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded192);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 4a1 1 0 0 0-1 1v9.535A4 4 0 1 0 10 18V8h10v4.535A4 4 0 1 0 22 16V5a1 1 0 0 0-1-1H9z",
    "data-ppui": "true"
  })), props.children);
};

var MusicalInstrumentsIcon = function MusicalInstrumentsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded193);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h17.997a1 1 0 0 0 1-1V8.085C21.998 8.057 22 8.029 22 8V6a1 1 0 0 0-1-1H3zm12.131 8V9h-1.633v4a1 1 0 0 1-.747.968v.658a573.018 573.018 0 0 0 .003 2.874h3.125l-.002-.482c-.002-.61-.002-1.456-.001-2.394v-.657a1 1 0 0 1-.745-.967zm2.245.97v.656a573.018 573.018 0 0 0 .003 2.874h3.117V9h-2.365v4a1 1 0 0 1-.755.97zM10.502 13a1 1 0 0 0 .75.968l-.001.656a576.798 576.798 0 0 0 .003 2.876H8.13l-.002-.487a573.56 573.56 0 0 1-.001-2.387v-.658A1 1 0 0 0 8.873 13V9h1.63v4zM6.63 17.5H3.5V9h2.378v4a1 1 0 0 0 .748.968v.656a575.361 575.361 0 0 0 .003 2.876z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var MuteIcon = function MuteIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded194);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.715 2.223a.75.75 0 0 1 0 1.061L3.283 20.716a.75.75 0 0 1-1.062-1.06L5.877 16H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h4l5.342-4.663C12.99 2.772 14 3.232 14 4.09v3.787l5.654-5.654a.75.75 0 0 1 1.06 0zM8.665 17.454l3.677 3.212c.647.565 1.658.106 1.658-.753V12.12l-5.335 5.335z",
    "data-ppui": "true"
  })), props.children);
};

var NavigateIcon = function NavigateIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded195);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73 14.27l-7.123-3.068c-.819-.352-.806-1.518.02-1.854l17.884-7.254c.154-.062.318-.094.484-.094C21.55 2 22 2.45 22 3.005c0 .166-.032.33-.094.484l-7.254 17.884c-.336.826-1.502.839-1.854.02L9.73 14.27z",
    "data-ppui": "true"
  })), props.children);
};

var NightIcon = function NightIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded196);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.901 16.8c.14-.214-.115-.46-.344-.345A8.267 8.267 0 0 1 9.8 3.435c.173-.188.01-.5-.235-.427A9.19 9.19 0 0 0 3 11.814a9.186 9.186 0 0 0 16.901 4.987z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var NoIconIcon = function NoIconIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded197);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 6v11.998h11.998V5.999H5.999zM5 4a1 1 0 0 0-1 1v13.997a1 1 0 0 0 1 1h13.997a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var NotificationPreferencesIcon = function NotificationPreferencesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded198);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.313 13.751a2.254 2.254 0 1 0 0-4.508 2.254 2.254 0 0 0 0 4.508z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.998 3.997a2 2 0 0 0-4 0v.341c-2.33.824-4 3.047-4 5.66v6h-1a1 1 0 1 0 0 2l14-.001a1 1 0 0 0 .888-1.46.758.758 0 0 0 .102-.139l1.907-3.302a.76.76 0 0 0-.278-1.038l-.971-.56.971-.561a.76.76 0 0 0 .278-1.039L19.99 6.596a.76.76 0 0 0-1.038-.278l-.972.56v-1.12a.76.76 0 0 0-.76-.76h-1.904a5.98 5.98 0 0 0-1.317-.66v-.34zm.148 3.932V6.497h2.333V7.93l.428.203c.182.087.356.188.52.301l.391.27 1.242-.716 1.167 2.02-1.242.717.038.472a3.785 3.785 0 0 1 0 .602l-.038.473 1.24.716-1.166 2.02-1.241-.716-.39.27a3.718 3.718 0 0 1-.52.3l-.429.204v1.432h-2.333v-1.432l-.428-.204a3.712 3.712 0 0 1-.52-.3l-.39-.27-1.242.716-1.167-2.02 1.241-.717-.038-.472a3.787 3.787 0 0 1 0-.602l.038-.472-1.24-.717 1.166-2.02 1.242.716.39-.27c.164-.113.338-.214.52-.3l.428-.204z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 21.997a3 3 0 0 1-2.959-2.5h5.917a3 3 0 0 1-2.958 2.5z",
    "data-ppui": "true"
  })), props.children);
};

var NotificationIcon = function NotificationIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded199);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a2 2 0 0 1 2 2v.341c2.33.824 4 3.047 4 5.659v6h1a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h1v-6a6.003 6.003 0 0 1 4-5.659V4a2 2 0 0 1 2-2zM9.041 19.5a3 3 0 0 0 5.918 0H9.04z",
    "data-ppui": "true"
  })), props.children);
};

var NumberPadIcon = function NumberPadIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded200);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6zm5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2zm4 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zM6 8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H6zm4 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9zm6-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2zM5 14a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2zm6-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2zm4 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2zm-4 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2z",
    "data-ppui": "true"
  })), props.children);
};

var NumberedListIcon = function NumberedListIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded201);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.368 11h1.368c.18 0 .276-.096.276-.276V2.696c0-.18-.096-.276-.276-.276H6.572c-.156 0-.252.072-.312.228-.324.792-1.032 1.26-2.028 1.26-.168 0-.24.096-.24.276v.804c0 .18.096.276.276.276h1.824v5.46c0 .18.096.276.276.276zM12 4.002a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7zM12 9a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7zm0 10a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7zm-1-4a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1zm-1.891 6H3.3c-.18 0-.276-.096-.276-.276v-1.068a.39.39 0 0 1 .168-.336c.96-.744 1.416-1.104 2.688-2.136 1.08-.876 1.428-1.536 1.428-2.22 0-.684-.42-1.068-1.104-1.068-.732 0-1.092.444-1.176 1.104-.012.168-.108.264-.276.264h-1.38c-.18 0-.276-.096-.264-.288.12-1.704 1.248-2.76 3.12-2.76 1.932 0 3.108 1.02 3.108 2.616 0 1.284-.828 2.316-1.98 3.192-.354.272-.646.484-.91.676-.354.257-.656.477-.986.752.264-.012.432-.012.708-.012h2.94c.18 0 .276.096.276.276v1.008c0 .18-.096.276-.276.276z",
    "data-ppui": "true"
  })), props.children);
};

var OccasionIcon = function OccasionIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded202);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75 2a.75.75 0 0 0-.75.75V4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4V2.75a.75.75 0 0 0-1.5 0V4h-3V2.75A.75.75 0 0 0 9.75 2zM5.5 5.5H9v.75a.75.75 0 0 0 1.5 0V5.5h3v.75a.75.75 0 0 0 1.5 0V5.5h3.5V10h-13V5.5zm6.974 5.916a.5.5 0 0 0-.948 0l-.67 2.003-2.113.019a.5.5 0 0 0-.293.901l1.698 1.257-.635 2.015a.5.5 0 0 0 .767.557L12 16.942l1.72 1.226a.5.5 0 0 0 .767-.557l-.635-2.015 1.698-1.257a.5.5 0 0 0-.293-.901l-2.112-.02-.67-2.002z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var OffersIcon = function OffersIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded203);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.817 3.422a1 1 0 0 0-1.635 0l-.592.841a1 1 0 0 1-1.238.332l-.933-.432a1 1 0 0 0-1.416.817L6.91 6.005a1 1 0 0 1-.905.905l-1.025.093a1 1 0 0 0-.817 1.416l.432.933a1 1 0 0 1-.332 1.238l-.84.592a1 1 0 0 0 0 1.635l.84.593a1 1 0 0 1 .332 1.237l-.432.934a1 1 0 0 0 .817 1.416l1.025.092a1 1 0 0 1 .905.906l.093 1.025a1 1 0 0 0 1.416.817l.933-.432a1 1 0 0 1 1.238.332l.592.84a1 1 0 0 0 1.635 0l.593-.84a1 1 0 0 1 1.237-.332l.934.432a1 1 0 0 0 1.416-.817l.092-1.025a1 1 0 0 1 .906-.906l1.025-.092a1 1 0 0 0 .817-1.416l-.432-.934a1 1 0 0 1 .332-1.237l.84-.593a1 1 0 0 0 0-1.635l-.84-.592a1 1 0 0 1-.332-1.238l.432-.933a1 1 0 0 0-.817-1.416l-1.025-.093a1 1 0 0 1-.906-.905l-.092-1.025a1 1 0 0 0-1.416-.817l-.934.432a1 1 0 0 1-1.237-.332l-.593-.84zm1.659 4.29a.75.75 0 0 0-1.025.274L9.25 15.264a.75.75 0 0 0 1.3.75l4.201-7.278a.75.75 0 0 0-.274-1.025zm2.04 5.788a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM9 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var OfficeSuppliesIcon = function OfficeSuppliesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded204);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 7.883a1 1 0 0 1 .876-.993l14.628-1.828A4 4 0 0 1 22 9.032V11a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-1 1h-9v2h11a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.883zM6 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var OfflineIcon = function OfflineIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded205);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.192 6.927L7.12 19H17v-.027a4.5 4.5 0 0 0 2.849-8.312 4.507 4.507 0 0 0-.657-3.734zM3.273 20.726a.75.75 0 0 1-1.055-1.067l1.569-1.569A4.5 4.5 0 0 1 6 10.027a4 4 0 0 1 6.051-3.418 4.504 4.504 0 0 1 4.661-1.444l2.945-2.945a.75.75 0 0 1 1.068 1.053l-.005.005-17.44 17.44a1.214 1.214 0 0 0-.007.008z",
    "data-ppui": "true"
  })), props.children);
};

var OnlineShoppingIcon = function OnlineShoppingIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded206);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.721 6.556h-1.889v-.612a.944.944 0 1 1 1.89 0v.612z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5h.5a2.5 2.5 0 0 0 2.47-2.88l-.914-5.945a2.5 2.5 0 0 0-1.387-1.873 3.946 3.946 0 0 0-4.035-3.3A3.544 3.544 0 0 0 15.501 2H6zm13.926 12.405a.995.995 0 0 1-.426.095h-7.447a1 1 0 0 1-.988-1.152l.915-5.945a1 1 0 0 1 .988-.847h.364v-.612a2.444 2.444 0 1 1 4.89 0v.612h.363a.997.997 0 0 1 .989.847l.914 5.945a1 1 0 0 1-.562 1.057zM11.998 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var OnlineIcon = function OnlineIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded207);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.849 10.66a4.5 4.5 0 0 0-7.799-4.05A4 4 0 0 0 6 10.027a4.5 4.5 0 0 0 1 8.946V19h10v-.027a4.5 4.5 0 0 0 2.849-8.312z",
    "data-ppui": "true"
  })), props.children);
};

var OpenBrowserIcon = function OpenBrowserIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded208);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 16.75V7.254h17v9.496H15v1.5h6a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6.007v-1.5H3.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.038a1 1 0 0 1-1-1V12.16l-2.295 2.295a1 1 0 0 1-1.414-1.414l3.995-3.995a1.01 1.01 0 0 1 1.428 0l3.995 3.995a1 1 0 1 1-1.414 1.414L13 12.16v8.878a1 1 0 0 1-1 1z",
    "data-ppui": "true"
  })), props.children);
};

var OrderAheadIcon = function OrderAheadIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded209);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 21a1 1 0 0 1-1 1h-1c-1.657 0-3-2.686-3-6 0-2.613.835-4.835 2-5.659V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v18zM12.25 2.003a.75.75 0 0 1 .75.75V8a4.001 4.001 0 0 1-2.5 3.709V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-9.291A4.001 4.001 0 0 1 5 7.999V2.754a.75.75 0 0 1 1.5 0V7h1.75V2.753a.75.75 0 0 1 1.5 0V7h1.75V2.753a.75.75 0 0 1 .75-.75z",
    "data-ppui": "true"
  })), props.children);
};

var OthersIcon = function OthersIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded210);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.237 10.691l-.751.45-.003.002a1 1 0 0 0 .003 1.714l7.486 4.491a2 2 0 0 0 2.056 0l7.485-4.491a1 1 0 0 0 .005-1.712l-.005-.003-.75-.45-5.963 3.576-.001.001-1.023.614a1.51 1.51 0 0 1-1.553 0L4.237 10.69z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.97 2.286a2 2 0 0 1 2.058 0l7.485 4.49c.364.22.523.612.478.982a.989.989 0 0 1-.478.734l-7.485 4.49-.001.001a2 2 0 0 1-2.057 0L3.486 8.491a1.001 1.001 0 0 1-.059-1.678m7.543-4.527l-7.484 4.49 7.484-4.49zM3.486 15.507l.75-.45 6.987 4.19a1.51 1.51 0 0 0 1.553 0l6.986-4.19.75.45a1 1 0 0 1 0 1.715l-7.484 4.49a2 2 0 0 1-2.058 0l-7.484-4.49a1 1 0 0 1 0-1.715z",
    "data-ppui": "true"
  })), props.children);
};

var OverflowIcon = function OverflowIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded211);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0-7a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    "data-ppui": "true"
  })), props.children);
};

var PackageSizeIcon = function PackageSizeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded212);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 2.75a.75.75 0 0 1 .75-.75h3.49c.42 0 .76.34.76.76v3.49a.75.75 0 0 1-1.5 0V3.5h-2.75a.75.75 0 0 1-.75-.75zM7 21.25a.75.75 0 0 1-.75.75H2.764a.76.76 0 0 1-.76-.76v-3.486a.75.75 0 0 1 1.5 0V20.5H6.25a.75.75 0 0 1 .75.75z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6zm.5 11.75c0 .414.336.75.75.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0-.75.75zM7.25 15a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5h-3.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PartySuppliesIcon = function PartySuppliesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded213);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 9a7.003 7.003 0 0 1-5.127 6.746l.403.807A1 1 0 0 1 13.382 18h-.632v3.25a.75.75 0 0 1-1.5 0V18h-.632a1 1 0 0 1-.894-1.447l.403-.807A7 7 0 1 1 19 9z",
    "data-ppui": "true"
  })), props.children);
};

var PasskeyIcon = function PasskeyIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded214);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.692 11.473c2.55 0 4.616-2.12 4.616-4.736C14.308 4.12 12.242 2 9.692 2S5.077 4.12 5.077 6.737c0 2.616 2.065 4.736 4.615 4.736z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.704 14.903a3.593 3.593 0 0 0 1.665-1.35 3.73 3.73 0 0 0 .631-2.08 3.73 3.73 0 0 0-1.05-2.605 3.54 3.54 0 0 0-2.538-1.077 3.54 3.54 0 0 0-2.539 1.077 3.73 3.73 0 0 0-1.05 2.605c0 .695.196 1.378.558 1.962.361.588.88 1.058 1.492 1.354v5.632l1.538 1.58 2.566-2.634-1.538-1.578 1.538-1.58-1.273-1.306zM18.41 9.365c.274 0 .535.11.727.308.193.198.3.466.3.746 0 .28-.107.549-.3.746a1.014 1.014 0 0 1-1.453 0 1.068 1.068 0 0 1-.3-.746c0-.28.107-.548.3-.746.192-.197.454-.308.727-.308z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.735 13.57a5.408 5.408 0 0 0 1.6 2.103v5.798H2v-2.104c0-1.673.65-3.28 1.804-4.464a6.076 6.076 0 0 1 4.35-1.851h3.077a6.013 6.013 0 0 1 2.504.517z",
    "data-ppui": "true"
  })), props.children);
};

var PasswordInputIcon = function PasswordInputIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded215);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.276 15.477h1.32c.18 0 .276-.096.276-.276V9.276c0-.18-.096-.276-.276-.276h-1.32c-.18 0-.276.096-.276.276v5.925c0 .18.096.276.276.276z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0zm6 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5zm1.5 13.5v-13h17v13h-17z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PauseIcon = function PauseIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded216);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7zm8 0a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2z",
    "data-ppui": "true"
  })), props.children);
};

var PayLaterIcon = function PayLaterIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded217);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3v3a6 6 0 1 0 6 6h-1.5A4.5 4.5 0 1 1 12 7.5v3.887c0 .619.203.617.756.612H16.5A4.5 4.5 0 0 0 12 7.5V6a6 6 0 0 1 6 5.998h3V12a9 9 0 1 1-9-9z",
    "data-ppui": "true"
  })), props.children);
};

var PayMonthlyIcon = function PayMonthlyIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded218);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.748 2a.75.75 0 0 0-.75.75V4h-4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1H19a1 1 0 0 0 1-1V9c0-.022 0-.044-.002-.066V5a1 1 0 0 0-1-1h-4V2.75a.75.75 0 1 0-1.5 0V4h-3V2.75a.75.75 0 0 0-.75-.75zm-4.25 3.5h3.5v.75a.75.75 0 1 0 1.5 0V5.5h3v.75a.75.75 0 0 0 1.5 0V5.5h3.5V8h-13V5.5zm5.999 6.015a.218.218 0 0 0-.216.184l-.757 4.785H9.19a.19.19 0 0 1-.186-.23L9.96 10.2a.235.235 0 0 1 .221-.2h2.3c.993-.005 1.85.707 1.847 1.67-.256-.131-.586-.155-.931-.155h-1.901zm-.147 2.426h1.058c.935 0 1.728-.682 1.872-1.605.011-.07.017-.181.019-.25-.238-.124-.559-.152-.864-.154h-1.604c-.124 0-.178.096-.194.192l-.287 1.817zm3.319-1.4a2.05 2.05 0 0 0 .02-.236c.64.335 1.013 1.01.896 1.753a2.16 2.16 0 0 1-2.131 1.817h-.668c-.108 0-.2.078-.216.184l-.278 1.744a.238.238 0 0 1-.235.197h-1.123a.193.193 0 0 1-.191-.223l.51-3.218a.238.238 0 0 1 .235-.2h1.05a2.16 2.16 0 0 0 2.13-1.818z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PayoutsIcon = function PayoutsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded219);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1h1a1 1 0 0 1 1 1v8h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1V3zm1 4a1 1 0 0 0-1 1v1h3V8a1 1 0 0 0-1-1H7zm4 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h-3V8zm-4 3a1 1 0 0 0-1 1v1h3v-1a1 1 0 0 0-1-1H7zm-1 5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1H6v-1zm6-5a1 1 0 0 0-1 1v1h3v-1a1 1 0 0 0-1-1h-1zm-1 7.5v-4h9.5v4H11z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PaypalAppIcon = function PaypalAppIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded220);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5zm6.121 4.893a.273.273 0 0 0-.27.23l-.946 5.982H8.238a.238.238 0 0 1-.233-.286L9.2 7.25A.294.294 0 0 1 9.478 7h2.874c1.242-.006 2.313.884 2.309 2.088-.32-.165-.732-.194-1.164-.195h-2.376zm-.184 3.032h1.323A2.37 2.37 0 0 0 14.6 9.92c.014-.088.021-.226.023-.312-.297-.155-.698-.19-1.08-.193H11.54c-.156 0-.224.12-.243.24l-.36 2.271zm4.148-1.749c.016-.1.022-.192.026-.295.799.419 1.266 1.263 1.12 2.19a2.7 2.7 0 0 1-2.664 2.272h-.835a.273.273 0 0 0-.27.23l-.348 2.181a.298.298 0 0 1-.293.246h-1.405a.242.242 0 0 1-.238-.28l.638-4.021a.297.297 0 0 1 .293-.252h1.312a2.7 2.7 0 0 0 2.664-2.27z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PaypalAssistantIcon = function PaypalAssistantIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded221);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.4 3.922l-1.983.805 1.982.766.743 1.959.828-1.96 1.897-.765-1.897-.805-.828-1.92-.743 1.92zM4 20.386l1.042-11.08A2.543 2.543 0 0 1 7.575 7h7.879a2.543 2.543 0 0 1 2.534 2.762l-.442 5.121a2.543 2.543 0 0 1-2.534 2.325h-6.13c-.818 0-1.586.393-2.064 1.056l-1.803 2.503A.561.561 0 0 1 4 20.387zm4.441-8.356l2.201-.876.825-2.09.92 2.09 2.105.876-2.105.834-.92 2.132-.825-2.132-2.2-.834z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PaypalBalanceIcon = function PaypalBalanceIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded222);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 5v2h2a1 1 0 0 1 1 1v2.526h-2a2 2 0 0 0-2 2v.947a2 2 0 0 0 2 2h2V18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1zM3.5 7h14V5.5h-14V7zm7.682 3.368a.522.522 0 0 1 .23-.052h2.178c.271 0 .523.019.748.055a3.183 3.183 0 0 1 .467.113c.022.007.043.016.065.024l.02.008c.043-.6-.123-1.018-.41-1.337-.42-.47-1.162-.679-2.12-.679H9.773a.398.398 0 0 0-.393.338l-1.157 7.386a.24.24 0 0 0 .236.278h1.524l.904-5.735a.534.534 0 0 1 .295-.399zm3.508.465a2.303 2.303 0 0 0-.41-.099 4.358 4.358 0 0 0-.69-.05h-2.023a.35.35 0 0 0-.343.296l-.365 2.338a.716.716 0 0 1 .124-.012h.816c.432 0 .819-.049 1.16-.148.863-.25 1.444-.815 1.734-1.714a4.54 4.54 0 0 0 .145-.555 2.227 2.227 0 0 0-.148-.056zm.502.216c.091.062.177.13.247.21.297.341.386.807.32 1.362-.007.05-.015.1-.025.149-.32 1.657-1.417 2.23-2.818 2.23H12.7a.349.349 0 0 0-.344.296l-.304 1.908a.348.348 0 0 1-.343.296h-1.255c-.116 0-.226-.104-.207-.232.024-.162.51-3.24.51-3.24a.396.396 0 0 1 .39-.338l.626.002c2.52 0 3.193-1.546 3.419-2.643z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11.526a1 1 0 0 0-1 1v.947a1 1 0 0 0 1 1h2v-2.947h-2z",
    "data-ppui": "true"
  })), props.children);
};

var PendingPausedIcon = function PendingPausedIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded223);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.254 18a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75zm-3.75-.75a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-1.5 0v3z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 1 8.993-8.653 6.25 6.25 0 0 1-8.647 8.646c-.114.005-.23.007-.346.007zm.75-15.235v4.5a6.271 6.271 0 0 0-1.5 1.146V5.766a.75.75 0 0 1 1.5 0zm-5.47 8.08l3.661-2.089a6.232 6.232 0 0 0-1.247 2.439l-1.67.953a.75.75 0 1 1-.744-1.302zm8.47 6.655a4.75 4.75 0 1 0 0-9.5 4.75 4.75 0 0 0 0 9.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PersonalInfoIcon = function PersonalInfoIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded224);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15.25a.25.25 0 0 1 .25.25v3.253a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25V15.5a.25.25 0 0 1 .25-.25h1zm-.5-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 22H5a1 1 0 0 1-1-1v-3a8.004 8.004 0 0 1 5.664-7.653 4.5 4.5 0 1 1 5.68-.834 6.25 6.25 0 0 1 1.64 12.366A4.049 4.049 0 0 1 16 22zm4.455-6.904a4.75 4.75 0 1 1-4.576-4.094h-.001a4.752 4.752 0 0 1 4.577 4.094z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PersonalSavingsIcon = function PersonalSavingsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded225);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7zm6.498 11.627a.75.75 0 0 0 0 1.5h1.625v1.625a.75.75 0 1 0 1.5 0v-1.625h1.625a.75.75 0 1 0 0-1.5h-1.625v-1.625a.75.75 0 1 0-1.5 0v1.625h-1.625z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.998 8.002a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4.688a6.274 6.274 0 0 0-1.552 2H6.998a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.505a6.23 6.23 0 0 0 .412 2H6.998a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5.357A6.25 6.25 0 1 0 17.998 9.92v-.917a1 1 0 0 0-1-1h-10zm4 7.75a4.73 4.73 0 0 1 .877-2.75 4.75 4.75 0 1 1-.877 2.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PetSuppliesIcon = function PetSuppliesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded226);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.758 4.757a5.98 5.98 0 0 0-1.34 2.039 3.001 3.001 0 0 0-4.196 1.929 3 3 0 0 0 1.554 5.796l2.689 2.689a3 3 0 1 0 5.796 1.554 3.001 3.001 0 0 0 1.937-4.179 5.957 5.957 0 0 0 2.045-1.342 6 6 0 1 0-8.485-8.486zm.333 4.327a2.988 2.988 0 0 0-.448-1.208c.02-.082.044-.164.07-.245a4.48 4.48 0 0 0 1.813-1.106 4.481 4.481 0 0 0 1.105-1.813 4.517 4.517 0 0 1 1.6-.206 5.972 5.972 0 0 1-1.645 3.08 5.974 5.974 0 0 1-2.495 1.498zm-1.89 1.457a1.5 1.5 0 1 0-2.146.016 1.5 1.5 0 1 0 .005 2.126l4.242 4.243a1.5 1.5 0 1 0 2.126.004 1.479 1.479 0 0 0 .116.104 1.501 1.501 0 0 0 2.138-2.073 1.5 1.5 0 0 0-2.258-.157l-.02-.02-4.188-4.187-.035-.035.02-.02zm7.169 2.747c-.08.025-.16.048-.24.069a2.986 2.986 0 0 0-1.21-.46 5.975 5.975 0 0 1 1.495-2.483 5.972 5.972 0 0 1 3.08-1.644 4.516 4.516 0 0 1-.207 1.6 4.48 4.48 0 0 0-1.813 1.105 4.48 4.48 0 0 0-1.105 1.813z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var Phone2Icon = function Phone2Icon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded227);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.065 7.992c.622 6.306 5.638 11.319 11.943 11.943.066.007.127.016.19.025.133.02.272.04.469.04a3.333 3.333 0 0 0 3.304-3.777c-.087-.652-.688-1.063-1.338-1.164l-2.58-.401-.764-.121c-.65-.104-1.35.103-1.633.698a3.308 3.308 0 0 0-.228.64 10.035 10.035 0 0 1-5.303-5.303c.223-.054.437-.13.64-.228.595-.283.802-.982.698-1.633l-.121-.764-.401-2.58c-.101-.65-.512-1.251-1.164-1.338a3.333 3.333 0 0 0-3.712 3.963z",
    "data-ppui": "true"
  })), props.children);
};

var PhoneIcon = function PhoneIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded228);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6zm6 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PhotoIdIcon = function PhotoIdIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded229);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6zm12 6a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5A.75.75 0 0 1 14 12zm.75-3.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3zM14 15a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 14 15zm-3.75-4.75c0 .815-.433 1.528-1.082 1.923A4.002 4.002 0 0 1 12 16v.444a.556.556 0 0 1-.556.556H4.555A.556.556 0 0 1 4 16.444V16a4.002 4.002 0 0 1 2.831-3.827A2.249 2.249 0 0 1 8 8a2.25 2.25 0 0 1 2.25 2.25z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PictureBrokenIcon = function PictureBrokenIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded230);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.113 5.006l-8.306 8.307c.042.02.083.041.124.065l1.158.67a1 1 0 0 0 1.326-.3l1.546-2.257a.75.75 0 0 1 1.308.127l1.72 3.986A1 1 0 0 1 19.07 17H9.12l-2 2H21a1 1 0 0 0 1-1V6a1 1 0 0 0-.887-.994z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.274 20.725a.75.75 0 0 1-1.056-1.066l.666-.666A1 1 0 0 1 2 18V6a1 1 0 0 1 1-1h13.877l2.78-2.78a.75.75 0 0 1 1.068 1.054l-.005.004-17.44 17.44-.006.007zM8 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PictureIcon = function PictureIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded231);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6zm6 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4.931 4.378l1.158.67a1 1 0 0 0 1.326-.3l1.546-2.257a.75.75 0 0 1 1.308.127l1.72 3.986A1 1 0 0 1 19.07 17H9.09c-.704 0-1.02-.881-.477-1.329l2.612-2.153a1.5 1.5 0 0 1 1.706-.14z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PinIcon = function PinIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded232);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.639 4.177a1.75 1.75 0 0 0-2.475 0l-3.59 3.59a1 1 0 0 0-.249.072L6.507 9.934a1 1 0 0 0-.309 1.625l2.592 2.59-4.82 4.82a.75.75 0 0 0 1.06 1.062l4.82-4.82 2.585 2.585a1 1 0 0 0 1.625-.309l2.095-4.818c.033-.076.056-.154.07-.233l3.598-3.6a1.75 1.75 0 0 0 0-2.474L17.64 4.177zm-2.179 6.901l3.303-3.302a.25.25 0 0 0 0-.354l-2.185-2.184a.25.25 0 0 0-.354 0L12.922 8.54l2.538 2.538z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PixIcon = function PixIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded233);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.185 7.213A3.61 3.61 0 0 0 6.643 6.16h-.06l3.27-3.27a3.038 3.038 0 0 1 4.296 0l3.287 3.286a3.613 3.613 0 0 0-2.381 1.05l-2.93 2.93-2.94-2.943zM6.83 18.09l3.02 3.02a3.038 3.038 0 0 0 4.296 0l3.052-3.047a3.612 3.612 0 0 1-2.143-1.03l-2.93-2.934-2.936 2.939-.002.002a3.596 3.596 0 0 1-2.357 1.05z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.11 9.852l-1.997-1.998a1 1 0 0 0-.736-.292l-.78.022a2.07 2.07 0 0 0-1.454.603l-3 3c-.28.28-.65.42-1.018.42-.37 0-.738-.14-1.02-.42L8.098 8.174a2.071 2.071 0 0 0-1.454-.602l-1.015-.023a1 1 0 0 0-.729.293l-2.01 2.01a3.04 3.04 0 0 0 0 4.297l2.01 2.01a1 1 0 0 0 .73.293l1.014-.022a2.06 2.06 0 0 0 1.454-.603l3.009-3.012c.546-.543 1.492-.543 2.037 0l3 3.003c.382.381.912.602 1.454.602l.782.02a1 1 0 0 0 .733-.292l1.999-2a3.039 3.039 0 0 0 0-4.296z",
    "data-ppui": "true"
  })), props.children);
};

var PlayIcon = function PlayIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded234);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.643 12.848L8.53 19.794A1 1 0 0 1 7 18.946V5.054a1 1 0 0 1 1.53-.848l11.113 6.946a1 1 0 0 1 0 1.696z",
    "data-ppui": "true"
  })), props.children);
};

var PledgeIcon = function PledgeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded235);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.999 6a1 1 0 0 0-1-1h-18a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6zm-18.5.504v1.75l2.54 1.523A3.486 3.486 0 0 1 6.56 8.34L3.5 6.504zm17 1.75l-2.532 1.518a3.485 3.485 0 0 0-.524-1.434l3.056-1.834v1.75zm-7.083.958c-.53 1.246-2.296 1.246-2.826 0a1.027 1.027 0 0 0-.294-.377C10.13 8.7 9.79 8.5 9.102 8.5c-.67 0-1.126.322-1.38.827-.27.537-.351 1.394.096 2.397.416.933 1.28 1.92 2.25 2.69.474.376.936.668 1.323.86.38.188.577.223.608.228h.008c.03-.005.228-.04.611-.228a7.68 7.68 0 0 0 1.325-.858c.97-.769 1.831-1.754 2.243-2.687l.002-.005c.448-1.003.367-1.86.096-2.397-.254-.505-.71-.827-1.38-.827-.688 0-1.028.2-1.193.335-.19.154-.272.325-.295.377z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PreferredSelectedIcon = function PreferredSelectedIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded236);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.948 3.624c-.305-.91-1.592-.91-1.896 0L9.25 9.003l-5.672.05c-.96.01-1.357 1.234-.586 1.805l4.559 3.375-1.704 5.41c-.289.915.753 1.672 1.534 1.115L12 17.465l4.618 3.293c.782.557 1.823-.2 1.535-1.115l-1.704-5.41 4.558-3.375c.771-.571.374-1.795-.586-1.804l-5.672-.051-1.801-5.379z",
    "data-ppui": "true"
  })), props.children);
};

var PreferredIcon = function PreferredIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded237);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.306 10.99L12 7.092l-1.306 3.898-4.11.037 3.303 2.447-1.235 3.921L12 15.01l3.348 2.386-1.235-3.921 3.304-2.447-4.111-.037zM9.25 9.003l-5.672.051c-.96.009-1.357 1.233-.586 1.804l4.558 3.375-1.704 5.41c-.288.914.753 1.67 1.535 1.114L12 17.465l4.618 3.292c.782.557 1.823-.2 1.535-1.115l-1.704-5.41 4.558-3.374c.77-.571.373-1.795-.586-1.804l-5.672-.051-1.8-5.378c-.306-.91-1.592-.91-1.897 0L9.25 9.003z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PreviewIcon = function PreviewIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded238);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.998a1.998 1.998 0 1 0 .001-3.996 1.998 1.998 0 0 0 0 3.996z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.5 12c0 1.3-2.6 5.2-6.5 5.2S5.5 13.28 5.5 12c0-1.28 2.6-5.2 6.5-5.2s6.5 3.9 6.5 5.2zM12 15.498a3.498 3.498 0 1 0 0-6.996 3.498 3.498 0 0 0 0 6.996z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.002 5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V5zm1.5 13.5v-13h17v13h-17z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PrintIcon = function PrintIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded239);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-3v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V5zm10.5 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-9 2h9v5h-9v-5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PropertyMgmtIcon = function PropertyMgmtIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded240);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.001 16.754a2.254 2.254 0 1 0 0-4.508 2.254 2.254 0 0 0 0 4.508z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.546 12.547a1 1 0 0 1-1.414 0l-.133-.133V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8.586l-.133.133a1 1 0 0 1-1.414-1.414l8.84-8.84a1 1 0 0 1 1.414 0l8.84 8.84a1 1 0 0 1 0 1.414zM10.834 9.75a.25.25 0 0 1 .25-.25h1.833a.25.25 0 0 1 .25.25v1.182l.428.203c.182.087.356.188.52.301l.391.27 1.025-.591a.25.25 0 0 1 .342.091l.917 1.588a.25.25 0 0 1-.092.341l-1.024.592.037.472a3.784 3.784 0 0 1 0 .602l-.038.472 1.025.592a.25.25 0 0 1 .091.341l-.917 1.588a.25.25 0 0 1-.341.091l-1.025-.591-.39.27a3.728 3.728 0 0 1-.52.3l-.429.204v1.182a.25.25 0 0 1-.25.25h-1.833a.25.25 0 0 1-.25-.25v-1.182l-.428-.204a3.721 3.721 0 0 1-.52-.3l-.39-.27-1.025.591a.25.25 0 0 1-.342-.091l-.917-1.588a.25.25 0 0 1 .092-.341l1.024-.592-.037-.472a3.78 3.78 0 0 1 0-.602l.037-.472-1.024-.592a.25.25 0 0 1-.091-.341l.916-1.588a.25.25 0 0 1 .342-.091l1.025.591.39-.27c.165-.113.338-.214.52-.3l.428-.204V9.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var PurchaseProtectionIcon = function PurchaseProtectionIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded241);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22.003c.12 0 .24-.028.347-.082C13.884 21.157 20 17.615 20 10.906V5.658c0-.383-.343-.699-.784-.725-4.106-.248-5.464-1.526-6.607-2.68-.337-.34-.947-.337-1.278.008-1.11 1.157-2.472 2.474-6.547 2.722-.44.027-.784.342-.784.726v5.246c0 6.666 6.117 10.202 7.653 10.966a.778.778 0 0 0 .347.082zm2.47-12.865l-3.438 4.48-1.493-1.533a.75.75 0 0 0-1.074 1.047l1.895 1.947a1 1 0 0 0 1.51-.089l3.79-4.938a.75.75 0 0 0-1.19-.914z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var QrcIcon = function QrcIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded242);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 0 0-1 1v3.25a.75.75 0 0 0 1.5 0V5.5h2.75a.75.75 0 0 0 0-1.5H5zm14 0a1 1 0 0 1 1 1v3.25a.75.75 0 0 1-1.5 0V5.5h-2.75a.75.75 0 0 1 0-1.5H19zM4 19a1 1 0 0 0 1 1h3.25a.75.75 0 0 0 0-1.5H5.5v-2.75a.75.75 0 0 0-1.5 0V19zm15 1a1 1 0 0 0 1-1v-3.25a.75.75 0 0 0-1.5 0v2.75h-2.75a.75.75 0 0 0 0 1.5H19zM7 8a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 13.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3zM14 16v-2h2v2h-2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2zm7-7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2zM5 4a1 1 0 0 0-1 1v3.25a.75.75 0 0 0 1.5 0V5.5h2.75a.75.75 0 0 0 0-1.5H5zm14 0a1 1 0 0 1 1 1v3.25a.75.75 0 0 1-1.5 0V5.5h-2.75a.75.75 0 0 1 0-1.5H19zM4 19a1 1 0 0 0 1 1h3.25a.75.75 0 0 0 0-1.5H5.5v-2.75a.75.75 0 0 0-1.5 0V19zm15 1a1 1 0 0 0 1-1v-3.25a.75.75 0 0 0-1.5 0v2.75h-2.75a.75.75 0 0 0 0 1.5H19zM7 8a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 13.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3zM14 16v-2h2v2h-2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2zm7-7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2z",
    "data-ppui": "true"
  })), props.children);
};

var QuestionSmIcon = function QuestionSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded243);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 9A7 7 0 1 1 2 9a7 7 0 0 1 14 0zm-7.476 1h.945c.137 0 .215-.078.225-.224.048-.458.263-.683.74-1.053l.088-.068c.615-.478.946-1.053.946-1.765 0-1.092-.838-1.96-2.37-1.96-1.452 0-2.33.78-2.446 2.048-.01.156.078.234.224.234h1.072c.137 0 .215-.078.234-.225.05-.526.342-.828.878-.828.517 0 .829.331.829.76 0 .42-.225.712-.449.917l-.37.34c-.546.498-.741.84-.77 1.59 0 .156.077.234.224.234zM9 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var QuestionIcon = function QuestionIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded244);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zm-9.578 1.54h1.164c.168 0 .264-.097.276-.277.06-.564.324-.84.912-1.296l.108-.084c.756-.588 1.164-1.296 1.164-2.172 0-1.344-1.032-2.412-2.916-2.412-1.788 0-2.868.96-3.012 2.52-.012.192.096.288.276.288h1.32c.168 0 .264-.096.288-.276.06-.648.42-1.02 1.08-1.02.636 0 1.02.408 1.02.936 0 .516-.276.876-.552 1.128l-.456.42c-.672.612-.912 1.032-.948 1.956 0 .192.096.288.276.288zM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var RainyDayIcon = function RainyDayIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded245);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a1 1 0 0 0-.998 1.062A8.001 8.001 0 0 0 4 11a1 1 0 0 0 1 1h6.25v6a1.25 1.25 0 1 1-2.5 0v-1.25a.75.75 0 0 0-1.5 0V18a2.75 2.75 0 1 0 5.5 0v-6H19a1 1 0 0 0 1-1 8.001 8.001 0 0 0-7.002-7.938A1 1 0 0 0 12 2z",
    "data-ppui": "true"
  })), props.children);
};

var RecurrentIcon = function RecurrentIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded246);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.745 8A7.002 7.002 0 0 0 5.07 11.003C4.993 11.55 4.552 12 4 12s-1.006-.45-.945-.998A9.001 9.001 0 0 1 19 6.342V4a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 1 1 0-2h2.745zm-11.49 8H9a1 1 0 1 0 0-2H4a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-2.343a9.001 9.001 0 0 0 15.945-4.659c.06-.549-.393-.998-.945-.998-.552 0-.992.45-1.07.997A7.001 7.001 0 0 1 6.255 16z",
    "data-ppui": "true"
  })), props.children);
};

var RecurringPausedIcon = function RecurringPausedIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded247);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.254 18a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75zm-3.75-.75a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-1.5 0v3z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 22a6.221 6.221 0 0 1-3.403-1.007A9 9 0 1 1 19 6.343V4a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1h-.382c-.468.03-.971-.26-1.17-.729A7.002 7.002 0 0 0 5 12a7.003 7.003 0 0 0 5.287 6.789A6.25 6.25 0 1 1 15.75 22zm3.407-9.56a4.75 4.75 0 1 0-6.816 6.619 4.75 4.75 0 0 0 6.816-6.619z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var RefreshIcon = function RefreshIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded248);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.93 12.997c.078-.547.518-.997 1.07-.997s1.006.45.945.998A9.001 9.001 0 0 1 3 12a9 9 0 0 1 16-5.657V4a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 1 1 0-2h2.745a7 7 0 1 0 1.184 4.997z",
    "data-ppui": "true"
  })), props.children);
};

var RefundIcon = function RefundIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded249);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 15.75A6.25 6.25 0 1 1 9.544 15H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.75zM12 7a3 3 0 0 1 2.967 2.548 6.252 6.252 0 0 0-4.576 2.984A3 3 0 0 1 12 7zm2.794 4.096a4.753 4.753 0 0 0-2.866 7.475 2.534 2.534 0 0 0 3.015-3.048l-.612.612a.75.75 0 0 1-1.06-1.06l1.767-1.769a1 1 0 0 1 1.414 0l1.768 1.768a.75.75 0 1 1-1.06 1.06l-.707-.706a4.03 4.03 0 0 1-1.127 3.52 4.017 4.017 0 0 1-1.748 1.027 4.73 4.73 0 0 0 2.725.493 4.75 4.75 0 1 0-1.509-9.372z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var RegistrationDocIcon = function RegistrationDocIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded250);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10.915v1.998a1 1 0 0 0 1.625.781l1.916-1.533 1.917 1.533a1 1 0 0 0 1.625-.78V19H21a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H3zm2.752 3.25h10.265a4.51 4.51 0 0 0-2.08 1.5H5.753a.75.75 0 0 1 0-1.5zM17.5 9.5c-.427 0-.833.09-1.2.25a3.012 3.012 0 0 0-1.528 1.5 2.99 2.99 0 0 0-.262 1.5 2.996 2.996 0 0 0 2.99 2.75 2.99 2.99 0 0 0 1.998-.762A3.001 3.001 0 0 0 17.5 9.5zM5.752 11.25h7.424a4.503 4.503 0 0 0-.17 1.5H5.753a.75.75 0 0 1 0-1.5zm0 3h7.601a4.51 4.51 0 0 0 1.034 1.5H5.752a.75.75 0 0 1 0-1.5zM17.5 17a4.48 4.48 0 0 1-2.085-.511v3.47l2.041-1.634 2.042 1.633v-3.425A4.482 4.482 0 0 1 17.5 17z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ReloadPhonesIcon = function ReloadPhonesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded251);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.002 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V3zm8.5 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM15.75 5a.75.75 0 0 0-.75.75v.896a4.5 4.5 0 1 0 1.062 5.293c.22-.46-.16-.939-.67-.939-.337 0-.63.219-.8.51A3 3 0 1 1 14.236 8h-1.485a.75.75 0 0 0 0 1.5h2.75a1 1 0 0 0 1-1V5.75a.75.75 0 0 0-.75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var RentIcon = function RentIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded252);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.133 12.547a1 1 0 0 0 1.414-1.414l-8.84-8.84a1 1 0 0 0-1.414 0l-8.84 8.84a1 1 0 1 0 1.414 1.414L4 12.414V21a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8.586l.133.133zM7.75 17.25a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5zM7 15a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 7 15zm.75-3.75a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5zM15 18a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 15 18zm.75-3.75a.75.75 0 1 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5zM15 12a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 15 12z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ReportProblemIcon = function ReportProblemIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded253);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.998 5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1.651.76L12.03 18h8.969a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-18zm8.491 8.014h1.02c.168 0 .276-.096.288-.264.019-.428.042-.85.067-1.28.055-.98.113-2.002.113-3.244v-.948c0-.18-.096-.276-.276-.276h-1.404c-.18 0-.276.096-.276.276v.948c0 1.242.058 2.264.114 3.243.024.43.048.853.066 1.281.012.168.12.264.288.264zM12 16.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var RequestMoneyIcon = function RequestMoneyIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded254);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.46 18.703a1 1 0 0 1-1.413 0l-1.768-1.767a.75.75 0 0 1 1.06-1.061l.665.664v-3.288a.75.75 0 0 1 1.5 0v3.288l.664-.664a.75.75 0 0 1 1.06 1.06l-1.767 1.768z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 15.752A6.25 6.25 0 1 1 9.544 15H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.752zm-7.034-6.204a3 3 0 1 0-4.576 2.984 6.252 6.252 0 0 1 4.576-2.984zM11.058 15a4.75 4.75 0 1 0 9.383 1.5 4.75 4.75 0 0 0-9.383-1.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ResolutionIcon = function ResolutionIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded255);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.75 15.955a2.12 2.12 0 0 0 .618-1.621 2.816 2.816 0 0 0 2.633-2.81V9.268a2 2 0 0 0-.583-1.411L18.17 4.594a2 2 0 0 0-.933-.53L13.22 3.06a2 2 0 0 0-1.9.526l-1.232 1.232-2.846-.407a1.75 1.75 0 0 0-1.485.495L2.514 8.15A1.75 1.75 0 0 0 2 9.386v.182c0 2.76 1.096 5.408 3.048 7.36l2.74 2.74a2.125 2.125 0 0 0 3.48-.725 2.125 2.125 0 0 0 2.652-1.238 2.125 2.125 0 0 0 2.652-1.237c.74.247 1.587.076 2.176-.513zM8.584 6.32l-.018.018a2.977 2.977 0 0 0 .001 4.208l.006.006.01.01a3 3 0 0 0 4.243 0l.707-.707 4.154 4.154a.625.625 0 1 1-.883.884l-.686-.685-.021-.022-1.503-1.502a.75.75 0 0 0-1.06 1.06l1.513 1.514a.625.625 0 0 1-.895.873l-2.21-2.21a.75.75 0 0 0-1.06 1.06l1.502 1.503a.625.625 0 1 1-.884.884l-.698-.698-.009-.009-1.502-1.503A.75.75 0 0 0 8.23 16.22l1.507 1.507a.625.625 0 0 1-.888.88l-2.74-2.74A8.907 8.907 0 0 1 3.5 9.568v-.182a.25.25 0 0 1 .073-.176l3.243-3.243a.25.25 0 0 1 .212-.07l1.732.247-.176.177z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var RetirementIcon = function RetirementIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded256);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.082 9.936c.543.93.966 1.97 1.022 2.948a1.5 1.5 0 0 1-2.658 1.037l-.274-.34c-.479-.598-1.064-1.328-1.83-1.972a7.066 7.066 0 0 0-.466-.36c.348 1.944.76 5.007.583 6.943 2.616.422 4.642 1.5 5.308 2.845.244.495-.215.963-.767.963H5c-.552 0-1.011-.468-.767-.963.697-1.409 2.886-2.523 5.681-2.9.228-2.066.439-5.285.071-7.08-1.256.822-2.13 2.182-2.563 3.434a1.5 1.5 0 0 1-2.868-.107c-.221-.837-.319-2.119.028-3.434l.007-.026a4.262 4.262 0 0 0-.13.105 1.5 1.5 0 0 1-2.453-1.297c.103-1.063.861-2.598 2.376-3.687a1.498 1.498 0 0 1 .042-2.508c1.285-.813 4.24-1.518 6.97.34.67-.571 1.514-1.126 2.504-1.484 1.683-.607 3.72-.61 5.818.705a1.5 1.5 0 0 1-.584 2.756c1.058.717 2.034 1.753 2.724 3.202a1.5 1.5 0 0 1-2.195 1.887l-.205-.14a15.957 15.957 0 0 0-1.374-.867zm-4.036-.347c-.803-.44-1.718-.719-2.741-.675-1.484.3-2.666 1.118-3.557 2.112a8.923 8.923 0 0 0-1.744 2.975c-.225-.852-.296-2.469.514-3.846a4.363 4.363 0 0 1 1.675-1.611c-.469-.126-1.245-.202-2.172.021a5.406 5.406 0 0 0-.265.071c-.7.207-1.472.587-2.257 1.24.062-.645.62-1.843 1.869-2.69.4-.27.87-.505 1.419-.675.28-.086.58-.156.9-.204a7.804 7.804 0 0 1 1.498-.066c0-.06-.05-.144-.145-.242-.314-.323-1.125-.794-2.28-1.037a7.468 7.468 0 0 0-1.535-.157c.798-.505 2.702-1.022 4.637-.084.273.132.546.293.817.488.272.195.541.422.805.688.239-.28.538-.586.889-.884.329-.28.704-.551 1.119-.786 1.43-.809 3.33-1.172 5.428.142-.622.05-1.513.143-2.397.328-.839.175-1.671.433-2.259.817-.237.155-.434.33-.576.528.541-.12 1.355-.134 2.254.06.179.038.361.085.546.14 1.473.445 3.065 1.464 4.013 3.459l-.21-.145c-.716-.497-2.137-1.484-3.902-1.862-.232-.05-.47-.09-.714-.115a6.178 6.178 0 0 0-1.636.036c.311.223.619.481.915.764.231.22.455.456.669.701 1.096 1.26 1.92 2.785 1.983 3.89l-.243-.302c-.68-.851-1.797-2.25-3.317-3.08z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ReturnRightIcon = function ReturnRightIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded257);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.29 12.304a1 1 0 0 0 1.415 1.414l4.998-4.998a1.01 1.01 0 0 0 0-1.429l-4.998-4.998a1 1 0 0 0-1.414 1.414L17.584 7H10.5a7.5 7.5 0 0 0 0 15H18a1 1 0 1 0 0-2h-7.5a5.5 5.5 0 1 1 0-11h7.094l-3.304 3.304z",
    "data-ppui": "true"
  })), props.children);
};

var RewardsIcon = function RewardsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded258);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5 8A2.5 2.5 0 0 1 6 5.5v-.156A2.344 2.344 0 0 1 8.344 3a3.908 3.908 0 0 1 3.654 2.524A3.91 3.91 0 0 1 15.655 3 2.345 2.345 0 0 1 18 5.345V5.5A2.5 2.5 0 0 1 15.5 8H19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.5zm-1-2.656V5.5a1 1 0 0 0 1 1h2.216a2.407 2.407 0 0 0-2.372-2 .844.844 0 0 0-.844.844zm9 .001V5.5a1 1 0 0 1-1 1h-2.22a2.41 2.41 0 0 1 2.375-2c.467 0 .845.378.845.845zM6.75 10.5a.75.75 0 0 0 0 1.5h4.5v5.25a.75.75 0 0 0 1.5 0V12h4.5a.75.75 0 0 0 0-1.5h-4.5v-.75a.75.75 0 0 0-1.5 0v.75h-4.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var RightAlignIcon = function RightAlignIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded259);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H5zm0 8a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5zm4 5a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1zm1-9a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2h-9z",
    "data-ppui": "true"
  })), props.children);
};

var SafariIcon = function SafariIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded260);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21c4.924 0 9-4.085 9-9 0-4.924-4.085-9-9.009-9C7.076 3 3 7.076 3 12c0 4.915 4.085 9 9 9zm0-1.5A7.464 7.464 0 0 1 4.509 12c0-4.165 3.317-7.5 7.482-7.5s7.5 3.335 7.509 7.5a7.466 7.466 0 0 1-7.5 7.5zm-3.697-3.044l5.065-2.48c.282-.132.476-.335.617-.608l2.462-5.056c.282-.6-.15-1.06-.768-.76l-5.047 2.463a1.257 1.257 0 0 0-.608.617l-2.48 5.065c-.282.582.177 1.041.759.759zM12 13.094c-.6 0-1.076-.485-1.076-1.085S11.4 10.932 12 10.932c.6 0 1.085.477 1.085 1.077S12.6 13.094 12 13.094z",
    "data-ppui": "true"
  })), props.children);
};

var SavingsIcon = function SavingsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded261);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1h-4v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1H5a1 1 0 0 1-1-1V5zm10 7a3.5 3.5 0 0 1-6.92.75h3.42a.75.75 0 0 0 0-1.5H7.08A3.501 3.501 0 0 1 14 12zm2.5 5.25a.75.75 0 0 0 1.5 0V16h-1.5v1.25zm0-3.25H18v-4h-1.5v4zm0-6V6.75a.75.75 0 0 1 1.5 0V8h-1.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ScanBarcodeIcon = function ScanBarcodeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded262);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7H7V5zm-1.5 7V4.75a.75.75 0 0 0-1.5 0V12h1.5zm-2.75 1.5a.75.75 0 0 0 0 1.5H4v4.25a.75.75 0 0 0 1.5 0V15H7v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4h1.5v4.25a.75.75 0 0 0 1.5 0V15h1.25a.75.75 0 0 0 0-1.5H2.75zM18.5 12H20V4.75a.75.75 0 0 0-1.5 0V12z",
    "data-ppui": "true"
  })), props.children);
};

var ScanIcon = function ScanIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded263);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 0 0-1 1v3.25a.75.75 0 0 0 1.5 0V5.5h2.75a.75.75 0 0 0 0-1.5H5zm14 0a1 1 0 0 1 1 1v3.25a.75.75 0 0 1-1.5 0V5.5h-2.75a.75.75 0 0 1 0-1.5H19zM4 19a1 1 0 0 0 1 1h3.25a.75.75 0 0 0 0-1.5H5.5v-2.75a.75.75 0 0 0-1.5 0V19zm15 1a1 1 0 0 0 1-1v-3.25a.75.75 0 0 0-1.5 0v2.75h-2.75a.75.75 0 0 0 0 1.5H19z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 0 0-1 1v3.25a.75.75 0 0 0 1.5 0V5.5h2.75a.75.75 0 0 0 0-1.5H5zm14 0a1 1 0 0 1 1 1v3.25a.75.75 0 0 1-1.5 0V5.5h-2.75a.75.75 0 0 1 0-1.5H19zM4 19a1 1 0 0 0 1 1h3.25a.75.75 0 0 0 0-1.5H5.5v-2.75a.75.75 0 0 0-1.5 0V19zm15 1a1 1 0 0 0 1-1v-3.25a.75.75 0 0 0-1.5 0v2.75h-2.75a.75.75 0 0 0 0 1.5H19z",
    "data-ppui": "true"
  })), props.children);
};

var ScienceIcon = function ScienceIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded264);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 11.764V6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v5.764a1 1 0 0 1-.106.447l-4.17 8.342A1 1 0 0 0 5.616 22H18.38a1 1 0 0 0 .895-1.447l-4.171-8.342a1 1 0 0 1-.106-.447zM14.5 3.5v1h-1v7.264c0 .079.003.158.01.236h-3.022a2.51 2.51 0 0 0 .011-.236V4.5h-1v-1h5zM9.051 15.25l-.75 1.5h2.944a.75.75 0 1 0 0-1.5H9.052zm-1.5 3l-.739 1.477c.06.015.122.023.186.023h4.247a.75.75 0 1 0 0-1.5H7.552z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SearchSmIcon = function SearchSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded265);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.757 12.172a5 5 0 1 1 1.414-1.414l2.536 2.536a1 1 0 1 1-1.414 1.414l-2.536-2.536zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SearchIcon = function SearchIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded266);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.052 16.46a7.5 7.5 0 1 1 1.413-1.415l3.243 3.243a1 1 0 1 1-1.414 1.414l-3.242-3.241zM16 10.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SecurityIcon = function SecurityIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded267);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.347 21.921a.778.778 0 0 1-.694 0C10.116 21.157 4 17.621 4 10.955V5.71c0-.384.343-.699.784-.726 4.075-.248 5.437-1.565 6.547-2.722.331-.345.941-.349 1.278-.008 1.143 1.154 2.501 2.432 6.607 2.68.44.026.784.342.784.725v5.248c0 6.71-6.117 10.25-7.653 11.015z",
    "data-ppui": "true"
  })), props.children);
};

var SendMoneyIcon = function SendMoneyIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded268);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.046 12.79a1 1 0 0 1 1.415 0l1.768 1.767a.75.75 0 0 1-1.061 1.06l-.665-.664v3.289a.75.75 0 1 1-1.5 0v-3.289l-.664.665a.75.75 0 1 1-1.06-1.061l1.768-1.768z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6.544A6.25 6.25 0 1 0 22 15.75V6zm-7.034 3.548a3 3 0 1 0-4.576 2.984 6.252 6.252 0 0 1 4.576-2.984zM11.058 15a4.75 4.75 0 1 0 9.383 1.5 4.75 4.75 0 0 0-9.383-1.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SendToBankIcon = function SendToBankIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded269);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.79 14.21l-7.088-3.052c-.816-.351-.803-1.511.02-1.845L20.75 2H21a1 1 0 0 1 1 1v.25l-7.313 18.03c-.334.822-1.494.835-1.845.02L9.79 14.21zm6.958-8.019l1.596-1.596-13.95 5.659 5.796 2.496 6.558-6.559z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ServicesIcon = function ServicesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded270);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.67 3.768l.678.391c.206-.142.423-.268.651-.376V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.782c.229.109.447.235.653.378l.678-.392a1 1 0 0 1 1.366.366l1 1.732a1 1 0 0 1-.366 1.366l-.678.392a4.727 4.727 0 0 1 0 .752l.678.392a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1-1.366.366l-.678-.391a4.67 4.67 0 0 1-.652.377V15l2.848-2.848a3 3 0 0 1 4.273.031l.587.605a1 1 0 0 1-.015 1.409l-4.725 4.653A4 4 0 0 1 14.16 20H9.5l-1.544 1.543a1 1 0 0 1-1.414 0l-3.836-3.836a1 1 0 0 1 0-1.414l3.122-3.121a4 4 0 0 1 1.726-1.017.998.998 0 0 1-.251-.289l-1-1.732a1 1 0 0 1 .366-1.366l.678-.392a4.732 4.732 0 0 1 0-.752l-.678-.392a1 1 0 0 1-.366-1.366l1-1.732a1 1 0 0 1 1.366-.366zM8.657 13.5a2.5 2.5 0 0 0-1.768.732L4.121 17l3.13 3.129L8.878 18.5h5.282a2.5 2.5 0 0 0 1.755-.719l4.37-4.304-.24-.249a1.496 1.496 0 0 0-2.137-.016l-2.848 2.849a1.5 1.5 0 0 1-1.073.439H9.75a.75.75 0 0 1 0-1.5h2.75v-1.5H8.657zM12 10.352a2.352 2.352 0 1 0 0-4.704 2.352 2.352 0 0 0 0 4.704z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SettingsIcon = function SettingsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded271);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.402 5.42V3.998a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.498c-.66.264-1.27.626-1.813 1.067l-1.265-.73a1 1 0 0 0-1.366.366l-1.5 2.597a1 1 0 0 0 .366 1.366l1.265.73a7.053 7.053 0 0 0 0 2.212l-1.264.73a1 1 0 0 0-.366 1.366l1.498 2.595a1 1 0 0 0 1.366.366l1.265-.73a6.99 6.99 0 0 0 1.914 1.107v1.46a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1.46a6.995 6.995 0 0 0 1.914-1.107l1.265.73a1 1 0 0 0 1.366-.365l1.498-2.596a1 1 0 0 0-.366-1.366l-1.264-.73a7.063 7.063 0 0 0 0-2.213l1.264-.73a1 1 0 0 0 .366-1.366L19.047 6.2a1 1 0 0 0-1.366-.366l-1.265.73a6.992 6.992 0 0 0-2.014-1.144zm1.6 6.578a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SewingIcon = function SewingIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded272);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 10h3v7H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5c0 1.398.957 2.572 2.25 2.905V15a.75.75 0 0 0 1.5 0v-2.095A3.001 3.001 0 0 0 10 10zm6.498-.499a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-2 3.749a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75zm.75 2.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ShareAndroidIcon = function ShareAndroidIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded273);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 8a3 3 0 1 0-2.967-2.557L7.799 9.6a3 3 0 1 0 .08 4.74l6.23 3.857a3 3 0 1 0 1.15-1.64L8.933 12.64a3.011 3.011 0 0 0-.023-1.376l6.07-4.047A2.99 2.99 0 0 0 17 8z",
    "data-ppui": "true"
  })), props.children);
};

var ShareFacebookIcon = function ShareFacebookIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded274);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12.055C21 7.055 16.97 3 12 3s-9 4.054-9 9.055c0 4.52 3.291 8.266 7.594 8.945v-6.328H8.309v-2.617h2.285V10.06c0-2.27 1.343-3.523 3.4-3.523.984 0 2.014.177 2.014.177v2.228h-1.135c-1.118 0-1.467.698-1.467 1.414v1.699h2.496l-.399 2.617h-2.097V21C17.71 20.32 21 16.575 21 12.055z",
    "data-ppui": "true"
  })), props.children);
};

var ShareInstagramIcon = function ShareInstagramIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded275);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.997 3.023l.194.007.52.023c.958.043 1.612.196 2.184.418A4.41 4.41 0 0 1 19.49 4.51c.5.5.808 1.003 1.038 1.595.223.572.375 1.226.418 2.184.01.192.016.358.023.52l.007.194c.016.488.022 1.022.024 2.205v1.585a69.443 69.443 0 0 1-.024 2.205l-.007.194-.023.52c-.043.958-.196 1.612-.418 2.184a4.41 4.41 0 0 1-1.038 1.595c-.5.5-1.003.808-1.595 1.038-.572.223-1.226.375-2.184.418a81.13 81.13 0 0 1-.52.023l-.194.007c-.488.016-1.022.022-2.205.024h-1.585a69.441 69.441 0 0 1-2.205-.024l-.194-.007a81.276 81.276 0 0 1-.52-.023c-.958-.043-1.612-.196-2.184-.418a4.412 4.412 0 0 1-1.595-1.038 4.41 4.41 0 0 1-1.038-1.595c-.222-.572-.375-1.226-.418-2.184A42.556 42.556 0 0 1 3 13.49v-2.723c.004-1.36.018-1.71.053-2.479.043-.958.196-1.612.418-2.184A4.412 4.412 0 0 1 4.51 4.509c.5-.5 1.003-.808 1.595-1.038.572-.222 1.226-.375 2.184-.418l.52-.023.194-.007c.385-.012.798-.02 1.534-.022L13.232 3c.885.003 1.342.01 1.765.023zm-1.74 1.599h-2.26c-1.509.002-1.837.014-2.635.05-.877.04-1.354.188-1.671.31-.42.164-.72.36-1.035.674-.315.315-.51.615-.673 1.035-.123.317-.27.794-.31 1.671-.034.75-.047 1.086-.051 2.38v2.26c.001.976.007 1.458.02 1.893l.009.235.022.507c.04.877.186 1.354.31 1.671.163.42.358.72.673 1.035.315.315.615.51 1.035.673.317.124.794.27 1.671.31.798.037 1.126.049 2.635.052h2.005a63.868 63.868 0 0 0 1.893-.022l.235-.008.507-.022c.877-.04 1.354-.186 1.671-.31a2.79 2.79 0 0 0 1.035-.673 2.79 2.79 0 0 0 .673-1.035c.124-.317.27-.794.31-1.671l.022-.507.008-.235c.014-.434.02-.917.022-1.893v-2.005c-.003-1.509-.015-1.837-.052-2.635-.04-.877-.186-1.354-.31-1.671a2.79 2.79 0 0 0-.673-1.035 2.79 2.79 0 0 0-1.035-.673c-.317-.123-.794-.27-1.671-.31a73.53 73.53 0 0 0-.507-.022l-.235-.008c-.395-.013-.83-.019-1.639-.021zm-1.258 2.755a4.622 4.622 0 1 1 0 9.245 4.622 4.622 0 0 1 0-9.245zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm4.805-2.884a1.08 1.08 0 1 1 0 2.16 1.08 1.08 0 0 1 0-2.16z",
    "data-ppui": "true"
  })), props.children);
};

var ShareIosIcon = function ShareIosIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded276);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28 6.547a.92.92 0 0 1 0-1.322l3.043-2.951A.956.956 0 0 1 12.02 2a.965.965 0 0 1 .66.278l3.04 2.947a.92.92 0 0 1 0 1.322.973.973 0 0 1-1.353 0l-1.41-1.355v8.873A.946.946 0 0 1 12 15a.946.946 0 0 1-.957-.935V5.192l-1.41 1.355a.973.973 0 0 1-1.353 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11a2 2 0 0 1 2-2h2v2H7v9h10v-9h-2V9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9z",
    "data-ppui": "true"
  })), props.children);
};

var ShareLineIcon = function ShareLineIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded277);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1 3A3.9 3.9 0 0 1 21 6.9v10.2a3.9 3.9 0 0 1-3.9 3.9H6.9A3.9 3.9 0 0 1 3 17.1V6.9A3.9 3.9 0 0 1 6.9 3h10.2zm-5.13 2.89c-3.613 0-6.553 2.386-6.553 5.319 0 2.629 2.332 4.83 5.481 5.247.214.046.504.14.578.323.066.166.043.425.02.592l-.093.561c-.029.166-.132.648.568.354.7-.295 3.774-2.223 5.15-3.805h-.001c.95-1.042 1.404-2.099 1.404-3.272 0-2.933-2.94-5.319-6.553-5.319zm-1.33 3.901c.07 0 .127.058.127.128v2.855c0 .07-.057.128-.128.128h-.46a.128.128 0 0 1-.127-.128V9.92c0-.07.057-.128.128-.128h.46zm1.172.001h.007l.005.002a.11.11 0 0 1 .008.001l.004.001.004.002h.004l.011.005.004.002.007.004.007.005.004.002.01.008.01.01v.001a.15.15 0 0 1 .01.013l1.31 1.767V9.92c0-.07.056-.128.127-.128h.46c.07 0 .127.058.127.128v2.855c0 .07-.057.128-.128.128h-.46a.12.12 0 0 1-.043-.008l-.003-.001a.102.102 0 0 1-.013-.006l-.011-.007h-.002a.126.126 0 0 1-.032-.032l-1.31-1.77v1.696c0 .07-.057.128-.128.128h-.46a.128.128 0 0 1-.127-.128V9.92c0-.07.057-.128.127-.128l.471.001zm-3.658 0c.07 0 .128.056.128.127v2.268h1.25c.07 0 .127.057.127.128v.46c0 .07-.057.127-.128.127H7.695l-.033-.004a.129.129 0 0 1-.095-.123V9.918c0-.07.057-.128.128-.128h.46zm8.188 0c.07 0 .127.057.127.127v.46c0 .07-.057.127-.127.127h-1.249v.483h1.249c.07 0 .127.057.127.128v.46c0 .07-.057.127-.127.127h-1.249v.483h1.249c.07 0 .127.057.127.128v.46c0 .07-.057.127-.127.127h-1.836l-.034-.004a.128.128 0 0 1-.094-.123V9.918c0-.034.014-.065.035-.088l.002-.002.002-.002a.127.127 0 0 1 .088-.036h1.837z",
    "data-ppui": "true"
  })), props.children);
};

var ShareLinkedinIcon = function ShareLinkedinIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded278);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.667 3a1.318 1.318 0 0 1 1.325 1.163l.008.135V19.7a1.317 1.317 0 0 1-1.198 1.294l-.135.005H4.328a1.315 1.315 0 0 1-1.32-1.165L3 19.701V4.3a1.314 1.314 0 0 1 1.194-1.292L4.328 3h15.339zM8.338 9.748h-2.67v8.59h2.67v-8.59zm6.799-.214a2.806 2.806 0 0 0-2.527 1.388h-.035V9.748h-2.56v8.589h2.666v-4.25c0-1.12.213-2.205 1.602-2.205 1.37 0 1.387 1.282 1.387 2.278v4.177h2.667l.002-4.712c0-2.313-.499-4.09-3.202-4.09zM7.004 5.478a1.548 1.548 0 1 0 .001 3.096 1.548 1.548 0 0 0 0-3.096z",
    "data-ppui": "true"
  })), props.children);
};

var ShareMessengerIcon = function ShareMessengerIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded279);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c5.07 0 9 3.714 9 8.73s-3.93 8.73-9 8.73c-.91 0-1.786-.12-2.606-.346a.718.718 0 0 0-.48.037l-1.785.787a.721.721 0 0 1-1.01-.637l-.05-1.6a.725.725 0 0 0-.242-.513C4.076 16.62 3 14.354 3 11.73 3 6.714 6.93 3 12 3zm5.404 6.718c.255-.402-.241-.856-.62-.568l-2.84 2.155a.54.54 0 0 1-.65.001L11.193 9.73a1.351 1.351 0 0 0-1.952.36l-2.644 4.194c-.255.402.241.857.62.57l2.84-2.156a.54.54 0 0 1 .65-.002l2.102 1.578c.63.472 1.532.306 1.952-.36l2.644-4.195z",
    "data-ppui": "true"
  })), props.children);
};

var ShareSnapchatIcon = function ShareSnapchatIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded280);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.687 17.477c-.87.487-1.45.435-1.9.728-.383.25-.156.787-.434.981-.342.239-1.351-.017-2.656.419-1.075.36-1.761 1.395-3.696 1.395-1.935 0-2.605-1.033-3.698-1.398-1.302-.436-2.314-.18-2.656-.419-.277-.194-.052-.731-.434-.98-.45-.294-1.03-.242-1.9-.726-.555-.31-.24-.502-.055-.592 3.155-1.547 3.658-3.934 3.68-4.111.028-.215.058-.383-.175-.601-.226-.211-1.226-.838-1.504-1.034-.459-.324-.66-.649-.512-1.047.104-.276.358-.38.625-.38.084 0 .168.01.25.029.504.11.994.366 1.276.435a.446.446 0 0 0 .105.014c.15 0 .204-.076.193-.251-.032-.559-.11-1.646-.023-2.663.12-1.399.564-2.092 1.093-2.704C8.52 4.277 9.714 3 11.997 3s3.48 1.272 3.734 1.565c.53.613.975 1.306 1.094 2.705.087 1.016.012 2.105-.024 2.662-.012.184.043.252.194.252a.44.44 0 0 0 .104-.014c.283-.07.773-.325 1.277-.435.082-.019.166-.029.25-.029.268 0 .52.106.625.38.149.398-.052.722-.512 1.047-.277.196-1.278.822-1.503 1.033-.234.218-.203.387-.176.602.022.18.525 2.567 3.681 4.11.186.095.5.286-.054.599z",
    "data-ppui": "true"
  })), props.children);
};

var ShareTwitterIcon = function ShareTwitterIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded281);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66 19.629c6.794 0 10.508-5.628 10.508-10.508 0-.16-.003-.319-.01-.477A7.513 7.513 0 0 0 21 6.732a7.373 7.373 0 0 1-2.12.581 3.706 3.706 0 0 0 1.623-2.043 7.4 7.4 0 0 1-2.345.897 3.694 3.694 0 0 0-6.293 3.368 10.484 10.484 0 0 1-7.612-3.859 3.69 3.69 0 0 0 1.143 4.93 3.666 3.666 0 0 1-1.673-.461v.047a3.695 3.695 0 0 0 2.962 3.62 3.703 3.703 0 0 1-1.667.063 3.697 3.697 0 0 0 3.45 2.565 7.41 7.41 0 0 1-4.587 1.581c-.298 0-.592-.017-.881-.051a10.454 10.454 0 0 0 5.66 1.659z",
    "data-ppui": "true"
  })), props.children);
};

var ShareWechatIcon = function ShareWechatIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded282);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.595 9.985c2.994 0 5.405 2.011 5.405 4.505 0 1.347-.723 2.573-1.869 3.398-.1.06-.16.16-.14.301 0 .04 0 .08.02.12.08.343.24.886.24.906 0 .06.02.1.02.14a.18.18 0 0 1-.18.181c-.04 0-.06-.02-.1-.04l-1.186-.683a.654.654 0 0 0-.281-.08c-.06 0-.12 0-.161.02a6.368 6.368 0 0 1-1.768.24c-2.994 0-5.405-2.01-5.405-4.503 0-2.494 2.41-4.505 5.405-4.505zM9.505 5c3.155 0 5.795 1.862 6.362 4.347l.043.209h-.363c-3.263 0-5.921 2.208-5.921 4.917 0 .37.052.726.144 1.07l.078.255h-.363c-.725 0-1.45-.12-2.115-.301-.06-.02-.12-.02-.18-.02a.652.652 0 0 0-.264.06l-.08.04-1.43.823c-.04.02-.08.04-.12.04-.12 0-.222-.1-.222-.22 0-.06.02-.1.04-.161.02-.02.202-.683.303-1.084 0-.04.02-.1.02-.14a.456.456 0 0 0-.181-.362C3.866 13.49 3 12.025 3 10.4 3 7.409 5.92 5 9.505 5zm7.874 7.294a.732.732 0 0 0-.735.735c0 .408.327.735.735.735a.745.745 0 0 0 .735-.735.732.732 0 0 0-.735-.735zm-3.621 0a.732.732 0 0 0-.735.735c0 .408.327.735.735.735a.745.745 0 0 0 .735-.735.732.732 0 0 0-.735-.735zm-2.152-4.46a.833.833 0 0 0-.84.84c0 .468.372.84.84.84.47 0 .84-.391.84-.84a.833.833 0 0 0-.84-.84zm-4.303 0a.833.833 0 0 0-.84.84c0 .468.372.84.84.84.469 0 .84-.391.84-.84a.833.833 0 0 0-.84-.84z",
    "data-ppui": "true"
  })), props.children);
};

var ShareWhatsappIcon = function ShareWhatsappIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded283);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.06 13.787c-.222-.112-1.318-.651-1.522-.726-.204-.074-.353-.111-.501.112-.149.223-.576.725-.706.874-.13.149-.26.167-.483.056-.223-.112-.941-.347-1.792-1.107-.663-.59-1.11-1.32-1.24-1.543-.13-.223-.014-.344.098-.455.1-.1.223-.26.334-.39.111-.13.149-.224.223-.373.074-.148.037-.278-.019-.39-.055-.111-.501-1.209-.687-1.655-.18-.434-.365-.375-.501-.382a8.936 8.936 0 0 0-.427-.008.819.819 0 0 0-.595.279c-.204.223-.78.762-.78 1.859s.799 2.157.91 2.305c.112.15 1.572 2.4 3.808 3.366.531.23.946.366 1.27.47.534.169 1.02.145 1.404.087.428-.064 1.318-.539 1.504-1.06.186-.52.186-.966.13-1.06-.056-.092-.204-.148-.427-.26zm-4.066 5.552h-.003a7.403 7.403 0 0 1-3.773-1.033l-.27-.161-2.806.736.748-2.736-.176-.28a7.396 7.396 0 0 1-1.133-3.946c.001-4.087 3.327-7.413 7.416-7.413a7.365 7.365 0 0 1 5.242 2.175 7.37 7.37 0 0 1 2.169 5.244c-.002 4.088-3.327 7.414-7.414 7.414zm6.31-13.723A8.861 8.861 0 0 0 11.994 3c-4.916 0-8.917 4.001-8.92 8.919 0 1.572.41 3.106 1.191 4.459L3 21l4.728-1.24a8.912 8.912 0 0 0 4.263 1.085h.003c4.916 0 8.918-4.001 8.92-8.92a8.866 8.866 0 0 0-2.61-6.31z",
    "data-ppui": "true"
  })), props.children);
};

var ShareIcon = function ShareIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded284);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.586 6H13a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V7.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L16.586 6z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H6v9h9v-5a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8z",
    "data-ppui": "true"
  })), props.children);
};

var ShippingLabelIcon = function ShippingLabelIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded285);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v5h1a1 1 0 0 1 1 1v9.998a1 1 0 0 1-1.625.781l-1.916-1.533-1.917 1.533a1 1 0 0 1-1.625-.78V20H5a1 1 0 0 1-1-1V5zm14.459 13.325l-2.042 1.633V11.5H20.5v8.458l-2.041-1.633zM6.25 18.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5h-1.5zm-.75-3.25c0 .414.336.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ShippingPackIcon = function ShippingPackIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded286);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.746a.75.75 0 0 0-1.5 0v3.697l-.972-.971a.75.75 0 1 0-1.06 1.06l2.245 2.245a.76.76 0 0 0 1.075 0l2.245-2.245a.75.75 0 0 0-1.061-1.06l-.972.971V2.746z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.36 10.221a.747.747 0 0 1 .517-.22V10h10.246v.002c.19.001.38.074.524.22l3.138 3.137a.75.75 0 1 1-1.06 1.06L18 12.697V21a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8.297l-1.718 1.718a.75.75 0 0 1-1.06-1.06l3.139-3.14zM8.25 20.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5h-1.5zm-.75-3.25c0 .414.336.75.75.75h3.5a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0-.75.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ShippingSendIcon = function ShippingSendIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded287);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.293 13.04a1 1 0 0 1 1.414 0l1.768 1.767a.75.75 0 0 1-1.06 1.06l-.665-.664v3.289a.75.75 0 0 1-1.5 0v-3.288l-.664.664a.75.75 0 0 1-1.06-1.06l1.767-1.769z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6.528A6 6 0 1 0 20 11.528V5a1 1 0 0 0-1-1H5zm8.936 16c.619.32 1.32.5 2.064.5s1.445-.18 2.064-.5A4.52 4.52 0 0 0 20 18.064c.32-.619.5-1.32.5-2.064s-.18-1.445-.5-2.064A4.5 4.5 0 1 0 13.936 20zm-3.747-5.5H6.25a.75.75 0 0 0 0 1.5H10c0-.518.066-1.02.189-1.5zM5.5 17.75c0 .414.336.75.75.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0-.75.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ShippingIcon = function ShippingIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded288);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1 1-1h3.984a1.5 1.5 0 0 1 1.393.943l.193.48a20 20 0 0 1 1.43 7.43V16a1 1 0 0 1-1 1h-3.55a2.5 2.5 0 0 1-4.9 0H8.423a2.5 2.5 0 0 1-4.9 0H3a1 1 0 0 1-1-1V6zm17.285 3.855l.276.829A1 1 0 0 1 18.613 12H18a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.1a1.25 1.25 0 0 1 1.185.855zM16.25 16.5a1.251 1.251 0 1 1-2.502 0 1.251 1.251 0 0 1 2.502 0zM5.973 17.751a1.251 1.251 0 1 0 0-2.502 1.251 1.251 0 0 0 0 2.502z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ShoesIcon = function ShoesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded289);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.003 6a1 1 0 0 1 1-1h7.996a1 1 0 0 1 1 1v2a4 4 0 0 0 4 4h2.004a4 4 0 0 1 4 4v2a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V6zm18.5 10h-17v1.5h17V16zM3.5 8.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75zm.75 2.25a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ShopIcon = function ShopIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded290);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 7H6.858a1 1 0 0 0-.988.848l-1.693 11A1 1 0 0 0 5.166 20h13.668a1 1 0 0 0 .989-1.152l-1.692-11A1 1 0 0 0 17.142 7H16V6a4 4 0 1 0-8 0v1zm1.5 0h5V6a2.5 2.5 0 0 0-5 0v1z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ShoppingBasketIcon = function ShoppingBasketIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded291);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3a7 7 0 0 0-7 7H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h.273l.644 7.09a1 1 0 0 0 .996.91h12.159a1 1 0 0 0 .997-.926L19.596 13h.403a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H19a7 7 0 0 0-7-7zm0 1.5a5.5 5.5 0 0 1 5.5 5.5h-11A5.5 5.5 0 0 1 12 4.5zm-3.25 9.25v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 1.5 0zm4 4.5v-4.5a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0zm4-4.5v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 1.5 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ShoppingCartIcon = function ShoppingCartIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded292);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 3.25a.75.75 0 0 0 0 1.5h1.706l2.642 9.375a.698.698 0 0 0 .007.024l.598 2.122.02.063A2.5 2.5 0 0 0 8.975 21a2.5 2.5 0 0 0 2-3.999H14.5a2.5 2.5 0 1 0 4.002 0h.376a1 1 0 0 0 .967-.744l2.123-8A1 1 0 0 0 21 7H6.648l-.902-3.203a.75.75 0 0 0-.722-.547H2.75zm15.002 15.249a1.251 1.251 0 1 1-2.503 0 1.251 1.251 0 0 1 2.502 0zm-8.777 1.252a1.251 1.251 0 1 0 0-2.503 1.251 1.251 0 0 0 0 2.502z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SkipIcon = function SkipIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded293);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2zm-3.34 8.753L5.657 19.75c-.646.565-1.658.106-1.658-.753V5.003c0-.859 1.012-1.318 1.658-.753l8.001 6.997a1 1 0 0 1 0 1.506z",
    "data-ppui": "true"
  })), props.children);
};

var SmartphonePhotoIcon = function SmartphonePhotoIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded294);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2a.75.75 0 0 1 0 1.5H3.5v1.75a.75.75 0 0 1-1.5 0V3a1 1 0 0 1 1-1h2.25zM18 2.75c0 .414.336.75.75.75h1.75v1.75a.75.75 0 0 0 1.5 0V3a1 1 0 0 0-1-1h-2.25a.75.75 0 0 0-.75.75zm0 18.5a.75.75 0 0 1 .75-.75h1.75v-1.75a.75.75 0 0 1 1.5 0V21a1 1 0 0 1-1 1h-2.25a.75.75 0 0 1-.75-.75zm-14.5-2.5a.75.75 0 0 0-1.5 0V21a1 1 0 0 0 1 1h2.25a.75.75 0 0 0 0-1.5H3.5v-1.75z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.004 6.004a1 1 0 0 1 1-1h11.992a1 1 0 0 1 1 1v11.992a1 1 0 0 1-1 1H6.005a1 1 0 0 1-1-1V6.005zm8.165 5.674A2.249 2.249 0 0 0 12 7.505a2.25 2.25 0 0 0-1.169 4.173A4.002 4.002 0 0 0 8 15.505v.444c0 .307.249.556.556.556h6.888a.556.556 0 0 0 .556-.556v-.444a4.002 4.002 0 0 0-2.831-3.827z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SnoozeIcon = function SnoozeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded295);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 4a2 2 0 1 0-4 0v.341C7.67 5.165 6 7.388 6 10v6H5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-1v-6a6.002 6.002 0 0 0-4-5.659V4zm.5 11H9.532c-.18 0-.276-.096-.276-.276v-.9a.46.46 0 0 1 .132-.336c.442-.501.927-1.056 1.379-1.573.739-.845 1.39-1.59 1.62-1.835-.011 0-.023-.012-.011-.012-.492.024-.936.024-1.476.024H9.64c-.18 0-.276-.096-.276-.276v-.84c0-.18.096-.276.276-.276h4.68c.18 0 .276.096.276.276v.9c0 .132-.036.24-.144.348a327.532 327.532 0 0 0-2.758 3.133l-.218.251v.012l.192-.004c.458-.01.866-.02 1.404-.02H14.5c.18 0 .276.096.276.276v.852c0 .18-.096.276-.276.276z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22a3 3 0 0 1-2.959-2.5h5.918A3 3 0 0 1 12 22z",
    "data-ppui": "true"
  })), props.children);
};

var SocialJusticeIcon = function SocialJusticeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded296);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.563 4c.708 0 1.349.287 1.813.751A2.554 2.554 0 0 1 10.188 4c.708 0 1.349.287 1.813.751A2.555 2.555 0 0 1 13.813 4c.708 0 1.349.287 1.813.751A2.563 2.563 0 0 1 20 6.562v2.876c0 .723-.3 1.376-.782 1.842a2.657 2.657 0 0 1 .78 1.97H20V15a5.001 5.001 0 0 1-3 4.584V21a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1.416A5.001 5.001 0 0 1 4 15V6.563A2.562 2.562 0 0 1 6.563 4zm1.063 5.438v.02l-.002.041a1.063 1.063 0 0 1-2.122 0v-.008l-.001-.053V6.562a1.063 1.063 0 0 1 2.125 0v2.875zm10.872 3.812l.003-.077v-.008c0-.644-.522-1.166-1.166-1.166h-3.669a1.166 1.166 0 0 0 0 2.332h3.669c.615 0 1.12-.477 1.163-1.081zm-7.031-1.591a2.666 2.666 0 0 0 2.2 4.172h3.668c.399 0 .777-.088 1.117-.245A3.505 3.505 0 0 1 16.4 18.21l-.9.393V20.5h-7v-1.898l-.899-.393A3.501 3.501 0 0 1 5.501 15v-3.23a2.556 2.556 0 0 0 2.875-.521 2.554 2.554 0 0 0 1.812.751c.466 0 .902-.124 1.279-.341zM10.188 5.5c.587 0 1.063.476 1.063 1.063v2.882a1.062 1.062 0 0 1-2.125 0V6.562c0-.587.475-1.063 1.062-1.063zm2.564 4v-.004h.001a1.017 1.017 0 0 1-.001-.059V6.563a1.063 1.063 0 0 1 2.125 0v2.875a1.062 1.062 0 0 1-2.124.062zm3.624-.063a1.063 1.063 0 0 0 2.125 0V6.563a1.063 1.063 0 0 0-2.125 0v2.875z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SpiritualityIcon = function SpiritualityIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded297);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.713 2.293l.288.28.287-.28a1 1 0 0 1 1.41.015l4.653 4.725A4 4 0 0 1 19.5 9.84v4.66l1.543 1.544a1 1 0 0 1 0 1.414l-3.836 3.836a1 1 0 0 1-1.414 0l-3.122-3.122A4 4 0 0 1 12 17.28c-.18.325-.405.625-.672.892l-3.121 3.122a1 1 0 0 1-1.414 0l-3.836-3.836a1 1 0 0 1 0-1.414L4.5 14.5V9.84a4 4 0 0 1 1.15-2.807l4.653-4.725a1 1 0 0 1 1.41-.015zm-5.688 7.2a2.5 2.5 0 0 0-.024.347v5.282l-1.629 1.629 3.129 3.128 2.768-2.767A2.5 2.5 0 0 0 11 15.344V11.5H9.5v2.75a.75.75 0 0 1-1.5 0v-4.239a1.501 1.501 0 0 1 .44-1.072l2.847-2.848a1.5 1.5 0 0 0-.016-2.136l-.211-.206-.037-.035-4.304 4.37a2.5 2.5 0 0 0-.695 1.408zm3.476.508L14 10h.5L12 7.5 9.5 10zm3.44-6.25c.382.81.382 1.756-.002 2.566L16 10.007v4.244a.75.75 0 0 1-1.5 0V11.5H13v3.843a2.499 2.499 0 0 0 .732 1.768l2.768 2.768 3.128-3.13L18 15.121V9.84a2.5 2.5 0 0 0-.719-1.755l-4.305-4.37-.036.035z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SplitBillIcon = function SplitBillIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded298);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.001 3a1 1 0 0 1 1-1h11.997a1 1 0 0 1 1 1v7.886a.778.778 0 0 0-.059.053l-.939.94-1.293-1.293a1 1 0 0 0-1.414 0L14 11.879l-1.293-1.293a1 1 0 0 0-1.414 0L10 11.879l-1.293-1.293a1 1 0 0 0-1.414 0L6 11.879l-.999-.999V3zM7 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5zm-1.999 8.002V21a1 1 0 0 0 1 1h11.997a1 1 0 0 0 1-1v-7.998l-.29.29a1 1 0 0 1-1.415 0L16 12l-1.293 1.293a1 1 0 0 1-1.414 0L12 12l-1.293 1.293a1 1 0 0 1-1.414 0L8 12l-1.293 1.293a1 1 0 0 1-1.414 0L5 13.002zM7 16.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75zm8.75-.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5zM7 19.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75zm8.75-.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SportsIcon = function SportsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded299);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 3.998a1.903 1.903 0 1 1 3.801 0l-.8 16.007A1 1 0 0 1 6.5 22h-2a1 1 0 0 1-.1-1.995L3.6 3.998z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.115 16.181A7 7 0 1 0 9.886 7.818a7 7 0 0 0 11.23 8.363zm-2.041 0a5.476 5.476 0 0 1-2.823 1.268V12.75h1.477a6.964 6.964 0 0 0 1.346 3.431zm-4.323-3.431v4.7a5.477 5.477 0 0 1-2.823-1.269 6.963 6.963 0 0 0 1.346-3.431h1.477zm2.977-1.5h-1.477v-4.7c1.07.147 2.041.6 2.823 1.269a6.963 6.963 0 0 0-1.346 3.431zm-2.977 0v-4.7c-1.07.147-2.041.6-2.823 1.269a6.963 6.963 0 0 1 1.346 3.431h1.477zm4.488 1.5c.114.832.413 1.605.856 2.276.442-.67.742-1.444.855-2.276h-1.71zm1.711-1.5h-1.71a5.468 5.468 0 0 1 .855-2.276c.442.67.742 1.444.855 2.276zm-9.187 0a5.468 5.468 0 0 0-.856-2.276 5.467 5.467 0 0 0-.855 2.276h1.71zm-1.711 1.5c.113.832.413 1.605.855 2.276.443-.67.742-1.444.856-2.276h-1.711z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SubscriptionsIcon = function SubscriptionsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded300);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3v3H6a1 1 0 0 0-1 1v13.997a1 1 0 0 0 1.64.768L10 18.964l3.36 2.801a1 1 0 0 0 1.64-.768v-5.2l2.36 1.968a1 1 0 0 0 1.64-.768V3a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1zm5 3h-3.5V3.5h7v12.43L15 13.844V7a1 1 0 0 0-1-1zm-4 2.748a.75.75 0 0 1 .75.75v1.252H12a.75.75 0 0 1 0 1.5h-1.25v1.252a.75.75 0 0 1-1.5 0V12.25H8a.75.75 0 0 1 0-1.5h1.25V9.498a.75.75 0 0 1 .75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SubtractIcon = function SubtractIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded301);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SurveyIcon = function SurveyIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded302);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.102 4.998a5.022 5.022 0 0 1-.1-.999V2.998a1 1 0 0 1 1-1H16a1 1 0 0 1 1 1v1.001c0 .342-.034.676-.1 1h1.101a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1h1.1zm1.545 0A3.5 3.5 0 0 1 8.502 4v-.501H15.5V4a3.51 3.51 0 0 1-.145 1 3.5 3.5 0 0 1-6.708 0zM7 11.748a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75zm0 3a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75zm10 3a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 .75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var SwitchCardIcon = function SwitchCardIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded303);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.25h14.793l-.664-.664a.75.75 0 0 1 1.06-1.06l1.768 1.767a1 1 0 0 1 0 1.414l-1.77 1.77a.75.75 0 0 1-1.06-1.06l.666-.667H4.75a.75.75 0 1 1 0-1.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H7zm1.495 1.5a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1H9a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1h-.505z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 18.248a.75.75 0 1 1 0 1.5H4.457l.666.666a.75.75 0 1 1-1.06 1.06l-1.77-1.77a1 1 0 0 1 0-1.413l1.768-1.768a.75.75 0 0 1 1.06 1.06l-.664.665H19.25z",
    "data-ppui": "true"
  })), props.children);
};

var TermsIcon = function TermsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded304);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.837 7.176l2.296-2.991A1 1 0 1 1 9.72 5.402l-3 3.908a1 1 0 0 1-1.51.09L3.77 7.92a1 1 0 1 1 1.433-1.395l.634.651zm0 5.279l2.296-2.991A1 1 0 0 1 9.72 10.68l-3 3.909a1 1 0 0 1-1.51.088L3.77 13.2a1 1 0 0 1 1.433-1.395l.634.651zm2.296 2.287A1 1 0 1 1 9.72 15.96l-3 3.908a1 1 0 0 1-1.51.089l-1.44-1.48a1 1 0 0 1 1.433-1.395l.634.652 2.296-2.992zm1.864-7.74a1 1 0 0 1 1-1H19a1 1 0 1 1 0 2h-8.003a1 1 0 0 1-1-1zm1 3.998a1 1 0 1 0 0 2H19a1 1 0 1 0 0-2h-8.003zm0 5a1 1 0 1 0 0 2H19a1 1 0 1 0 0-2h-8.003z",
    "data-ppui": "true"
  })), props.children);
};

var TextSizeIcon = function TextSizeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded305);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.55 7a.3.3 0 0 1-.3-.3V4.3a.3.3 0 0 1 .3-.3H19.7a.3.3 0 0 1 .3.3v2.4a.3.3 0 0 1-.3.3h-3.575v12.752a.3.3 0 0 1-.3.3h-2.4a.3.3 0 0 1-.3-.3V7H9.55zM4.3 12a.3.3 0 0 1-.3-.3V9.8a.3.3 0 0 1 .3-.3h7.4a.3.3 0 0 1 .3.3v1.9a.3.3 0 0 1-.3.3H9.25v7.725a.3.3 0 0 1-.3.3h-1.9a.3.3 0 0 1-.3-.3V12H4.3z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var TipJarIcon = function TipJarIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded306);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V3zm1.5 2.5v-2h7v2h-7zM6 7a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6zm10 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-6-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ToolsIcon = function ToolsIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded307);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.414 12l2.047 2.047.353-.354a1 1 0 0 1 1.414 0l3.538 3.538a1 1 0 0 1 0 1.414l-2.12 2.121a1 1 0 0 1-1.415 0l-3.538-3.537a1 1 0 0 1 0-1.415l.354-.353L12 13.414l-2.422 2.422a3.5 3.5 0 0 1-4.744 4.74l2.725-2.724-1.414-1.414-2.725 2.725a3.5 3.5 0 0 1 4.744-4.742L10.585 12 8.399 9.813a.999.999 0 0 1-.43-.028l-2.315-.67a1 1 0 0 1-.605-.491L2.935 4.655a1 1 0 0 1 .176-1.177l.367-.367a1 1 0 0 1 1.177-.176l3.969 2.113a1 1 0 0 1 .49.605l.67 2.315a1 1 0 0 1 .029.43L12 10.586l2.42-2.421a3.502 3.502 0 0 1 4.745-4.745L16.44 6.146l1.415 1.415 2.726-2.726a3.502 3.502 0 0 1-4.745 4.744L13.414 12zm3.107 3.108l2.83 2.83-1.413 1.414-2.83-2.83 1.413-1.414zM7.732 6.273l.581 2.006-.004.03-.03.004-2.006-.58L4.61 4.61l3.121 1.662z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var TopUpIcon = function TopUpIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded308);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1zm15.708 10.708a1 1 0 0 1-1.414 0L13 10.414V21a1 1 0 1 1-2 0V10.414l-5.294 5.294a1 1 0 0 1-1.414-1.414L11.286 7.3l.003-.003a.997.997 0 0 1 1.421-.001l.004.004 6.994 6.994a1 1 0 0 1 0 1.414z",
    "data-ppui": "true"
  })), props.children);
};

var ToysIcon = function ToysIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded309);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5a1 1 0 0 1 1-1h4c.024 0 .047 0 .07.002a.99.99 0 0 1 1.05.847l1.313 9.182a3 3 0 1 1-1.946.378l-.185-1.293-4.595 4.595a1 1 0 0 1-.707.293l-4.171-.002A3.001 3.001 0 0 1 2 17a3 3 0 0 1 5.83-1h3.346a1 1 0 0 0 .707-.293l4.965-4.965c.032-.033.067-.062.102-.09L16.286 6H13a1 1 0 0 1-1-1zm5.74 11.185a1.5 1.5 0 1 0 2.519 1.63 1.5 1.5 0 0 0-2.518-1.63zM6.5 17A1.496 1.496 0 0 1 5 18.5 1.5 1.5 0 1 1 6.5 17z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var TransferIcon = function TransferIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded310);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.29 11.709a1 1 0 0 1 0-1.414L16.587 8H5a1 1 0 1 1 0-2h11.586L14.29 3.705a1 1 0 0 1 1.414-1.414L19.7 6.286a1.01 1.01 0 0 1 0 1.428l-3.995 3.995a1 1 0 0 1-1.414 0zm-4.585 10a1 1 0 0 0 0-1.414L7.41 18h11.586a1 1 0 1 0 0-2H7.41l2.295-2.295a1 1 0 1 0-1.414-1.414l-3.995 3.995a1.01 1.01 0 0 0 0 1.428l3.995 3.995a1 1 0 0 0 1.414 0z",
    "data-ppui": "true"
  })), props.children);
};

var TravelIcon = function TravelIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded311);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.073 2.68l4.463 6.82H19.5a2.5 2.5 0 0 1 0 5h-3.964l-4.464 6.824a1.5 1.5 0 0 1-1.256.679h-.499a.75.75 0 0 1-.71-.99L10.81 14.5H6.988l-1.414 1.414a2 2 0 0 1-1.414.586H2.502a.5.5 0 0 1-.39-.814L4.676 12.5 2.394 8.236a.5.5 0 0 1 .441-.736H4.16a2 2 0 0 1 1.414.586L6.988 9.5h3.822L8.609 2.99a.75.75 0 0 1 .71-.99h.5a1.5 1.5 0 0 1 1.254.679zM19.301 11a.75.75 0 1 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var TreatYourselfIcon = function TreatYourselfIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded312);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 5a1 1 0 0 1 1 1v2.535a3.5 3.5 0 1 0 0 6.93V18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2.536a3.5 3.5 0 1 0 0-6.93V6.001a1 1 0 0 1 1-1h18zm-9.474 3.38a.5.5 0 0 1 .948 0l.67 2.003 2.113.02a.5.5 0 0 1 .293.901l-1.698 1.257.635 2.015a.5.5 0 0 1-.767.557L12 13.907l-1.72 1.226a.5.5 0 0 1-.767-.557l.635-2.015-1.698-1.257a.5.5 0 0 1 .293-.902l2.112-.018.67-2.003z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var TrophyIcon = function TrophyIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded313);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1 7 7 0 0 1-6.678 6.993c-.842 1.673-1.569 3.426-1.728 5.114 1.937.266 3.482 1.006 4.106 1.954.304.462-.148.939-.7.939H7c-.552 0-1.004-.477-.7-.939.624-.948 2.169-1.688 4.106-1.954-.16-1.688-.886-3.44-1.728-5.114A7 7 0 0 1 2 7a1 1 0 0 1 1-1h3V3zM3.522 7.5H6.04c.112 1.303.452 2.384.926 3.28.195.368.4.747.611 1.134l.25.46A5.504 5.504 0 0 1 3.522 7.5zm12.901 4.414l-.25.46A5.504 5.504 0 0 0 20.478 7.5H17.96c-.112 1.303-.453 2.384-.926 3.28a109 109 0 0 1-.611 1.134z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var TuitionIcon = function TuitionIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded314);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.748 16.752a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-3v4.002h2.998a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H10.502a1 1 0 0 1-1-1v-.247C7.09 17.228 6.278 16 6.065 15.575A.68.68 0 0 1 6 15.267V8H4.75v9l.816 1.962A.75.75 0 0 1 4.873 20H3.127a.75.75 0 0 1-.692-1.038l.815-1.96V8H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h18zm-.502 12.502h-9.5v-4h9.5v4z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var UndoIcon = function UndoIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded315);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71 12.303a1 1 0 0 1-1.415 1.414L3.297 8.719a1.01 1.01 0 0 1 0-1.429l4.998-4.998A1 1 0 1 1 9.71 3.706L6.416 7H13.5a7.5 7.5 0 0 1 0 15H6a1 1 0 1 1 0-2h7.5a5.5 5.5 0 0 0 0-11H6.406l3.303 3.304z",
    "data-ppui": "true"
  })), props.children);
};

var UnlockIcon = function UnlockIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded316);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 8v1H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H7.5V8a4.501 4.501 0 0 1 3.753-4.437c.409-.069.747-.398.747-.812 0-.414-.338-.755-.748-.704A6.001 6.001 0 0 0 6 8.001zm8 6a2 2 0 0 1-1 1.733v2.268a1 1 0 0 1-2 0v-2.268a2 2 0 1 1 3-1.732z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var UnmuteIcon = function UnmuteIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded317);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 4.09c0-.858-1.01-1.318-1.658-.753L7 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4l5.342 4.666c.647.565 1.658.106 1.658-.753V4.09zm3.834 2.076c-.293.293-.29.766-.027 1.087A7.469 7.469 0 0 1 19.5 12a7.469 7.469 0 0 1-1.694 4.748c-.262.32-.265.793.028 1.086.293.293.77.294 1.038-.022A8.964 8.964 0 0 0 21 12c0-2.215-.8-4.244-2.128-5.812-.268-.316-.745-.314-1.038-.022z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.666 9.39c-.24-.337-.246-.81.046-1.102.293-.293.773-.296 1.027.031A5.974 5.974 0 0 1 18 12c0 1.387-.47 2.665-1.261 3.68-.255.328-.734.325-1.027.033-.292-.293-.286-.765-.046-1.103A4.48 4.48 0 0 0 16.5 12a4.48 4.48 0 0 0-.834-2.61z",
    "data-ppui": "true"
  })), props.children);
};

var UploadIcon = function UploadIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded318);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.998 16a1 1 0 1 0 2 0V5.41l2.295 2.295a1 1 0 1 0 1.414-1.414l-3.995-3.995a1.01 1.01 0 0 0-1.428 0L7.288 6.29a1 1 0 1 0 1.415 1.414l2.295-2.295V16z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v6H5v-6a1 1 0 0 0-1-1z",
    "data-ppui": "true"
  })), props.children);
};

var UserProfileIcon = function UserProfileIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded319);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.337 10.347a4.5 4.5 0 1 0-4.673 0A8.004 8.004 0 0 0 4 18v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a8.004 8.004 0 0 0-5.663-7.653z",
    "data-ppui": "true"
  })), props.children);
};

var VacationIcon = function VacationIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded320);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.783 2.553a1.75 1.75 0 0 0-1.566 0l-5 2.5a1.75 1.75 0 0 0-.967 1.565V7c0 .966.784 1.75 1.75 1.75h4.25v11.5a.75.75 0 0 0 1.5 0V8.75H20A1.75 1.75 0 0 0 21.75 7v-.382a1.75 1.75 0 0 0-.967-1.565l-5-2.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v4h-.75a.747.747 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0V17.5h5v2.75a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75h-.75v-4z",
    "data-ppui": "true"
  })), props.children);
};

var VerifiedIcon = function VerifiedIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded321);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.817 3.422a1 1 0 0 0-1.635 0l-.592.841a1 1 0 0 1-1.238.332l-.933-.432a1 1 0 0 0-1.416.817L6.91 6.005a1 1 0 0 1-.905.905l-1.025.093a1 1 0 0 0-.817 1.416l.432.933a1 1 0 0 1-.332 1.238l-.84.592a1 1 0 0 0 0 1.635l.84.593a1 1 0 0 1 .332 1.237l-.432.934a1 1 0 0 0 .817 1.416l1.025.092a1 1 0 0 1 .905.906l.093 1.025a1 1 0 0 0 1.416.817l.933-.432a1 1 0 0 1 1.238.332l.592.84a1 1 0 0 0 1.635 0l.593-.84a1 1 0 0 1 1.237-.332l.934.432a1 1 0 0 0 1.416-.817l.092-1.025a1 1 0 0 1 .906-.906l1.025-.092a1 1 0 0 0 .817-1.416l-.432-.934a1 1 0 0 1 .332-1.237l.84-.593a1 1 0 0 0 0-1.635l-.84-.592a1 1 0 0 1-.332-1.238l.432-.933a1 1 0 0 0-.817-1.416l-1.025-.093a1 1 0 0 1-.906-.905l-.092-1.025a1 1 0 0 0-1.416-.817l-.934.432a1 1 0 0 1-1.237-.332l-.593-.84zm1.652 5.285l-3.437 4.48-1.493-1.532A.75.75 0 1 0 8.464 12.7l1.896 1.947a1 1 0 0 0 1.51-.089l3.79-4.938a.75.75 0 1 0-1.19-.914z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var VideoGamesIcon = function VideoGamesIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded322);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 7a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.5a3.5 3.5 0 1 1-7 0V16H9v.5a3.5 3.5 0 1 1-7 0V7zm18 5.495a1.251 1.251 0 1 1-2.502 0 1.251 1.251 0 0 1 2.502 0zm-3.749-1.246a1.251 1.251 0 1 0 0-2.502 1.251 1.251 0 0 0 0 2.502zm-12.628-.002a.75.75 0 0 1 .75-.75h1.625V8.872a.75.75 0 1 1 1.5 0v1.625h1.625a.75.75 0 1 1 0 1.5H7.498v1.625a.75.75 0 0 1-1.5 0v-1.625H4.373a.75.75 0 0 1-.75-.75z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ViewIcon = function ViewIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded323);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 20c6 0 10-6 10-8s-4-8-10-8-10 6.031-10 8c0 1.969 4 8 10 8zm5-8a5 5 0 1 1-10 0 5 5 0 0 1 10 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var WalletIcon = function WalletIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded324);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4zM5 7a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H5zm-2 5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8z",
    "data-ppui": "true"
  })), props.children);
};

var WandIcon = function WandIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded325);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8 5.8L9 8l-.8-2.2L6 5l2.2-.8L9 2l.8 2.2L12 5l-2.2.8z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.471 6.68a1 1 0 0 0-.95.262L3.294 17.17a1 1 0 0 0 0 1.414l2.124 2.124a1 1 0 0 0 1.414 0l7.057-7.057.01-.01 3.16-3.16a1 1 0 0 0 0-1.414l-2.123-2.123a.995.995 0 0 0-.465-.264zm-2.696 4.13l2.454-2.453 1.416 1.416-2.453 2.453-1.417-1.416z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8l.8-2.2L22 5l-2.2-.8L19 2l-.8 2.2L16 5l2.2.8L19 8zm.8 7.8L19 18l-.8-2.2L16 15l2.2-.8.8-2.2.8 2.2 2.2.8-2.2.8z",
    "data-ppui": "true"
  })), props.children);
};

var WarningSmIcon = function WarningSmIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded326);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 9.001a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm-7.414.982h.827c.136 0 .224-.08.233-.219.015-.355.035-.704.054-1.06.045-.811.092-1.658.092-2.686v-.785c0-.15-.077-.229-.223-.229H8.43c-.145 0-.223.08-.223.229v.785c0 1.028.047 1.875.092 2.686.02.356.039.705.054 1.06.01.14.097.219.233.219zM9 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var WarningIcon = function WarningIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded327);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 12.001a9 9 0 1 1-18 0 9 9 0 0 1 18 0zm-9.511 1.514h1.02c.168 0 .276-.096.288-.264.018-.428.042-.85.067-1.28.055-.98.113-2.002.113-3.244v-.948c0-.18-.096-.276-.276-.276h-1.404c-.18 0-.276.096-.276.276v.948c0 1.242.058 2.264.113 3.243.025.43.049.852.067 1.281.012.168.12.264.288.264zM12 17.001a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var WebsiteIcon = function WebsiteIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded328);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5.001v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zm1.5.5v3.5h17v-3.5h-17zm11.491 8.344l-5.616-2.553a.441.441 0 0 0-.584.584l2.553 5.616a.44.44 0 0 0 .796.015l.643-1.287 1.272 1.272a.441.441 0 0 0 .624 0l.312-.312a.441.441 0 0 0 0-.623l-1.272-1.272 1.287-.644a.441.441 0 0 0-.015-.796z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var WellnessIcon = function WellnessIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded329);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.048 7.437C12.288 6.87 13.287 5 16.348 5c3.76 0 5.79 3.94 3.98 8-1.63 3.69-6.33 7-8.33 7-1.999 0-6.69-3.32-8.33-7-1.81-4.06.22-8 3.98-8 3.061 0 4.06 1.87 4.302 2.437.018.043.08.043.098 0zm2.729 2.701l-3.86 5.03-1.742-1.79A.75.75 0 1 0 8.1 14.425l2.146 2.203a1 1 0 0 0 1.51-.088l4.21-5.488a.75.75 0 0 0-1.19-.914z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var WildlifeIcon = function WildlifeIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded330);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.207 13a.5.5 0 0 0-.354.854l1.793 1.792a.5.5 0 0 0 .707 0l1.793-1.792a.5.5 0 0 0-.353-.854h-3.586z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.74 9.457A3.005 3.005 0 0 0 20 7.007 3.003 3.003 0 0 0 17 4c-1.4 0-2.575.96-2.907 2.26A8.513 8.513 0 0 0 12 6a8.47 8.47 0 0 0-2.093.26A3.002 3.002 0 0 0 7 4C5.343 4 4 5.346 4 7.007c0 1.01.498 1.905 1.26 2.45A7.13 7.13 0 0 0 4 13.5c0 3.465 2.506 6.381 5.912 7.242.431.125.878.212 1.338.258v-.032a8.645 8.645 0 0 0 1.5 0V21c.46-.046.907-.133 1.338-.258C17.494 19.881 20 16.965 20 13.5a7.13 7.13 0 0 0-1.26-4.043zM16 15a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var WithdrawCashIcon = function WithdrawCashIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded331);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 21v-2h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H9V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zm-5.5-.5h4V19H5V9h2.5V7.5h-4v13zM12 11a3 3 0 1 1 0 6 3 3 0 0 1 0-6z",
    clipRule: "evenodd",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.953 4.293a1 1 0 0 1 0 1.414l-1.767 1.768a.75.75 0 0 1-1.06-1.06l.663-.665h-6.288a.75.75 0 0 1 0-1.5h6.288l-.664-.664a.75.75 0 1 1 1.06-1.06l1.768 1.767z",
    "data-ppui": "true"
  })), props.children);
};

var WorkingCapitalIcon = function WorkingCapitalIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded332);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 9c0 .996-.243 1.935-.672 2.761a3.001 3.001 0 0 1 3.793.422l.587.605a1 1 0 0 1-.016 1.409l-4.724 4.653A4 4 0 0 1 14.16 20H9.5l-1.543 1.543a1 1 0 0 1-1.414 0l-3.836-3.836a1 1 0 0 1 0-1.414l3.121-3.121a3.998 3.998 0 0 1 1.193-.822A6 6 0 1 1 18 9zm-5.5 4.5V15H9.75a.75.75 0 0 0 0 1.5h4.238a1.496 1.496 0 0 0 1.072-.44l2.848-2.847a1.494 1.494 0 0 1 1.35-.411c.29.056.566.199.787.426l.24.249-4.37 4.304a2.5 2.5 0 0 1-1.754.719H8.879l-1.63 1.629L4.122 17l2.768-2.768a2.5 2.5 0 0 1 1.768-.732H12.5zm-1.25-6.002h1.191L9.5 10.44a.75.75 0 0 0 1.06 1.061l2.94-2.94v1.19a.75.75 0 0 0 1.5 0V6.998a1 1 0 0 0-1-1h-2.75a.75.75 0 0 0 0 1.5z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ZoomInIcon = function ZoomInIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded333);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7a1 1 0 0 1 1 1v1.5H13a1 1 0 1 1 0 2h-1.5V13a1 1 0 1 1-2 0v-1.5H8a1 1 0 1 1 0-2h1.5V8a1 1 0 0 1 1-1z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 18c1.71 0 3.287-.573 4.55-1.537l3.243 3.244a1 1 0 0 0 1.414-1.414l-3.244-3.244A7.5 7.5 0 1 0 10.5 18zm0-2a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var ZoomOutIcon = function ZoomOutIcon(props) {
  var svgElementRef = props.svgElementRef,
      rest = _objectWithoutProperties(props, _excluded334);

  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11.5a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2h5z",
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 18c1.71 0 3.287-.573 4.55-1.537l3.243 3.244a1 1 0 0 0 1.414-1.414l-3.244-3.244A7.5 7.5 0 1 0 10.5 18zm0-2a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z",
    clipRule: "evenodd",
    "data-ppui": "true"
  })), props.children);
};

var _excluded$2 = ["name", "as", "size", "className", "children", "color", "cdnHost"];

var Icon = function Icon(_ref) {
  var _iconStyles$getIconSi, _iconStyles$getMaskIm;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'acorns' : _ref$name,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      cdnHost = _ref.cdnHost,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var tokens = useTheme();
  var iconStyles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);
  var cssVal = [iconStyles.base, iconStyles.backgroundBase, // @ts-ignore
  (_iconStyles$getIconSi = iconStyles.getIconSizeCss) === null || _iconStyles$getIconSi === void 0 ? void 0 : _iconStyles$getIconSi.call(iconStyles, size), (_iconStyles$getMaskIm = iconStyles.getMaskImageCss) === null || _iconStyles$getMaskIm === void 0 ? void 0 : _iconStyles$getMaskIm.call(iconStyles, color, name, cdnHost)];
  return jsx(as, _extends({
    css: cssVal,
    className: className
  }, rest, {
    "data-ppui": "true"
  }));
};

export { AcornsIcon, ActivityIcon, AddCameraIcon, AddCashIcon, AddIcon, AddUserIcon, AddVideoIcon, AlarmClockIcon, AnimalsIcon, AppMenuIcon, AppliancesIcon, ArrowDownIcon, ArrowDownSmIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon, ArrowUpSmIcon, ArtIcon, AttachIcon, AutoIcon, AutopayIcon, AutopayNoIcon, BabyProductsIcon, BankDepositIcon, BankIcon, BankInfoIcon, BeautyIcon, BigPurchaseIcon, BillPaymentIcon, BirthdayIcon, BitcoinCashIcon, BitcoinIcon, BlockIcon, BooksIcon, BoxIcon, BusinessIcon, ButtonIcon, CalculatorIcon, CalendarIcon, CalendarPausedIcon, CalendarSmIcon, CameraIcon, CardStackIcon, CashBackIcon, CashIcon, CashPickupIcon, CausesIcon, CenterAlignIcon, ChangePlanIcon, CharitiesIcon, ChatIcon, CheckCaptureIcon, CheckIcon, CheckmarkBackgroundIcon, CheckmarkBackgroundSmIcon, CheckmarkIcon, CheckmarkSmIcon, ChevronDownIcon, ChevronDownSmIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronUpSmIcon, ChildrenIcon, ClockIcon, ClockSmIcon, CloseIcon, CloseSmIcon, ClothingIcon, CloudStorageIcon, CodeIcon, CommunityIcon, ConnectionIcon, ContactUsIcon, ContactsIcon, CopyToClipboardIcon, CreditCardIcon, CreditMastercardIcon, CriticalIcon, CriticalSmIcon, CrowdfundIcon, CryptoIcon, CultureIcon, CurrencyChfIcon, CurrencyDollarIcon, CurrencyEuroIcon, CurrencyPoundIcon, CurrencyRupeeIcon, CurrencyYenIcon, CustomersIcon, DailyDealIcon, DashboardIcon, DayIcon, DealsIcon, DeclineIcon, DeleteIcon, DesktopIcon, DetailedListIcon, DirectDepositIcon, DisasterIcon, DisasterReliefIcon, DislikeIcon, DislikeSelectedIcon, DisputesIcon, DocumentIcon, DonateIcon, DownloadIcon, EditIcon, EducationIcon, ElectricityIcon, EmailIcon, EmojiIcon, EnvironmentIcon, EthereumIcon, FaceIdIcon, FamilySupportIcon, FaqIcon, FavoriteIcon, FavoriteSelectedIcon, FilterIcon, FingerprintIcon, FlagIcon, FlashIcon, FlashOffIcon, FlowersIcon, FoodIcon, FundraiserIcon, FurnitureIcon, GasPumpIcon, GeneralSupportIcon, GetDirectionsIcon, GiftCardIcon, GoalsIcon, GoldIcon, GourmetFoodIcon, GrantsIcon, HandbagsIcon, HealthIcon, HelpIcon, HideIcon, HomeIcon, HomeownerIcon, HoneyIcon, HourglassIcon, HouseholdIcon, HouseholdSuppliesIcon, HumanIcon, HumanServicesIcon, HungerIcon, Icon, IconContainer, InFlightIcon, IndustrialIcon, InformationIcon, InformationSmIcon, InsightsIcon, InstallmentsIcon, InsuranceIcon, InsuredIcon, InternationalIcon, InternetIcon, InvestIcon, InvoiceIcon, JewelryIcon, JusticeIcon, LaptopIcon, LawnIcon, LeftAlignIcon, LetterCheckmarkIcon, LightBulbIcon, LikeIcon, LikeSelectedIcon, LinkIcon, ListSimpleIcon, LitecoinIcon, LoansIcon, LocationIcon, LockIcon, LogoutIcon, LoyaltyCardIcon, LuggageIcon, MedicalIcon, MembershipsIcon, MemorialsIcon, MenuIcon, MerchantIcon, MessageCenterIcon, MessageIcon, MgmIcon, MicrophoneIcon, MilitaryIcon, MoveIcon, MovieIcon, MusicIcon, MusicalInstrumentsIcon, MuteIcon, NavigateIcon, NightIcon, NoIconIcon, NotificationIcon, NotificationPreferencesIcon, NumberPadIcon, NumberedListIcon, OccasionIcon, OffersIcon, OfficeSuppliesIcon, OfflineIcon, OnlineIcon, OnlineShoppingIcon, OpenBrowserIcon, OrderAheadIcon, OthersIcon, OverflowIcon, PackageSizeIcon, PartySuppliesIcon, PasskeyIcon, PasswordInputIcon, PauseIcon, PayLaterIcon, PayMonthlyIcon, PayoutsIcon, PaypalAppIcon, PaypalAssistantIcon, PaypalBalanceIcon, PendingPausedIcon, PersonalInfoIcon, PersonalSavingsIcon, PetSuppliesIcon, Phone2Icon, PhoneIcon, PhotoIdIcon, PictureBrokenIcon, PictureIcon, PinIcon, PixIcon, PlayIcon, PledgeIcon, PreferredIcon, PreferredSelectedIcon, PreviewIcon, PrintIcon, PropertyMgmtIcon, PurchaseProtectionIcon, QrcIcon, QuestionIcon, QuestionSmIcon, RainyDayIcon, RecurrentIcon, RecurringPausedIcon, RefreshIcon, RefundIcon, RegistrationDocIcon, ReloadPhonesIcon, RentIcon, ReportProblemIcon, RequestMoneyIcon, ResolutionIcon, RetirementIcon, ReturnRightIcon, RewardsIcon, RightAlignIcon, SafariIcon, SavingsIcon, ScanBarcodeIcon, ScanIcon, ScienceIcon, SearchIcon, SearchSmIcon, SecurityIcon, SendMoneyIcon, SendToBankIcon, ServicesIcon, SettingsIcon, SewingIcon, ShareAndroidIcon, ShareFacebookIcon, ShareIcon, ShareInstagramIcon, ShareIosIcon, ShareLineIcon, ShareLinkedinIcon, ShareMessengerIcon, ShareSnapchatIcon, ShareTwitterIcon, ShareWechatIcon, ShareWhatsappIcon, ShippingIcon, ShippingLabelIcon, ShippingPackIcon, ShippingSendIcon, ShoesIcon, ShopIcon, ShoppingBasketIcon, ShoppingCartIcon, SkipIcon, SmartphonePhotoIcon, SnoozeIcon, SocialJusticeIcon, SpiritualityIcon, SplitBillIcon, SportsIcon, SubscriptionsIcon, SubtractIcon, SurveyIcon, SwitchCardIcon, TermsIcon, TextSizeIcon, TipJarIcon, ToolsIcon, TopUpIcon, ToysIcon, TransferIcon, TravelIcon, TreatYourselfIcon, TrophyIcon, TuitionIcon, UndoIcon, UnlockIcon, UnmuteIcon, UploadIcon, UserProfileIcon, VacationIcon, VerifiedIcon, VideoGamesIcon, ViewIcon, WalletIcon, WandIcon, WarningIcon, WarningSmIcon, WebsiteIcon, WellnessIcon, WildlifeIcon, WithdrawCashIcon, WorkingCapitalIcon, ZoomInIcon, ZoomOutIcon, styles as iconStyles };